(() => {
/**
 * Swiper 10.3.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 28, 2023
 */ /**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $768c2f4c151a0363$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $768c2f4c151a0363$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($768c2f4c151a0363$var$isObject(src[key]) && $768c2f4c151a0363$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $768c2f4c151a0363$var$extend(target[key], src[key]);
    });
}
const $768c2f4c151a0363$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $768c2f4c151a0363$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $768c2f4c151a0363$var$extend(doc, $768c2f4c151a0363$var$ssrDocument);
    return doc;
}
const $768c2f4c151a0363$var$ssrWindow = {
    document: $768c2f4c151a0363$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $768c2f4c151a0363$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $768c2f4c151a0363$var$extend(win, $768c2f4c151a0363$var$ssrWindow);
    return win;
}



function $3e0e2b092da8f124$export$43caf9889c228507(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $3e0e2b092da8f124$export$4368d992c4eafac0() {
    return Date.now();
}
function $3e0e2b092da8f124$var$getComputedStyle(el) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $3e0e2b092da8f124$export$dda1d9f60106f0e9(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $3e0e2b092da8f124$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $3e0e2b092da8f124$export$35e795649ee09318(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $3e0e2b092da8f124$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $3e0e2b092da8f124$export$9e5f44173e64f162() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$3e0e2b092da8f124$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($3e0e2b092da8f124$export$35e795649ee09318(to[nextKey]) && $3e0e2b092da8f124$export$35e795649ee09318(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $3e0e2b092da8f124$export$9e5f44173e64f162(to[nextKey], nextSource[nextKey]);
                    } else if (!$3e0e2b092da8f124$export$35e795649ee09318(to[nextKey]) && $3e0e2b092da8f124$export$35e795649ee09318(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $3e0e2b092da8f124$export$9e5f44173e64f162(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $3e0e2b092da8f124$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $3e0e2b092da8f124$export$ffb5f4729a158638(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $3e0e2b092da8f124$export$342063e11d6c3cad(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $3e0e2b092da8f124$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    return [
        ...element.children
    ].filter((el)=>el.matches(selector));
}
function $3e0e2b092da8f124$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : [
        classes
    ]);
    return el;
}
function $3e0e2b092da8f124$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $3e0e2b092da8f124$export$ae1af26003f05816(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $3e0e2b092da8f124$export$953cecd6e717a553(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $3e0e2b092da8f124$export$882b5998b3b9117c(el, prop) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $3e0e2b092da8f124$export$39b482c5e57630a8(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $3e0e2b092da8f124$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $3e0e2b092da8f124$export$23f2a1d2818174ef(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $3e0e2b092da8f124$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}


let $6946bfb4689eabba$var$support;
function $6946bfb4689eabba$var$calcSupport() {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $6946bfb4689eabba$var$getSupport() {
    if (!$6946bfb4689eabba$var$support) $6946bfb4689eabba$var$support = $6946bfb4689eabba$var$calcSupport();
    return $6946bfb4689eabba$var$support;
}
let $6946bfb4689eabba$var$deviceCached;
function $6946bfb4689eabba$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $6946bfb4689eabba$var$getSupport();
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $6946bfb4689eabba$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$6946bfb4689eabba$var$deviceCached) $6946bfb4689eabba$var$deviceCached = $6946bfb4689eabba$var$calcDevice(overrides);
    return $6946bfb4689eabba$var$deviceCached;
}
let $6946bfb4689eabba$var$browser;
function $6946bfb4689eabba$var$calcBrowser() {
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    return {
        isSafari: needPerspectiveFix || isSafari(),
        needPerspectiveFix: needPerspectiveFix,
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent)
    };
}
function $6946bfb4689eabba$var$getBrowser() {
    if (!$6946bfb4689eabba$var$browser) $6946bfb4689eabba$var$browser = $6946bfb4689eabba$var$calcBrowser();
    return $6946bfb4689eabba$var$browser;
}
function $6946bfb4689eabba$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $6946bfb4689eabba$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $3e0e2b092da8f124$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $6946bfb4689eabba$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $6946bfb4689eabba$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, "padding-left") || 0, 10) - parseInt((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, "padding-top") || 0, 10) - parseInt((0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $6946bfb4689eabba$var$updateSlides() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slides[i] && (0, $3e0e2b092da8f124$export$882b5998b3b9117c)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $3e0e2b092da8f124$export$2d1720544b23b823)(slide, "width", true) : (0, $3e0e2b092da8f124$export$2d1720544b23b823)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $6946bfb4689eabba$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $6946bfb4689eabba$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
function $6946bfb4689eabba$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $6946bfb4689eabba$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
function $6946bfb4689eabba$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const getFilteredSlide = (selector)=>{
        return (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    let activeSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        // Next Slide
        let nextSlide = (0, $3e0e2b092da8f124$export$953cecd6e717a553)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !nextSlide) nextSlide = slides[0];
        if (nextSlide) nextSlide.classList.add(params.slideNextClass);
        // Prev Slide
        let prevSlide = (0, $3e0e2b092da8f124$export$ae1af26003f05816)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        params.loop;
        if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
    }
    swiper.emitSlidesClasses();
}
const $6946bfb4689eabba$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $6946bfb4689eabba$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $6946bfb4689eabba$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $6946bfb4689eabba$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $6946bfb4689eabba$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $6946bfb4689eabba$var$unlazy(swiper, i);
    }
};
function $6946bfb4689eabba$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $6946bfb4689eabba$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $6946bfb4689eabba$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (swiper.slides[activeIndex]) realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
    else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $6946bfb4689eabba$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function $6946bfb4689eabba$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $6946bfb4689eabba$var$update = {
    updateSize: $6946bfb4689eabba$var$updateSize,
    updateSlides: $6946bfb4689eabba$var$updateSlides,
    updateAutoHeight: $6946bfb4689eabba$var$updateAutoHeight,
    updateSlidesOffset: $6946bfb4689eabba$var$updateSlidesOffset,
    updateSlidesProgress: $6946bfb4689eabba$var$updateSlidesProgress,
    updateProgress: $6946bfb4689eabba$var$updateProgress,
    updateSlidesClasses: $6946bfb4689eabba$var$updateSlidesClasses,
    updateActiveIndex: $6946bfb4689eabba$var$updateActiveIndex,
    updateClickedSlide: $6946bfb4689eabba$var$updateClickedSlide
};
function $6946bfb4689eabba$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $6946bfb4689eabba$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $6946bfb4689eabba$var$minTranslate() {
    return -this.snapGrid[0];
}
function $6946bfb4689eabba$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $6946bfb4689eabba$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $3e0e2b092da8f124$export$ffb5f4729a158638)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $6946bfb4689eabba$var$translate = {
    getTranslate: $6946bfb4689eabba$var$getSwiperTranslate,
    setTranslate: $6946bfb4689eabba$var$setTranslate,
    minTranslate: $6946bfb4689eabba$var$minTranslate,
    maxTranslate: $6946bfb4689eabba$var$maxTranslate,
    translateTo: $6946bfb4689eabba$var$translateTo
};
function $6946bfb4689eabba$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $6946bfb4689eabba$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $6946bfb4689eabba$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $6946bfb4689eabba$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $6946bfb4689eabba$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $6946bfb4689eabba$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $6946bfb4689eabba$var$transition = {
    setTransition: $6946bfb4689eabba$var$setTransition,
    transitionStart: $6946bfb4689eabba$var$transitionStart,
    transitionEnd: $6946bfb4689eabba$var$transitionEnd
};
function $6946bfb4689eabba$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $3e0e2b092da8f124$export$ffb5f4729a158638)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $6946bfb4689eabba$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else newIndex = swiper.getSlideIndexByData(newIndex);
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $6946bfb4689eabba$var$slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $6946bfb4689eabba$var$slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled) return swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $6946bfb4689eabba$var$slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $6946bfb4689eabba$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $6946bfb4689eabba$var$slideToClickedSlide() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $6946bfb4689eabba$var$slide = {
    slideTo: $6946bfb4689eabba$var$slideTo,
    slideToLoop: $6946bfb4689eabba$var$slideToLoop,
    slideNext: $6946bfb4689eabba$var$slideNext,
    slidePrev: $6946bfb4689eabba$var$slidePrev,
    slideReset: $6946bfb4689eabba$var$slideReset,
    slideToClosest: $6946bfb4689eabba$var$slideToClosest,
    slideToClickedSlide: $6946bfb4689eabba$var$slideToClickedSlide
};
function $6946bfb4689eabba$var$loopCreate(slideRealIndex) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index)=>{
        el.setAttribute("data-swiper-slide-index", index);
    });
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $6946bfb4689eabba$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
    let loopedSlides = params.loopedSlides || slidesPerView;
    if (loopedSlides % params.slidesPerGroup !== 0) loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
    swiper.loopedSlides = loopedSlides;
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    // prepend last slides before start
    if (activeSlideIndex < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeSlideIndex; i += 1){
            const index = i - Math.floor(i / slides.length) * slides.length;
            prependSlidesIndexes.push(slides.length - index - 1);
        }
    } else if (activeSlideIndex /* + slidesPerView */  > swiper.slides.length - loopedSlides * 2) {
        slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / slides.length) * slides.length;
            appendSlidesIndexes.push(index);
        }
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (setTranslate) {
                        swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                        swiper.touchEventsData.currentTranslate = swiper.translate;
                    }
                }
            } else if (setTranslate) {
                swiper.slideToLoop(slideRealIndex, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                        swiper.touchEventsData.currentTranslate = swiper.translate;
                    }
                }
            } else swiper.slideToLoop(slideRealIndex, 0, false, true);
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function $6946bfb4689eabba$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $6946bfb4689eabba$var$loop = {
    loopCreate: $6946bfb4689eabba$var$loopCreate,
    loopFix: $6946bfb4689eabba$var$loopFix,
    loopDestroy: $6946bfb4689eabba$var$loopDestroy
};
function $6946bfb4689eabba$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $6946bfb4689eabba$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $6946bfb4689eabba$var$grabCursor = {
    setGrabCursor: $6946bfb4689eabba$var$setGrabCursor,
    unsetGrabCursor: $6946bfb4689eabba$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $6946bfb4689eabba$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $768c2f4c151a0363$export$39b482c5e57630a8)() || el === (0, $768c2f4c151a0363$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $6946bfb4689eabba$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const data = swiper.touchEventsData;
    data.evCache.push(event);
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $6946bfb4689eabba$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $6946bfb4689eabba$var$onTouchMove(event) {
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pointerIndex = data.evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
    const targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                prevX: swiper.touches.currentX,
                prevY: swiper.touches.currentY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.swipeDirection === "next" && swiper.allowSlideNext || swiper.swipeDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        // need another loop fix
        swiper.loopFix({
            direction: swiper.swipeDirection,
            setTranslate: true
        });
        loopFixed = true;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $6946bfb4689eabba$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const pointerIndex = data.evCache.findIndex((cachedEv)=>cachedEv.pointerId === event.pointerId);
    if (pointerIndex >= 0) data.evCache.splice(pointerIndex, 1);
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(event.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(event.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
    (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $6946bfb4689eabba$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $6946bfb4689eabba$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $6946bfb4689eabba$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $6946bfb4689eabba$var$onLoad(e) {
    const swiper = this;
    $6946bfb4689eabba$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
let $6946bfb4689eabba$var$dummyEventAttached = false;
function $6946bfb4689eabba$var$dummyEventListener() {}
const $6946bfb4689eabba$var$events = (swiper, method)=>{
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    // Touch Events
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $6946bfb4689eabba$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $6946bfb4689eabba$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $6946bfb4689eabba$var$attachEvents() {
    const swiper = this;
    const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const { params: params } = swiper;
    swiper.onTouchStart = $6946bfb4689eabba$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $6946bfb4689eabba$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $6946bfb4689eabba$var$onTouchEnd.bind(swiper);
    if (params.cssMode) swiper.onScroll = $6946bfb4689eabba$var$onScroll.bind(swiper);
    swiper.onClick = $6946bfb4689eabba$var$onClick.bind(swiper);
    swiper.onLoad = $6946bfb4689eabba$var$onLoad.bind(swiper);
    if (!$6946bfb4689eabba$var$dummyEventAttached) {
        document1.addEventListener("touchstart", $6946bfb4689eabba$var$dummyEventListener);
        $6946bfb4689eabba$var$dummyEventAttached = true;
    }
    $6946bfb4689eabba$var$events(swiper, "on");
}
function $6946bfb4689eabba$var$detachEvents() {
    const swiper = this;
    $6946bfb4689eabba$var$events(swiper, "off");
}
var $6946bfb4689eabba$var$events$1 = {
    attachEvents: $6946bfb4689eabba$var$attachEvents,
    detachEvents: $6946bfb4689eabba$var$detachEvents
};
const $6946bfb4689eabba$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $6946bfb4689eabba$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $6946bfb4689eabba$var$isGridEnabled(swiper, params);
    const isMultiRow = $6946bfb4689eabba$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $3e0e2b092da8f124$export$9e5f44173e64f162)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $6946bfb4689eabba$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $6946bfb4689eabba$var$breakpoints = {
    setBreakpoint: $6946bfb4689eabba$var$setBreakpoint,
    getBreakpoint: $6946bfb4689eabba$var$getBreakpoint
};
function $6946bfb4689eabba$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $6946bfb4689eabba$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $6946bfb4689eabba$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $6946bfb4689eabba$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $6946bfb4689eabba$var$classes = {
    addClasses: $6946bfb4689eabba$var$addClasses,
    removeClasses: $6946bfb4689eabba$var$removeClasses
};
function $6946bfb4689eabba$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $6946bfb4689eabba$var$checkOverflow$1 = {
    checkOverflow: $6946bfb4689eabba$var$checkOverflow
};
var $6946bfb4689eabba$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopedSlides: null,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $6946bfb4689eabba$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $3e0e2b092da8f124$export$9e5f44173e64f162)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $3e0e2b092da8f124$export$9e5f44173e64f162)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $3e0e2b092da8f124$export$9e5f44173e64f162)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $6946bfb4689eabba$var$prototypes = {
    eventsEmitter: $6946bfb4689eabba$var$eventsEmitter,
    update: $6946bfb4689eabba$var$update,
    translate: $6946bfb4689eabba$var$translate,
    transition: $6946bfb4689eabba$var$transition,
    slide: $6946bfb4689eabba$var$slide,
    loop: $6946bfb4689eabba$var$loop,
    grabCursor: $6946bfb4689eabba$var$grabCursor,
    events: $6946bfb4689eabba$var$events$1,
    breakpoints: $6946bfb4689eabba$var$breakpoints,
    checkOverflow: $6946bfb4689eabba$var$checkOverflow$1,
    classes: $6946bfb4689eabba$var$classes
};
const $6946bfb4689eabba$var$extendedDefaults = {};
class $6946bfb4689eabba$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)({}, params, {
                    el: containerEl
                });
                swipers.push(new $6946bfb4689eabba$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $6946bfb4689eabba$var$getSupport();
        swiper.device = $6946bfb4689eabba$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $6946bfb4689eabba$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $6946bfb4689eabba$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)({}, $6946bfb4689eabba$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)({}, swiperParams, $6946bfb4689eabba$var$extendedDefaults, params);
        swiper.originalParams = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)({}, swiper.params);
        swiper.passedParams = (0, $3e0e2b092da8f124$export$9e5f44173e64f162)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                evCache: []
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $3e0e2b092da8f124$export$39b482c5e57630a8)(slides[0]);
        return (0, $3e0e2b092da8f124$export$39b482c5e57630a8)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $3e0e2b092da8f124$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $6946bfb4689eabba$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === "SWIPER-CONTAINER") swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $3e0e2b092da8f124$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $3e0e2b092da8f124$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $3e0e2b092da8f124$export$882b5998b3b9117c)(el, "direction") === "rtl"),
            wrongRTL: (0, $3e0e2b092da8f124$export$882b5998b3b9117c)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $6946bfb4689eabba$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $6946bfb4689eabba$var$processLazyPreloader(swiper, e.target);
            });
        });
        $6946bfb4689eabba$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $6946bfb4689eabba$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            el.removeAttribute("style");
            wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.el.swiper = null;
            (0, $3e0e2b092da8f124$export$43caf9889c228507)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $3e0e2b092da8f124$export$9e5f44173e64f162)($6946bfb4689eabba$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $6946bfb4689eabba$var$extendedDefaults;
    }
    static get defaults() {
        return $6946bfb4689eabba$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__) $6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $6946bfb4689eabba$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$6946bfb4689eabba$export$25ce5a424b770e84.installModule(m));
            return $6946bfb4689eabba$export$25ce5a424b770e84;
        }
        $6946bfb4689eabba$export$25ce5a424b770e84.installModule(module);
        return $6946bfb4689eabba$export$25ce5a424b770e84;
    }
}
Object.keys($6946bfb4689eabba$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($6946bfb4689eabba$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $6946bfb4689eabba$export$25ce5a424b770e84.prototype[protoMethod] = $6946bfb4689eabba$var$prototypes[prototypeGroup][protoMethod];
    });
});
$6946bfb4689eabba$export$25ce5a424b770e84.use([
    $6946bfb4689eabba$var$Resize,
    $6946bfb4689eabba$var$Observer
]);






function $46fa7b324a069045$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("swiper-slide");
        else slideEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $3e0e2b092da8f124$export$2408f22a0fab9ae5)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $398e6017151607ad$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const window = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $3e0e2b092da8f124$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $3e0e2b092da8f124$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $343d866400a2e3c2$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $3e0e2b092da8f124$export$4368d992c4eafac0)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $3e0e2b092da8f124$export$4368d992c4eafac0)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $3e0e2b092da8f124$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $3e0e2b092da8f124$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $d6f86baea06bd282$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}


function $ad56a2ca63fb5863$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $d6f86baea06bd282$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $452edee79264d178$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}




function $4b9f6507912f3e92$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $452edee79264d178$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $3e0e2b092da8f124$export$39b482c5e57630a8)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const realIndex = swiper.realIndex;
            const newSlideIndex = swiper.getSlideIndexByData(index);
            const currentSlideIndex = swiper.getSlideIndexByData(swiper.realIndex);
            const loopFix = (dir)=>{
                const indexBeforeLoopFix = swiper.activeIndex;
                swiper.loopFix({
                    direction: dir,
                    activeSlideIndex: newSlideIndex,
                    slideTo: false
                });
                const indexAfterFix = swiper.activeIndex;
                if (indexBeforeLoopFix === indexAfterFix) swiper.slideToLoop(realIndex, 0, false, true);
            };
            if (newSlideIndex > swiper.slides.length - swiper.loopedSlides) loopFix(newSlideIndex > currentSlideIndex ? "next" : "prev");
            else if (swiper.params.centeredSlides) {
                const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (newSlideIndex < Math.floor(slidesPerView / 2)) loopFix("prev");
            }
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $3e0e2b092da8f124$export$2d1720544b23b823)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $3e0e2b092da8f124$export$39b482c5e57630a8)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $452edee79264d178$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $452edee79264d178$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $452edee79264d178$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $452edee79264d178$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $d6f86baea06bd282$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter((subEl)=>{
                if ((0, $3e0e2b092da8f124$export$407448d2b89b1813)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = makeElementsArray(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}





function $86d9ada396b8d520$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $d6f86baea06bd282$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = document.querySelectorAll(params.el);
        else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector(`.${swiper.params.scrollbar.dragClass}`);
            if (!dragEl) {
                dragEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $9a5a5dc98a39a784$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $3e0e2b092da8f124$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $902ac29743f68e69$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth;
            image.height = gesture.imageEl.offsetHeight;
            image.startX = (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $3e0e2b092da8f124$export$dda1d9f60106f0e9)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        zoom.scale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        currentScale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $3e0e2b092da8f124$export$8b22cf2602fb60ce)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth;
            imageHeight = gesture.imageEl.offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $3e0e2b092da8f124$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $8ad27336c27f2357$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $3e0e2b092da8f124$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $3e0e2b092da8f124$export$23f2a1d2818174ef)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElement = document.querySelector(swiper.params.controller.control);
            if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
            else if (controlElement) {
                const onControllerSwiper = (e)=>{
                    swiper.controller.control = e.detail[0];
                    swiper.update();
                    controlElement.removeEventListener("init", onControllerSwiper);
                };
                controlElement.addEventListener("init", onControllerSwiper);
            }
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $f036f37c54b3aa6f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $452edee79264d178$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && targetEl.matches((0, $452edee79264d178$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $3e0e2b092da8f124$export$39b482c5e57630a8)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $452edee79264d178$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.removeEventListener("focus", handleFocus, true);
        swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
        swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $0ce99a47f98448f9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $749dc992af967f35$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
    const window = (0, $768c2f4c151a0363$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-hash") === hash)[0];
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $3e0e2b092da8f124$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $41ae6f5a5ccdab5c$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime;
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl)=>slideEl.classList.contains("swiper-slide-active"))[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            autoplayStartTime = new Date().getTime();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $1664cd01e0f13904$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $3e0e2b092da8f124$export$35e795649ee09318)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $3e0e2b092da8f124$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $768c2f4c151a0363$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener("init", onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $661f7d385acf36a7$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $3e0e2b092da8f124$export$4368d992c4eafac0)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $3e0e2b092da8f124$export$4368d992c4eafac0)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $3e0e2b092da8f124$export$4368d992c4eafac0)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $3e0e2b092da8f124$export$23f2a1d2818174ef)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $3e0e2b092da8f124$export$23f2a1d2818174ef)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $3e0e2b092da8f124$export$23f2a1d2818174ef)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $3767883c93014eb9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style[getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $e8eb9c2e5c926b2c$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $e8eb9c2e5c926b2c$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $e8eb9c2e5c926b2c$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $e8eb9c2e5c926b2c$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $e8eb9c2e5c926b2c$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $e8eb9c2e5c926b2c$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $e8eb9c2e5c926b2c$var$appendSlide.bind(swiper),
        prependSlide: $e8eb9c2e5c926b2c$var$prependSlide.bind(swiper),
        addSlide: $e8eb9c2e5c926b2c$var$addSlide.bind(swiper),
        removeSlide: $e8eb9c2e5c926b2c$var$removeSlide.bind(swiper),
        removeAllSlides: $e8eb9c2e5c926b2c$var$removeAllSlides.bind(swiper)
    });
}


function $ce39167a9c5549e3$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $1edc75782959477e$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $3e0e2b092da8f124$export$342063e11d6c3cad)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $3ea27eb365069d23$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.filter((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $3e0e2b092da8f124$export$23f2a1d2818174ef)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $ed89a1cd6005d986$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $75984ef6f5fe27b6$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $4dfb92d69cb8a433$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, $3e0e2b092da8f124$export$342063e11d6c3cad)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, $3e0e2b092da8f124$export$db3b6bfb95261072)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $7a3c30fafac582ff$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $8b7378894c192c44$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $9406c03f7fbaac7d$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $ccd0a7134d1e48e4$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $4dfb92d69cb8a433$export$db3b6bfb95261072)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $1edc75782959477e$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $3e0e2b092da8f124$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3ea27eb365069d23$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $ce39167a9c5549e3$export$f1e1789686576879)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $465ea4fae4599252$export$2e2bcd8739ae039() {
    document.querySelectorAll(".swiper").forEach($465ea4fae4599252$var$startSlider);
}
function $465ea4fae4599252$var$startSlider(sliderEl) {
    if (sliderEl.swiper) return;
    const { swiperConfig: swiperConfig } = sliderEl.dataset ?? {};
    new (0, $6946bfb4689eabba$export$25ce5a424b770e84)(sliderEl, {
        modules: [
            (0, $ad56a2ca63fb5863$export$2e2bcd8739ae039),
            (0, $41ae6f5a5ccdab5c$export$2e2bcd8739ae039),
            (0, $3767883c93014eb9$export$2e2bcd8739ae039)
        ],
        navigation: {
            enabled: true,
            prevEl: sliderEl.querySelector(".swiper-prev"),
            nextEl: sliderEl.querySelector(".swiper-next")
        },
        ...$465ea4fae4599252$var$getSwiperConfig(swiperConfig, sliderEl)
    });
}
function $465ea4fae4599252$var$getSwiperConfig(swiperConfig, sliderEl) {
    const slidesLength = sliderEl.querySelectorAll(".swiper-slide").length;
    switch(swiperConfig){
        case "discover":
            return {
                slidesPerView: 1,
                spaceBetween: 32,
                breakpoints: {
                    768: {
                        slidesPerView: 2
                    },
                    1024: {
                        slidesPerView: 3
                    }
                },
                navigation: {
                    enabled: true,
                    prevEl: sliderEl.parentElement.querySelector(".swiper-prev"),
                    nextEl: sliderEl.parentElement.querySelector(".swiper-next")
                }
            };
        case "brands":
            return {
                slidesPerView: 2,
                spaceBetween: 32,
                loop: slidesLength >= 4,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        loop: slidesLength >= 6
                    },
                    1024: {
                        slidesPerView: 5,
                        loop: slidesLength >= 10
                    }
                },
                navigation: {
                    enabled: true,
                    prevEl: sliderEl.parentElement.querySelector(".swiper-prev"),
                    nextEl: sliderEl.parentElement.querySelector(".swiper-next")
                }
            };
        case "marketing":
            return {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: slidesLength >= 4,
                loopAddBlankSlides: true,
                speed: 500,
                autoplay: {
                    disableOnInteraction: false
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 32
                    }
                }
            };
        default:
            return {};
    }
}


function $71f7029a2b886464$export$2e2bcd8739ae039() {
    document.querySelectorAll(".anim-label").forEach($71f7029a2b886464$var$startAnimLabel);
}
function $71f7029a2b886464$var$startAnimLabel(inputGroup) {
    if (inputGroup.classList.contains("anim-label--started")) return;
    inputGroup.classList.add("anim-label--started");
    const input = inputGroup.querySelector("input, textarea");
    const label = inputGroup.querySelector("label");
    if (input && label) input.addEventListener("input", ()=>{
        if (input.value) label.classList.add("active");
        else label.classList.remove("active");
    });
}
function $71f7029a2b886464$export$fa6cf3b4dcaf1b1c() {
    document.querySelectorAll(":where(form, input, textarea):not(.novalidate)").forEach((el)=>{
        el.removeAttribute("novalidate");
    });
}


function $bc9f108a1f5a5010$export$2e2bcd8739ae039() {
    const header = document.querySelector("header.sfi-header");
    if (header) window.addEventListener("scroll", ()=>{
        if (window.scrollY > 0) header.classList.add("scrolled");
        else header.classList.remove("scrolled");
    });
}


function $861618b1eb57e58a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $861618b1eb57e58a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $861618b1eb57e58a$export$4922bee768729a77 = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, $861618b1eb57e58a$var$_defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, $861618b1eb57e58a$var$_suppressOverwrites, $861618b1eb57e58a$var$_reverting, $861618b1eb57e58a$var$_context, $861618b1eb57e58a$var$_bigNum = 1e8, $861618b1eb57e58a$var$_tinyNum = 1 / $861618b1eb57e58a$var$_bigNum, $861618b1eb57e58a$var$_2PI = Math.PI * 2, $861618b1eb57e58a$var$_HALF_PI = $861618b1eb57e58a$var$_2PI / 4, $861618b1eb57e58a$var$_gsID = 0, $861618b1eb57e58a$var$_sqrt = Math.sqrt, $861618b1eb57e58a$var$_cos = Math.cos, $861618b1eb57e58a$var$_sin = Math.sin, $861618b1eb57e58a$export$f664476fd67145ca = function _isString(value) {
    return typeof value === "string";
}, $861618b1eb57e58a$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $861618b1eb57e58a$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $861618b1eb57e58a$export$a8178c063a9fd3a1 = function _isUndefined(value) {
    return typeof value === "undefined";
}, $861618b1eb57e58a$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $861618b1eb57e58a$var$_isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, $861618b1eb57e58a$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $861618b1eb57e58a$var$_isFuncOrString = function _isFuncOrString(value) {
    return $861618b1eb57e58a$var$_isFunction(value) || $861618b1eb57e58a$export$f664476fd67145ca(value);
}, $861618b1eb57e58a$var$_isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
$861618b1eb57e58a$var$_isArray = Array.isArray, $861618b1eb57e58a$var$_strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
$861618b1eb57e58a$export$b9d44bb6523120d6 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$861618b1eb57e58a$export$65c88bbd597e7b0a = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, $861618b1eb57e58a$var$_complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
$861618b1eb57e58a$export$5a680e28b0b61bc = /[+-]=-?[.\d]+/, $861618b1eb57e58a$var$_delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
$861618b1eb57e58a$var$_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, $861618b1eb57e58a$var$_globalTimeline, $861618b1eb57e58a$var$_win, $861618b1eb57e58a$var$_coreInitted, $861618b1eb57e58a$var$_doc, $861618b1eb57e58a$var$_globals = {}, $861618b1eb57e58a$var$_installScope = {}, $861618b1eb57e58a$var$_coreReady, $861618b1eb57e58a$var$_install = function _install(scope) {
    return ($861618b1eb57e58a$var$_installScope = $861618b1eb57e58a$var$_merge(scope, $861618b1eb57e58a$var$_globals)) && $861618b1eb57e58a$export$99ee26438460406a;
}, $861618b1eb57e58a$export$7fb54635790b59a5 = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, $861618b1eb57e58a$var$_warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, $861618b1eb57e58a$var$_addGlobal = function _addGlobal(name, obj) {
    return name && ($861618b1eb57e58a$var$_globals[name] = obj) && $861618b1eb57e58a$var$_installScope && ($861618b1eb57e58a$var$_installScope[name] = obj) || $861618b1eb57e58a$var$_globals;
}, $861618b1eb57e58a$var$_emptyFunc = function _emptyFunc() {
    return 0;
}, $861618b1eb57e58a$var$_startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, $861618b1eb57e58a$var$_revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, $861618b1eb57e58a$var$_revertConfig = {
    suppressEvents: true
}, $861618b1eb57e58a$var$_reservedProps = {}, $861618b1eb57e58a$var$_lazyTweens = [], $861618b1eb57e58a$var$_lazyLookup = {}, $861618b1eb57e58a$var$_lastRenderedFrame, $861618b1eb57e58a$export$d305d8ec5d7c26b8 = {}, $861618b1eb57e58a$var$_effects = {}, $861618b1eb57e58a$var$_nextGCFrame = 30, $861618b1eb57e58a$var$_harnessPlugins = [], $861618b1eb57e58a$var$_callbackNames = "", $861618b1eb57e58a$var$_harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    $861618b1eb57e58a$var$_isObject(target) || $861618b1eb57e58a$var$_isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = $861618b1eb57e58a$var$_harnessPlugins.length;
        while(i-- && !$861618b1eb57e58a$var$_harnessPlugins[i].targetTest(target));
        harnessPlugin = $861618b1eb57e58a$var$_harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new $861618b1eb57e58a$export$cf10981d5419cad5(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, $861618b1eb57e58a$export$8b9be379d2de2a39 = function _getCache(target) {
    return target._gsap || $861618b1eb57e58a$var$_harness($861618b1eb57e58a$export$45b10814cc054894(target))[0]._gsap;
}, $861618b1eb57e58a$export$51d6bbe898aef1f9 = function _getProperty(target, property, v) {
    return (v = target[property]) && $861618b1eb57e58a$var$_isFunction(v) ? target[property]() : $861618b1eb57e58a$export$a8178c063a9fd3a1(v) && target.getAttribute && target.getAttribute(property) || v;
}, $861618b1eb57e58a$export$f9000b814859f126 = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
$861618b1eb57e58a$export$9c8d725d65e13f94 = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $861618b1eb57e58a$var$_roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
$861618b1eb57e58a$export$dac762bc6301b560 = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, $861618b1eb57e58a$var$_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, $861618b1eb57e58a$var$_lazyRender = function _lazyRender() {
    var l = $861618b1eb57e58a$var$_lazyTweens.length, a = $861618b1eb57e58a$var$_lazyTweens.slice(0), i, tween;
    $861618b1eb57e58a$var$_lazyLookup = {};
    $861618b1eb57e58a$var$_lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, $861618b1eb57e58a$var$_lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    $861618b1eb57e58a$var$_lazyTweens.length && !$861618b1eb57e58a$var$_reverting && $861618b1eb57e58a$var$_lazyRender();
    animation.render(time, suppressEvents, force || $861618b1eb57e58a$var$_reverting && time < 0 && (animation._initted || animation._startAt));
    $861618b1eb57e58a$var$_lazyTweens.length && !$861618b1eb57e58a$var$_reverting && $861618b1eb57e58a$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, $861618b1eb57e58a$var$_numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match($861618b1eb57e58a$var$_delimitedValueExp).length < 2 ? n : $861618b1eb57e58a$export$f664476fd67145ca(value) ? value.trim() : value;
}, $861618b1eb57e58a$var$_passThrough = function _passThrough(p) {
    return p;
}, $861618b1eb57e58a$export$dc2b19673bb53610 = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $861618b1eb57e58a$var$_setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, $861618b1eb57e58a$var$_merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, $861618b1eb57e58a$var$_mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = $861618b1eb57e58a$var$_isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, $861618b1eb57e58a$var$_copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, $861618b1eb57e58a$var$_inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || $861618b1eb57e58a$var$_globalTimeline, func = vars.keyframes ? $861618b1eb57e58a$var$_setKeyframeDefaults($861618b1eb57e58a$var$_isArray(vars.keyframes)) : $861618b1eb57e58a$export$dc2b19673bb53610;
    if ($861618b1eb57e58a$var$_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, $861618b1eb57e58a$var$_arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, $861618b1eb57e58a$var$_addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, $861618b1eb57e58a$export$cd008aa6cd8844e3 = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, $861618b1eb57e58a$var$_removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, $861618b1eb57e58a$var$_uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, $861618b1eb57e58a$var$_recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, $861618b1eb57e58a$var$_rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && ($861618b1eb57e58a$var$_reverting ? tween._startAt.revert($861618b1eb57e58a$var$_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, $861618b1eb57e58a$var$_hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, $861618b1eb57e58a$var$_elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? $861618b1eb57e58a$var$_animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
$861618b1eb57e58a$var$_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, $861618b1eb57e58a$var$_parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, $861618b1eb57e58a$var$_setEnd = function _setEnd(animation) {
    return animation._end = $861618b1eb57e58a$var$_roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || $861618b1eb57e58a$var$_tinyNum) || 0));
}, $861618b1eb57e58a$var$_alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = $861618b1eb57e58a$var$_roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        $861618b1eb57e58a$var$_setEnd(animation);
        parent._dirty || $861618b1eb57e58a$var$_uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ $861618b1eb57e58a$var$_postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = $861618b1eb57e58a$var$_parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || $861618b1eb57e58a$var$_clamp(0, child.totalDuration(), t) - child._tTime > $861618b1eb57e58a$var$_tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if ($861618b1eb57e58a$var$_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -$861618b1eb57e58a$var$_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, $861618b1eb57e58a$var$_addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && $861618b1eb57e58a$var$_removeFromParent(child);
    child._start = $861618b1eb57e58a$var$_roundPrecise(($861618b1eb57e58a$var$_isNumber(position) ? position : position || timeline !== $861618b1eb57e58a$var$_globalTimeline ? $861618b1eb57e58a$var$_parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = $861618b1eb57e58a$var$_roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    $861618b1eb57e58a$var$_addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    $861618b1eb57e58a$var$_isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || $861618b1eb57e58a$var$_postAddChecks(timeline, child);
    timeline._ts < 0 && $861618b1eb57e58a$var$_alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, $861618b1eb57e58a$var$_scrollTrigger = function _scrollTrigger(animation, trigger) {
    return ($861618b1eb57e58a$var$_globals.ScrollTrigger || $861618b1eb57e58a$export$7fb54635790b59a5("scrollTrigger", trigger)) && $861618b1eb57e58a$var$_globals.ScrollTrigger.create(trigger, animation);
}, $861618b1eb57e58a$var$_attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    $861618b1eb57e58a$var$_initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !$861618b1eb57e58a$var$_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && $861618b1eb57e58a$var$_lastRenderedFrame !== $861618b1eb57e58a$export$762ed8fbedb691e3.frame) {
        $861618b1eb57e58a$var$_lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, $861618b1eb57e58a$var$_parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
$861618b1eb57e58a$var$_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, $861618b1eb57e58a$var$_renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && $861618b1eb57e58a$var$_parentPlayheadIsBeforeStart(tween) && !(!tween._initted && $861618b1eb57e58a$var$_isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !$861618b1eb57e58a$var$_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = $861618b1eb57e58a$var$_clamp(0, tween._tDur, totalTime);
        iteration = $861618b1eb57e58a$var$_animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== $861618b1eb57e58a$var$_animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || $861618b1eb57e58a$var$_reverting || force || tween._zTime === $861618b1eb57e58a$var$_tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && $861618b1eb57e58a$var$_attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? $861618b1eb57e58a$var$_tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && $861618b1eb57e58a$var$_rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && $861618b1eb57e58a$var$_callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && $861618b1eb57e58a$var$_callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && $861618b1eb57e58a$var$_removeFromParent(tween, 1);
            if (!suppressEvents && !$861618b1eb57e58a$var$_reverting) {
                $861618b1eb57e58a$var$_callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, $861618b1eb57e58a$var$_findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, $861618b1eb57e58a$var$_setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = $861618b1eb57e58a$var$_roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : $861618b1eb57e58a$var$_roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && $861618b1eb57e58a$var$_alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && $861618b1eb57e58a$var$_setEnd(animation);
    skipUncache || $861618b1eb57e58a$var$_uncache(animation.parent, animation);
    return animation;
}, $861618b1eb57e58a$var$_onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof $861618b1eb57e58a$export$e6a97ba2cae5bb94 ? $861618b1eb57e58a$var$_uncache(animation) : $861618b1eb57e58a$var$_setDuration(animation, animation._dur);
}, $861618b1eb57e58a$var$_zeroPosition = {
    _start: 0,
    endTime: $861618b1eb57e58a$var$_emptyFunc,
    totalDuration: $861618b1eb57e58a$var$_emptyFunc
}, $861618b1eb57e58a$var$_parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || $861618b1eb57e58a$var$_zeroPosition, clippedDuration = animation.duration() >= $861618b1eb57e58a$var$_bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if ($861618b1eb57e58a$export$f664476fd67145ca(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * ($861618b1eb57e58a$var$_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, $861618b1eb57e58a$var$_createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = $861618b1eb57e58a$var$_isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = $861618b1eb57e58a$var$_isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = $861618b1eb57e58a$var$_isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new $861618b1eb57e58a$export$208a41d6b4e37b97(params[0], vars, params[varsIndex + 1]);
}, $861618b1eb57e58a$var$_conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, $861618b1eb57e58a$var$_clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, $861618b1eb57e58a$export$65f2564e9a9b9222 = function getUnit(value, v) {
    return !$861618b1eb57e58a$export$f664476fd67145ca(value) || !(v = $861618b1eb57e58a$var$_unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
$861618b1eb57e58a$export$7d15b64cf5a3a4c4 = function clamp(min, max, value) {
    return $861618b1eb57e58a$var$_conditionalReturn(value, function(v) {
        return $861618b1eb57e58a$var$_clamp(min, max, v);
    });
}, $861618b1eb57e58a$var$_slice = [].slice, $861618b1eb57e58a$var$_isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && $861618b1eb57e58a$var$_isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && $861618b1eb57e58a$var$_isObject(value[0])) && !value.nodeType && value !== $861618b1eb57e58a$var$_win;
}, $861618b1eb57e58a$var$_flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return $861618b1eb57e58a$export$f664476fd67145ca(value) && !leaveStrings || $861618b1eb57e58a$var$_isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, $861618b1eb57e58a$export$45b10814cc054894(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
$861618b1eb57e58a$export$45b10814cc054894 = function toArray(value, scope, leaveStrings) {
    return $861618b1eb57e58a$var$_context && !scope && $861618b1eb57e58a$var$_context.selector ? $861618b1eb57e58a$var$_context.selector(value) : $861618b1eb57e58a$export$f664476fd67145ca(value) && !leaveStrings && ($861618b1eb57e58a$var$_coreInitted || !$861618b1eb57e58a$var$_wake()) ? $861618b1eb57e58a$var$_slice.call((scope || $861618b1eb57e58a$var$_doc).querySelectorAll(value), 0) : $861618b1eb57e58a$var$_isArray(value) ? $861618b1eb57e58a$var$_flatten(value, leaveStrings) : $861618b1eb57e58a$var$_isArrayLike(value) ? $861618b1eb57e58a$var$_slice.call(value, 0) : value ? [
        value
    ] : [];
}, $861618b1eb57e58a$export$aea217a45095ce11 = function selector(value) {
    value = $861618b1eb57e58a$export$45b10814cc054894(value)[0] || $861618b1eb57e58a$var$_warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return $861618b1eb57e58a$export$45b10814cc054894(v, el.querySelectorAll ? el : el === value ? $861618b1eb57e58a$var$_warn("Invalid scope") || $861618b1eb57e58a$var$_doc.createElement("div") : value);
    };
}, $861618b1eb57e58a$export$448332262467e042 = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
$861618b1eb57e58a$export$f02a9ddbe4480f19 = function distribute(v) {
    if ($861618b1eb57e58a$var$_isFunction(v)) return v;
    var vars = $861618b1eb57e58a$var$_isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = $861618b1eb57e58a$var$_parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if ($861618b1eb57e58a$export$f664476fd67145ca(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                $861618b1eb57e58a$var$_bigNum
            ])[1];
            if (!wrapAt) {
                max = -$861618b1eb57e58a$var$_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === $861618b1eb57e58a$var$_bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = $861618b1eb57e58a$var$_bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? $861618b1eb57e58a$var$_sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && $861618b1eb57e58a$export$448332262467e042(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = $861618b1eb57e58a$export$65f2564e9a9b9222(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? $861618b1eb57e58a$var$_invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return $861618b1eb57e58a$var$_roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, $861618b1eb57e58a$export$dd12390e6b265a17 = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = $861618b1eb57e58a$var$_roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + ($861618b1eb57e58a$var$_isNumber(raw) ? 0 : $861618b1eb57e58a$export$65f2564e9a9b9222(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, $861618b1eb57e58a$export$51a0620f7a28532b = function snap(snapTo, value) {
    var isArray = $861618b1eb57e58a$var$_isArray(snapTo), radius, is2D;
    if (!isArray && $861618b1eb57e58a$var$_isObject(snapTo)) {
        radius = isArray = snapTo.radius || $861618b1eb57e58a$var$_bigNum;
        if (snapTo.values) {
            snapTo = $861618b1eb57e58a$export$45b10814cc054894(snapTo.values);
            if (is2D = !$861618b1eb57e58a$var$_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = $861618b1eb57e58a$export$dd12390e6b265a17(snapTo.increment);
    }
    return $861618b1eb57e58a$var$_conditionalReturn(value, !isArray ? $861618b1eb57e58a$export$dd12390e6b265a17(snapTo) : $861618b1eb57e58a$var$_isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = $861618b1eb57e58a$var$_bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || $861618b1eb57e58a$var$_isNumber(raw) ? closest : closest + $861618b1eb57e58a$export$65f2564e9a9b9222(raw);
    });
}, $861618b1eb57e58a$export$4385e60b38654f68 = function random(min, max, roundingIncrement, returnFunction) {
    return $861618b1eb57e58a$var$_conditionalReturn($861618b1eb57e58a$var$_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return $861618b1eb57e58a$var$_isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, $861618b1eb57e58a$export$a4627e546088548d = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, $861618b1eb57e58a$export$d7502930aa5492de = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || $861618b1eb57e58a$export$65f2564e9a9b9222(value));
    };
}, $861618b1eb57e58a$export$a3295358bff77e = function normalize(min, max, value) {
    return $861618b1eb57e58a$export$f65a7599bbc6b121(min, max, 0, 1, value);
}, $861618b1eb57e58a$var$_wrapArray = function _wrapArray(a, wrapper, value) {
    return $861618b1eb57e58a$var$_conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, $861618b1eb57e58a$export$4997ffc0176396a6 = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return $861618b1eb57e58a$var$_isArray(min) ? $861618b1eb57e58a$var$_wrapArray(min, wrap(0, min.length), max) : $861618b1eb57e58a$var$_conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, $861618b1eb57e58a$export$cfc0b067273edc55 = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return $861618b1eb57e58a$var$_isArray(min) ? $861618b1eb57e58a$var$_wrapArray(min, wrapYoyo(0, min.length - 1), max) : $861618b1eb57e58a$var$_conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, $861618b1eb57e58a$export$d5962a97e3cde94d = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? $861618b1eb57e58a$var$_delimitedValueExp : $861618b1eb57e58a$var$_strictNumExp);
        s += value.substr(prev, i - prev) + $861618b1eb57e58a$export$4385e60b38654f68(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, $861618b1eb57e58a$export$f65a7599bbc6b121 = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return $861618b1eb57e58a$var$_conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, $861618b1eb57e58a$export$89e29e4ab65e70a9 = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = $861618b1eb57e58a$export$f664476fd67145ca(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if ($861618b1eb57e58a$var$_isArray(start) && !$861618b1eb57e58a$var$_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = $861618b1eb57e58a$var$_merge($861618b1eb57e58a$var$_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)$861618b1eb57e58a$var$_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return $861618b1eb57e58a$var$_renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return $861618b1eb57e58a$var$_conditionalReturn(progress, func);
}, $861618b1eb57e58a$var$_getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = $861618b1eb57e58a$var$_bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, $861618b1eb57e58a$var$_callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = $861618b1eb57e58a$var$_context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && $861618b1eb57e58a$var$_lazyTweens.length && $861618b1eb57e58a$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && ($861618b1eb57e58a$var$_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    $861618b1eb57e58a$var$_context = prevContext;
    return result;
}, $861618b1eb57e58a$var$_interrupt = function _interrupt(animation) {
    $861618b1eb57e58a$var$_removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!$861618b1eb57e58a$var$_reverting);
    animation.progress() < 1 && $861618b1eb57e58a$var$_callback(animation, "onInterrupt");
    return animation;
}, $861618b1eb57e58a$var$_quickTween, $861618b1eb57e58a$var$_registerPluginQueue = [], $861618b1eb57e58a$var$_createPlugin = function _createPlugin(config) {
    if ($861618b1eb57e58a$var$_windowExists() && config) {
        // edge case: some build tools may pass in a null/undefined value
        config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
        var name = config.name, isFunc = $861618b1eb57e58a$var$_isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: $861618b1eb57e58a$var$_emptyFunc,
            render: $861618b1eb57e58a$var$_renderPropTweens,
            add: $861618b1eb57e58a$var$_addPropTween,
            kill: $861618b1eb57e58a$var$_killPropTweensOf,
            modifier: $861618b1eb57e58a$var$_addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: $861618b1eb57e58a$export$d60fbc1e0278aaf0,
            aliases: {},
            register: 0
        };
        $861618b1eb57e58a$var$_wake();
        if (config !== Plugin) {
            if ($861618b1eb57e58a$export$d305d8ec5d7c26b8[name]) return;
            $861618b1eb57e58a$export$dc2b19673bb53610(Plugin, $861618b1eb57e58a$export$dc2b19673bb53610($861618b1eb57e58a$var$_copyExcluding(config, instanceDefaults), statics)); //static methods
            $861618b1eb57e58a$var$_merge(Plugin.prototype, $861618b1eb57e58a$var$_merge(instanceDefaults, $861618b1eb57e58a$var$_copyExcluding(config, statics))); //instance methods
            $861618b1eb57e58a$export$d305d8ec5d7c26b8[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                $861618b1eb57e58a$var$_harnessPlugins.push(Plugin);
                $861618b1eb57e58a$var$_reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        $861618b1eb57e58a$var$_addGlobal(name, Plugin);
        config.register && config.register($861618b1eb57e58a$export$99ee26438460406a, Plugin, $861618b1eb57e58a$export$3a67f7f44b1e838a);
    } else config && $861618b1eb57e58a$var$_registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ $861618b1eb57e58a$var$_255 = 255, $861618b1eb57e58a$var$_colorLookup = {
    aqua: [
        0,
        $861618b1eb57e58a$var$_255,
        $861618b1eb57e58a$var$_255
    ],
    lime: [
        0,
        $861618b1eb57e58a$var$_255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        $861618b1eb57e58a$var$_255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        $861618b1eb57e58a$var$_255,
        $861618b1eb57e58a$var$_255,
        $861618b1eb57e58a$var$_255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        $861618b1eb57e58a$var$_255,
        $861618b1eb57e58a$var$_255,
        0
    ],
    orange: [
        $861618b1eb57e58a$var$_255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        $861618b1eb57e58a$var$_255,
        0,
        0
    ],
    pink: [
        $861618b1eb57e58a$var$_255,
        192,
        203
    ],
    cyan: [
        0,
        $861618b1eb57e58a$var$_255,
        $861618b1eb57e58a$var$_255
    ],
    transparent: [
        $861618b1eb57e58a$var$_255,
        $861618b1eb57e58a$var$_255,
        $861618b1eb57e58a$var$_255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
$861618b1eb57e58a$var$_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * $861618b1eb57e58a$var$_255 + .5 | 0;
}, $861618b1eb57e58a$export$73d6f35be992df24 = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? $861618b1eb57e58a$var$_colorLookup.black : $861618b1eb57e58a$var$_isNumber(v) ? [
        v >> 16,
        v >> 8 & $861618b1eb57e58a$var$_255,
        v & $861618b1eb57e58a$var$_255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if ($861618b1eb57e58a$var$_colorLookup[v]) a = $861618b1eb57e58a$var$_colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & $861618b1eb57e58a$var$_255,
                    a & $861618b1eb57e58a$var$_255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & $861618b1eb57e58a$var$_255,
                v & $861618b1eb57e58a$var$_255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match($861618b1eb57e58a$var$_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = $861618b1eb57e58a$var$_hue(h + 1 / 3, r, g);
                a[1] = $861618b1eb57e58a$var$_hue(h, r, g);
                a[2] = $861618b1eb57e58a$var$_hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match($861618b1eb57e58a$export$b9d44bb6523120d6);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match($861618b1eb57e58a$var$_strictNumExp) || $861618b1eb57e58a$var$_colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / $861618b1eb57e58a$var$_255;
        g = a[1] / $861618b1eb57e58a$var$_255;
        b = a[2] / $861618b1eb57e58a$var$_255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, $861618b1eb57e58a$var$_colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split($861618b1eb57e58a$export$dd733e62515be2bd).forEach(function(v) {
        var a = v.match($861618b1eb57e58a$export$65c88bbd597e7b0a) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, $861618b1eb57e58a$var$_formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match($861618b1eb57e58a$export$dd733e62515be2bd), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = $861618b1eb57e58a$export$73d6f35be992df24(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = $861618b1eb57e58a$var$_colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace($861618b1eb57e58a$export$dd733e62515be2bd, "1").split($861618b1eb57e58a$export$65c88bbd597e7b0a);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split($861618b1eb57e58a$export$dd733e62515be2bd);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, $861618b1eb57e58a$export$dd733e62515be2bd = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in $861618b1eb57e58a$var$_colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), $861618b1eb57e58a$var$_hslExp = /hsl[a]?\(/, $861618b1eb57e58a$export$7eb2e5eb5eeb96a4 = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    $861618b1eb57e58a$export$dd733e62515be2bd.lastIndex = 0;
    if ($861618b1eb57e58a$export$dd733e62515be2bd.test(combined)) {
        toHSL = $861618b1eb57e58a$var$_hslExp.test(combined);
        a[1] = $861618b1eb57e58a$var$_formatColors(a[1], toHSL);
        a[0] = $861618b1eb57e58a$var$_formatColors(a[0], toHSL, $861618b1eb57e58a$var$_colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ $861618b1eb57e58a$var$_tickerActive, $861618b1eb57e58a$export$762ed8fbedb691e3 = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if ($861618b1eb57e58a$var$_coreReady) {
                if (!$861618b1eb57e58a$var$_coreInitted && $861618b1eb57e58a$var$_windowExists()) {
                    $861618b1eb57e58a$var$_win = $861618b1eb57e58a$var$_coreInitted = window;
                    $861618b1eb57e58a$var$_doc = $861618b1eb57e58a$var$_win.document || {};
                    $861618b1eb57e58a$var$_globals.gsap = $861618b1eb57e58a$export$99ee26438460406a;
                    ($861618b1eb57e58a$var$_win.gsapVersions || ($861618b1eb57e58a$var$_win.gsapVersions = [])).push($861618b1eb57e58a$export$99ee26438460406a.version);
                    $861618b1eb57e58a$var$_install($861618b1eb57e58a$var$_installScope || $861618b1eb57e58a$var$_win.GreenSockGlobals || !$861618b1eb57e58a$var$_win.gsap && $861618b1eb57e58a$var$_win || {});
                    _raf = $861618b1eb57e58a$var$_win.requestAnimationFrame;
                    $861618b1eb57e58a$var$_registerPluginQueue.forEach($861618b1eb57e58a$var$_createPlugin);
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                $861618b1eb57e58a$var$_tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? $861618b1eb57e58a$var$_win.cancelAnimationFrame : clearTimeout)(_id);
            $861618b1eb57e58a$var$_tickerActive = 0;
            _req = $861618b1eb57e58a$var$_emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            $861618b1eb57e58a$var$_wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), $861618b1eb57e58a$var$_wake = function _wake() {
    return !$861618b1eb57e58a$var$_tickerActive && $861618b1eb57e58a$export$762ed8fbedb691e3.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ $861618b1eb57e58a$var$_easeMap = {}, $861618b1eb57e58a$var$_customEaseExp = /^[\d.\-M][\d.\-,\s]/, $861618b1eb57e58a$var$_quotesExp = /["']/g, $861618b1eb57e58a$var$_parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace($861618b1eb57e58a$var$_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, $861618b1eb57e58a$var$_valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, $861618b1eb57e58a$var$_configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = $861618b1eb57e58a$var$_easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        $861618b1eb57e58a$var$_parseObjectInString(split[1])
    ] : $861618b1eb57e58a$var$_valueInParentheses(name).split(",").map($861618b1eb57e58a$var$_numericIfPossible)) : $861618b1eb57e58a$var$_easeMap._CE && $861618b1eb57e58a$var$_customEaseExp.test(name) ? $861618b1eb57e58a$var$_easeMap._CE("", name) : ease;
}, $861618b1eb57e58a$var$_invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
$861618b1eb57e58a$var$_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof $861618b1eb57e58a$export$e6a97ba2cae5bb94) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, $861618b1eb57e58a$var$_parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : ($861618b1eb57e58a$var$_isFunction(ease) ? ease : $861618b1eb57e58a$var$_easeMap[ease] || $861618b1eb57e58a$var$_configEaseFromString(ease)) || defaultEase;
}, $861618b1eb57e58a$var$_insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    $861618b1eb57e58a$export$f9000b814859f126(names, function(name) {
        $861618b1eb57e58a$var$_easeMap[name] = $861618b1eb57e58a$var$_globals[name] = ease;
        $861618b1eb57e58a$var$_easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)$861618b1eb57e58a$var$_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = $861618b1eb57e58a$var$_easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, $861618b1eb57e58a$var$_easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, $861618b1eb57e58a$var$_configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / $861618b1eb57e58a$var$_2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * $861618b1eb57e58a$var$_sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $861618b1eb57e58a$var$_easeInOutFromOut(easeOut);
    p2 = $861618b1eb57e58a$var$_2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, $861618b1eb57e58a$var$_configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $861618b1eb57e58a$var$_easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
$861618b1eb57e58a$export$f9000b814859f126("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    $861618b1eb57e58a$var$_insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
$861618b1eb57e58a$var$_easeMap.Linear.easeNone = $861618b1eb57e58a$var$_easeMap.none = $861618b1eb57e58a$var$_easeMap.Linear.easeIn;
$861618b1eb57e58a$var$_insertEase("Elastic", $861618b1eb57e58a$var$_configElastic("in"), $861618b1eb57e58a$var$_configElastic("out"), $861618b1eb57e58a$var$_configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    $861618b1eb57e58a$var$_insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
$861618b1eb57e58a$var$_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
$861618b1eb57e58a$var$_insertEase("Circ", function(p) {
    return -($861618b1eb57e58a$var$_sqrt(1 - p * p) - 1);
});
$861618b1eb57e58a$var$_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -$861618b1eb57e58a$var$_cos(p * $861618b1eb57e58a$var$_HALF_PI) + 1;
});
$861618b1eb57e58a$var$_insertEase("Back", $861618b1eb57e58a$var$_configBack("in"), $861618b1eb57e58a$var$_configBack("out"), $861618b1eb57e58a$var$_configBack());
$861618b1eb57e58a$var$_easeMap.SteppedEase = $861618b1eb57e58a$var$_easeMap.steps = $861618b1eb57e58a$var$_globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - $861618b1eb57e58a$var$_tinyNum;
        return function(p) {
            return ((p2 * $861618b1eb57e58a$var$_clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
$861618b1eb57e58a$var$_defaults.ease = $861618b1eb57e58a$var$_easeMap["quad.out"];
$861618b1eb57e58a$export$f9000b814859f126("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return $861618b1eb57e58a$var$_callbackNames += name + "," + name + "Params,";
});
var $861618b1eb57e58a$export$cf10981d5419cad5 = function GSCache(target, harness) {
    this.id = $861618b1eb57e58a$var$_gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : $861618b1eb57e58a$export$51d6bbe898aef1f9;
    this.set = harness ? harness.getSetter : $861618b1eb57e58a$export$d60fbc1e0278aaf0;
};
var $861618b1eb57e58a$export$c35d437ae5945fcd = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        $861618b1eb57e58a$var$_setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if ($861618b1eb57e58a$var$_context) {
            this._ctx = $861618b1eb57e58a$var$_context;
            $861618b1eb57e58a$var$_context.data.push(this);
        }
        $861618b1eb57e58a$var$_tickerActive || $861618b1eb57e58a$export$762ed8fbedb691e3.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return $861618b1eb57e58a$var$_setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        $861618b1eb57e58a$var$_wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            $861618b1eb57e58a$var$_alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || $861618b1eb57e58a$var$_postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            $861618b1eb57e58a$var$_addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === $861618b1eb57e58a$var$_tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            $861618b1eb57e58a$var$_lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + $861618b1eb57e58a$var$_elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + $861618b1eb57e58a$var$_elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? $861618b1eb57e58a$var$_animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -$861618b1eb57e58a$var$_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? $861618b1eb57e58a$var$_parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -$861618b1eb57e58a$var$_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime($861618b1eb57e58a$var$_clamp(-Math.abs(this._delay), this._tDur, tTime), true);
        $861618b1eb57e58a$var$_setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return $861618b1eb57e58a$var$_recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                $861618b1eb57e58a$var$_wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== $861618b1eb57e58a$var$_tinyNum && (this._tTime -= $861618b1eb57e58a$var$_tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && $861618b1eb57e58a$var$_addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + ($861618b1eb57e58a$var$_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : $861618b1eb57e58a$var$_parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = $861618b1eb57e58a$var$_revertConfig;
        var prevIsReverting = $861618b1eb57e58a$var$_reverting;
        $861618b1eb57e58a$var$_reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        $861618b1eb57e58a$var$_reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.vars.immediateRender ? -Infinity : this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return $861618b1eb57e58a$var$_onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            $861618b1eb57e58a$var$_onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime($861618b1eb57e58a$var$_parsePosition(this, position), $861618b1eb57e58a$var$_isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, $861618b1eb57e58a$var$_isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -$861618b1eb57e58a$var$_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -$861618b1eb57e58a$var$_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - $861618b1eb57e58a$var$_tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = $861618b1eb57e58a$var$_isFunction(onFulfilled) ? onFulfilled : $861618b1eb57e58a$var$_passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                $861618b1eb57e58a$var$_isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        $861618b1eb57e58a$var$_interrupt(this);
    };
    return Animation;
}();
$861618b1eb57e58a$export$dc2b19673bb53610($861618b1eb57e58a$export$c35d437ae5945fcd.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -$861618b1eb57e58a$var$_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var $861618b1eb57e58a$export$e6a97ba2cae5bb94 = /*#__PURE__*/ function(_Animation) {
    $861618b1eb57e58a$var$_inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = $861618b1eb57e58a$var$_isNotFalse(vars.sortChildren);
        $861618b1eb57e58a$var$_globalTimeline && $861618b1eb57e58a$var$_addToTimeline(vars.parent || $861618b1eb57e58a$var$_globalTimeline, $861618b1eb57e58a$var$_assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && $861618b1eb57e58a$var$_scrollTrigger($861618b1eb57e58a$var$_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        $861618b1eb57e58a$var$_createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        $861618b1eb57e58a$var$_createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        $861618b1eb57e58a$var$_createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        $861618b1eb57e58a$var$_inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new $861618b1eb57e58a$export$208a41d6b4e37b97(targets, vars, $861618b1eb57e58a$var$_parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return $861618b1eb57e58a$var$_addToTimeline(this, $861618b1eb57e58a$export$208a41d6b4e37b97.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new $861618b1eb57e58a$export$208a41d6b4e37b97(targets, vars, $861618b1eb57e58a$var$_parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        $861618b1eb57e58a$var$_inheritDefaults(vars).immediateRender = $861618b1eb57e58a$var$_isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        $861618b1eb57e58a$var$_inheritDefaults(toVars).immediateRender = $861618b1eb57e58a$var$_isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : $861618b1eb57e58a$var$_roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== $861618b1eb57e58a$var$_globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $861618b1eb57e58a$var$_roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = $861618b1eb57e58a$var$_animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : $861618b1eb57e58a$var$_roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && $861618b1eb57e58a$var$_callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    $861618b1eb57e58a$var$_propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = $861618b1eb57e58a$var$_findNextPauseTween(this, $861618b1eb57e58a$var$_roundPrecise(prevTime), $861618b1eb57e58a$var$_roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                $861618b1eb57e58a$var$_callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -$861618b1eb57e58a$var$_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || $861618b1eb57e58a$var$_reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -$861618b1eb57e58a$var$_tinyNum : $861618b1eb57e58a$var$_tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -$861618b1eb57e58a$var$_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    $861618b1eb57e58a$var$_setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && $861618b1eb57e58a$var$_callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && $861618b1eb57e58a$var$_removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            $861618b1eb57e58a$var$_callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        $861618b1eb57e58a$var$_isNumber(position) || (position = $861618b1eb57e58a$var$_parsePosition(this, position, child));
        if (!(child instanceof $861618b1eb57e58a$export$c35d437ae5945fcd)) {
            if ($861618b1eb57e58a$var$_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if ($861618b1eb57e58a$export$f664476fd67145ca(child)) return this.addLabel(child, position);
            if ($861618b1eb57e58a$var$_isFunction(child)) child = $861618b1eb57e58a$export$208a41d6b4e37b97.delayedCall(0, child);
            else return this;
        }
        return this !== child ? $861618b1eb57e58a$var$_addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -$861618b1eb57e58a$var$_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof $861618b1eb57e58a$export$208a41d6b4e37b97) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if ($861618b1eb57e58a$export$f664476fd67145ca(child)) return this.removeLabel(child);
        if ($861618b1eb57e58a$var$_isFunction(child)) return this.killTweensOf(child);
        $861618b1eb57e58a$export$cd008aa6cd8844e3(this, child);
        if (child === this._recent) this._recent = this._last;
        return $861618b1eb57e58a$var$_uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = $861618b1eb57e58a$var$_roundPrecise($861618b1eb57e58a$export$762ed8fbedb691e3.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = $861618b1eb57e58a$var$_parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = $861618b1eb57e58a$export$208a41d6b4e37b97.delayedCall(0, callback || $861618b1eb57e58a$var$_emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return $861618b1eb57e58a$var$_addToTimeline(this, t, $861618b1eb57e58a$var$_parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = $861618b1eb57e58a$var$_parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") $861618b1eb57e58a$var$_removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)$861618b1eb57e58a$var$_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = $861618b1eb57e58a$export$45b10814cc054894(targets), child = this._first, isGlobalTime = $861618b1eb57e58a$var$_isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof $861618b1eb57e58a$export$208a41d6b4e37b97) {
                if ($861618b1eb57e58a$var$_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!$861618b1eb57e58a$var$_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = $861618b1eb57e58a$var$_parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = $861618b1eb57e58a$export$208a41d6b4e37b97.to(tl, $861618b1eb57e58a$export$dc2b19673bb53610({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || $861618b1eb57e58a$var$_tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && $861618b1eb57e58a$var$_setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, $861618b1eb57e58a$export$dc2b19673bb53610({
            startAt: {
                time: $861618b1eb57e58a$var$_parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return $861618b1eb57e58a$var$_getLabelInDirection(this, $861618b1eb57e58a$var$_parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return $861618b1eb57e58a$var$_getLabelInDirection(this, $861618b1eb57e58a$var$_parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + $861618b1eb57e58a$var$_tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return $861618b1eb57e58a$var$_uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return $861618b1eb57e58a$var$_uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = $861618b1eb57e58a$var$_bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    $861618b1eb57e58a$var$_addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            $861618b1eb57e58a$var$_setDuration(self, self === $861618b1eb57e58a$var$_globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if ($861618b1eb57e58a$var$_globalTimeline._ts) {
            $861618b1eb57e58a$var$_lazySafeRender($861618b1eb57e58a$var$_globalTimeline, $861618b1eb57e58a$var$_parentToChildTotalTime(time, $861618b1eb57e58a$var$_globalTimeline));
            $861618b1eb57e58a$var$_lastRenderedFrame = $861618b1eb57e58a$export$762ed8fbedb691e3.frame;
        }
        if ($861618b1eb57e58a$export$762ed8fbedb691e3.frame >= $861618b1eb57e58a$var$_nextGCFrame) {
            $861618b1eb57e58a$var$_nextGCFrame += $861618b1eb57e58a$export$4922bee768729a77.autoSleep || 120;
            var child = $861618b1eb57e58a$var$_globalTimeline._first;
            if (!child || !child._ts) {
                if ($861618b1eb57e58a$export$4922bee768729a77.autoSleep && $861618b1eb57e58a$export$762ed8fbedb691e3._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || $861618b1eb57e58a$export$762ed8fbedb691e3.sleep();
                }
            }
        }
    };
    return Timeline;
}($861618b1eb57e58a$export$c35d437ae5945fcd);
$861618b1eb57e58a$export$dc2b19673bb53610($861618b1eb57e58a$export$e6a97ba2cae5bb94.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var $861618b1eb57e58a$var$_addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new $861618b1eb57e58a$export$3a67f7f44b1e838a(this._pt, target, prop, 0, 1, $861618b1eb57e58a$export$c5bc8e04394ecb2, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = $861618b1eb57e58a$export$d5962a97e3cde94d(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match($861618b1eb57e58a$var$_complexStringNumExp) || [];
    while(result = $861618b1eb57e58a$var$_complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? $861618b1eb57e58a$export$dac762bc6301b560(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = $861618b1eb57e58a$var$_complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if ($861618b1eb57e58a$export$5a680e28b0b61bc.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, $861618b1eb57e58a$var$_addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    $861618b1eb57e58a$var$_isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !$861618b1eb57e58a$var$_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !$861618b1eb57e58a$var$_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !$861618b1eb57e58a$var$_isFunction(currentValue) ? $861618b1eb57e58a$var$_setterPlain : funcParam ? $861618b1eb57e58a$var$_setterFuncWithParam : $861618b1eb57e58a$var$_setterFunc, pt;
    if ($861618b1eb57e58a$export$f664476fd67145ca(end)) {
        if (~end.indexOf("random(")) end = $861618b1eb57e58a$export$d5962a97e3cde94d(end);
        if (end.charAt(1) === "=") {
            pt = $861618b1eb57e58a$export$dac762bc6301b560(parsedStart, end) + ($861618b1eb57e58a$export$65f2564e9a9b9222(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || $861618b1eb57e58a$var$_forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new $861618b1eb57e58a$export$3a67f7f44b1e838a(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? $861618b1eb57e58a$var$_renderBoolean : $861618b1eb57e58a$var$_renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && $861618b1eb57e58a$export$7fb54635790b59a5(prop, end);
        return $861618b1eb57e58a$var$_addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || $861618b1eb57e58a$export$4922bee768729a77.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
$861618b1eb57e58a$var$_processVars = function _processVars(vars, index, target, targets, tween) {
    $861618b1eb57e58a$var$_isFunction(vars) && (vars = $861618b1eb57e58a$var$_parseFuncOrString(vars, tween, index, target, targets));
    if (!$861618b1eb57e58a$var$_isObject(vars) || vars.style && vars.nodeType || $861618b1eb57e58a$var$_isArray(vars) || $861618b1eb57e58a$var$_isTypedArray(vars)) return $861618b1eb57e58a$export$f664476fd67145ca(vars) ? $861618b1eb57e58a$var$_parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = $861618b1eb57e58a$var$_parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, $861618b1eb57e58a$export$5c457b74208010cf = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if ($861618b1eb57e58a$export$d305d8ec5d7c26b8[property] && (plugin = new $861618b1eb57e58a$export$d305d8ec5d7c26b8[property]()).init(target, plugin.rawVars ? vars[property] : $861618b1eb57e58a$var$_processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new $861618b1eb57e58a$export$3a67f7f44b1e838a(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== $861618b1eb57e58a$var$_quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, $861618b1eb57e58a$var$_overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
$861618b1eb57e58a$var$_forceAllPropTweens, $861618b1eb57e58a$var$_initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !$861618b1eb57e58a$var$_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = $861618b1eb57e58a$var$_parseEase(ease, $861618b1eb57e58a$var$_defaults.ease);
    tween._yEase = yoyoEase ? $861618b1eb57e58a$var$_invertEase($861618b1eb57e58a$var$_parseEase(yoyoEase === true ? ease : yoyoEase, $861618b1eb57e58a$var$_defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? $861618b1eb57e58a$export$8b9be379d2de2a39(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = $861618b1eb57e58a$var$_copyExcluding(vars, $861618b1eb57e58a$var$_reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? $861618b1eb57e58a$var$_revertConfigNoKill : $861618b1eb57e58a$var$_startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            $861618b1eb57e58a$var$_removeFromParent(tween._startAt = $861618b1eb57e58a$export$208a41d6b4e37b97.set(targets, $861618b1eb57e58a$export$dc2b19673bb53610({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && $861618b1eb57e58a$var$_isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && ($861618b1eb57e58a$var$_reverting || !immediateRender && !autoRevert) && tween._startAt.revert($861618b1eb57e58a$var$_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = $861618b1eb57e58a$export$dc2b19673bb53610({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && $861618b1eb57e58a$var$_isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                $861618b1eb57e58a$var$_removeFromParent(tween._startAt = $861618b1eb57e58a$export$208a41d6b4e37b97.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && ($861618b1eb57e58a$var$_reverting ? tween._startAt.revert($861618b1eb57e58a$var$_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, $861618b1eb57e58a$var$_tinyNum, $861618b1eb57e58a$var$_tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && $861618b1eb57e58a$var$_isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || $861618b1eb57e58a$var$_harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            $861618b1eb57e58a$var$_lazyLookup[gsData.id] && $861618b1eb57e58a$var$_lazyTweens.length && $861618b1eb57e58a$var$_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new $861618b1eb57e58a$export$3a67f7f44b1e838a(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if ($861618b1eb57e58a$export$d305d8ec5d7c26b8[p] && (plugin = $861618b1eb57e58a$export$5c457b74208010cf(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = $861618b1eb57e58a$var$_addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                $861618b1eb57e58a$var$_overwritingTween = tween;
                $861618b1eb57e58a$var$_globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                $861618b1eb57e58a$var$_overwritingTween = 0;
            }
            tween._pt && lazy && ($861618b1eb57e58a$var$_lazyLookup[gsData.id] = 1);
        }
        hasPriority && $861618b1eb57e58a$export$eed5824f53346d57(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render($861618b1eb57e58a$var$_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, $861618b1eb57e58a$var$_updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                $861618b1eb57e58a$var$_forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                $861618b1eb57e58a$var$_initTween(tween, time);
                $861618b1eb57e58a$var$_forceAllPropTweens = 0;
                return 1;
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = $861618b1eb57e58a$export$9c8d725d65e13f94(value) + $861618b1eb57e58a$export$65f2564e9a9b9222(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + $861618b1eb57e58a$export$65f2564e9a9b9222(rootPT.b)); // (beginning value)
    }
}, $861618b1eb57e58a$var$_addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? $861618b1eb57e58a$export$8b9be379d2de2a39(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = $861618b1eb57e58a$var$_merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
$861618b1eb57e58a$var$_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if ($861618b1eb57e58a$var$_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, $861618b1eb57e58a$var$_parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return $861618b1eb57e58a$var$_isFunction(value) ? value.call(tween, i, target, targets) : $861618b1eb57e58a$export$f664476fd67145ca(value) && ~value.indexOf("random(") ? $861618b1eb57e58a$export$d5962a97e3cde94d(value) : value;
}, $861618b1eb57e58a$var$_staggerTweenProps = $861618b1eb57e58a$var$_callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", $861618b1eb57e58a$var$_staggerPropsToSkip = {};
$861618b1eb57e58a$export$f9000b814859f126($861618b1eb57e58a$var$_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return $861618b1eb57e58a$var$_staggerPropsToSkip[name] = 1;
});
var $861618b1eb57e58a$export$208a41d6b4e37b97 = /*#__PURE__*/ function(_Animation2) {
    $861618b1eb57e58a$var$_inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : $861618b1eb57e58a$var$_inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || $861618b1eb57e58a$var$_globalTimeline, parsedTargets = ($861618b1eb57e58a$var$_isArray(targets) || $861618b1eb57e58a$var$_isTypedArray(targets) ? $861618b1eb57e58a$var$_isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : $861618b1eb57e58a$export$45b10814cc054894(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? $861618b1eb57e58a$var$_harness(parsedTargets) : $861618b1eb57e58a$var$_warn("GSAP target " + targets + " not found. https://greensock.com", !$861618b1eb57e58a$export$4922bee768729a77.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || $861618b1eb57e58a$var$_isFuncOrString(duration) || $861618b1eb57e58a$var$_isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new $861618b1eb57e58a$export$e6a97ba2cae5bb94({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = $861618b1eb57e58a$var$_assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || $861618b1eb57e58a$var$_isFuncOrString(duration) || $861618b1eb57e58a$var$_isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && $861618b1eb57e58a$export$f02a9ddbe4480f19(stagger);
                if ($861618b1eb57e58a$var$_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~$861618b1eb57e58a$var$_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = $861618b1eb57e58a$var$_copyExcluding(vars, $861618b1eb57e58a$var$_staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && $861618b1eb57e58a$var$_merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +$861618b1eb57e58a$var$_parseFuncOrString(duration, $861618b1eb57e58a$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+$861618b1eb57e58a$var$_parseFuncOrString(delay, $861618b1eb57e58a$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = $861618b1eb57e58a$var$_easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                $861618b1eb57e58a$var$_inheritDefaults($861618b1eb57e58a$export$dc2b19673bb53610(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = $861618b1eb57e58a$var$_parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if ($861618b1eb57e58a$var$_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || $861618b1eb57e58a$var$_parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !$861618b1eb57e58a$var$_suppressOverwrites) {
            $861618b1eb57e58a$var$_overwritingTween = $861618b1eb57e58a$var$_assertThisInitialized(_this3);
            $861618b1eb57e58a$var$_globalTimeline.killTweensOf(parsedTargets);
            $861618b1eb57e58a$var$_overwritingTween = 0;
        }
        $861618b1eb57e58a$var$_addToTimeline(parent, $861618b1eb57e58a$var$_assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === $861618b1eb57e58a$var$_roundPrecise(parent._time) && $861618b1eb57e58a$var$_isNotFalse(immediateRender) && $861618b1eb57e58a$var$_hasNoPausedAncestors($861618b1eb57e58a$var$_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -$861618b1eb57e58a$var$_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && $861618b1eb57e58a$var$_scrollTrigger($861618b1eb57e58a$var$_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - $861618b1eb57e58a$var$_tinyNum && !isNegative ? tDur : totalTime < $861618b1eb57e58a$var$_tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) $861618b1eb57e58a$var$_renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $861618b1eb57e58a$var$_roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = $861618b1eb57e58a$var$_animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && $861618b1eb57e58a$var$_propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render($861618b1eb57e58a$var$_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if ($861618b1eb57e58a$var$_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values.
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                $861618b1eb57e58a$var$_callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -$861618b1eb57e58a$var$_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && $861618b1eb57e58a$var$_rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                $861618b1eb57e58a$var$_callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && $861618b1eb57e58a$var$_callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && $861618b1eb57e58a$var$_rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && $861618b1eb57e58a$var$_removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    $861618b1eb57e58a$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative) {
        $861618b1eb57e58a$var$_tickerActive || $861618b1eb57e58a$export$762ed8fbedb691e3.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || $861618b1eb57e58a$var$_initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if ($861618b1eb57e58a$var$_updatePropTweens(this, property, value, start, startIsRelative, ratio, time)) return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        $861618b1eb57e58a$var$_alignPlayhead(this, 0);
        this.parent || $861618b1eb57e58a$var$_addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? $861618b1eb57e58a$var$_interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, $861618b1eb57e58a$var$_overwritingTween && $861618b1eb57e58a$var$_overwritingTween.vars.overwrite !== true)._first || $861618b1eb57e58a$var$_interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && $861618b1eb57e58a$var$_setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? $861618b1eb57e58a$export$45b10814cc054894(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && $861618b1eb57e58a$var$_arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return $861618b1eb57e58a$var$_interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if ($861618b1eb57e58a$export$f664476fd67145ca(vars)) {
                p = {};
                $861618b1eb57e58a$export$f9000b814859f126(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = $861618b1eb57e58a$var$_addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) $861618b1eb57e58a$export$cd008aa6cd8844e3(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && $861618b1eb57e58a$var$_interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return $861618b1eb57e58a$var$_createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return $861618b1eb57e58a$var$_createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return $861618b1eb57e58a$var$_globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}($861618b1eb57e58a$export$c35d437ae5945fcd);
$861618b1eb57e58a$export$dc2b19673bb53610($861618b1eb57e58a$export$208a41d6b4e37b97.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
$861618b1eb57e58a$export$f9000b814859f126("staggerTo,staggerFrom,staggerFromTo", function(name) {
    $861618b1eb57e58a$export$208a41d6b4e37b97[name] = function() {
        var tl = new $861618b1eb57e58a$export$e6a97ba2cae5bb94(), params = $861618b1eb57e58a$var$_slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var $861618b1eb57e58a$var$_setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, $861618b1eb57e58a$var$_setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, $861618b1eb57e58a$var$_setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, $861618b1eb57e58a$var$_setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, $861618b1eb57e58a$export$d60fbc1e0278aaf0 = function _getSetter(target, property) {
    return $861618b1eb57e58a$var$_isFunction(target[property]) ? $861618b1eb57e58a$var$_setterFunc : $861618b1eb57e58a$export$a8178c063a9fd3a1(target[property]) && target.setAttribute ? $861618b1eb57e58a$var$_setterAttribute : $861618b1eb57e58a$var$_setterPlain;
}, $861618b1eb57e58a$var$_renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, $861618b1eb57e58a$var$_renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, $861618b1eb57e58a$export$c5bc8e04394ecb2 = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, $861618b1eb57e58a$var$_renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, $861618b1eb57e58a$var$_addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, $861618b1eb57e58a$var$_killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) $861618b1eb57e58a$export$cd008aa6cd8844e3(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, $861618b1eb57e58a$var$_setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, $861618b1eb57e58a$export$eed5824f53346d57 = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var $861618b1eb57e58a$export$3a67f7f44b1e838a = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || $861618b1eb57e58a$var$_renderPlain;
        this.d = data || this;
        this.set = setter || $861618b1eb57e58a$var$_setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = $861618b1eb57e58a$var$_setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
$861618b1eb57e58a$export$f9000b814859f126($861618b1eb57e58a$var$_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return $861618b1eb57e58a$var$_reservedProps[name] = 1;
});
$861618b1eb57e58a$var$_globals.TweenMax = $861618b1eb57e58a$var$_globals.TweenLite = $861618b1eb57e58a$export$208a41d6b4e37b97;
$861618b1eb57e58a$var$_globals.TimelineLite = $861618b1eb57e58a$var$_globals.TimelineMax = $861618b1eb57e58a$export$e6a97ba2cae5bb94;
$861618b1eb57e58a$var$_globalTimeline = new $861618b1eb57e58a$export$e6a97ba2cae5bb94({
    sortChildren: false,
    defaults: $861618b1eb57e58a$var$_defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
$861618b1eb57e58a$export$4922bee768729a77.stringFilter = $861618b1eb57e58a$export$7eb2e5eb5eeb96a4;
var $861618b1eb57e58a$var$_media = [], $861618b1eb57e58a$var$_listeners = {}, $861618b1eb57e58a$var$_emptyArray = [], $861618b1eb57e58a$var$_lastMediaTime = 0, $861618b1eb57e58a$var$_contextID = 0, $861618b1eb57e58a$var$_dispatch = function _dispatch(type) {
    return ($861618b1eb57e58a$var$_listeners[type] || $861618b1eb57e58a$var$_emptyArray).map(function(f) {
        return f();
    });
}, $861618b1eb57e58a$var$_onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - $861618b1eb57e58a$var$_lastMediaTime > 2) {
        $861618b1eb57e58a$var$_dispatch("matchMediaInit");
        $861618b1eb57e58a$var$_media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = $861618b1eb57e58a$var$_win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        $861618b1eb57e58a$var$_dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c);
        });
        $861618b1eb57e58a$var$_lastMediaTime = time;
        $861618b1eb57e58a$var$_dispatch("matchMedia");
    }
};
var $861618b1eb57e58a$var$Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && $861618b1eb57e58a$export$aea217a45095ce11(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = $861618b1eb57e58a$var$_contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if ($861618b1eb57e58a$var$_isFunction(name)) {
            scope = func;
            func = name;
            name = $861618b1eb57e58a$var$_isFunction;
        }
        var self = this, f = function f() {
            var prev = $861618b1eb57e58a$var$_context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = $861618b1eb57e58a$export$aea217a45095ce11(scope));
            $861618b1eb57e58a$var$_context = self;
            result = func.apply(self, arguments);
            $861618b1eb57e58a$var$_isFunction(result) && self._r.push(result);
            $861618b1eb57e58a$var$_context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === $861618b1eb57e58a$var$_isFunction ? f(self) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = $861618b1eb57e58a$var$_context;
        $861618b1eb57e58a$var$_context = null;
        func(this);
        $861618b1eb57e58a$var$_context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof $861618b1eb57e58a$export$208a41d6b4e37b97 && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) {
            var tweens = this.getTweens();
            this.data.forEach(function(t) {
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            }); // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t.globalTime(0),
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            this.data.forEach(function(e) {
                return !(e instanceof $861618b1eb57e58a$export$208a41d6b4e37b97) && e.revert && e.revert(revert);
            });
            this._r.forEach(function(f) {
                return f(revert, _this4);
            });
            this.isReverted = true;
        } else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = $861618b1eb57e58a$var$_media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            $861618b1eb57e58a$var$_media[i].id === this.id && $861618b1eb57e58a$var$_media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var $861618b1eb57e58a$var$MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        $861618b1eb57e58a$var$_isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new $861618b1eb57e58a$var$Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        $861618b1eb57e58a$var$_context && !context.selector && (context.selector = $861618b1eb57e58a$var$_context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = $861618b1eb57e58a$var$_win.matchMedia(conditions[p]);
            if (mq) {
                $861618b1eb57e58a$var$_media.indexOf(context) < 0 && $861618b1eb57e58a$var$_media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener($861618b1eb57e58a$var$_onMediaChange) : mq.addEventListener("change", $861618b1eb57e58a$var$_onMediaChange);
            }
        }
        active && func(context);
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var $861618b1eb57e58a$var$_gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return $861618b1eb57e58a$var$_createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new $861618b1eb57e58a$export$e6a97ba2cae5bb94(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return $861618b1eb57e58a$var$_globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        $861618b1eb57e58a$export$f664476fd67145ca(target) && (target = $861618b1eb57e58a$export$45b10814cc054894(target)[0]); //in case selector text or an array is passed in
        var getter = $861618b1eb57e58a$export$8b9be379d2de2a39(target || {}).get, format = unit ? $861618b1eb57e58a$var$_passThrough : $861618b1eb57e58a$var$_numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format(($861618b1eb57e58a$export$d305d8ec5d7c26b8[property] && $861618b1eb57e58a$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
        } : format(($861618b1eb57e58a$export$d305d8ec5d7c26b8[property] && $861618b1eb57e58a$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = $861618b1eb57e58a$export$45b10814cc054894(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return $861618b1eb57e58a$export$99ee26438460406a.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = $861618b1eb57e58a$export$d305d8ec5d7c26b8[property], cache = $861618b1eb57e58a$export$8b9be379d2de2a39(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            $861618b1eb57e58a$var$_quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, $861618b1eb57e58a$var$_quickTween, 0, [
                target
            ]);
            p.render(1, p);
            $861618b1eb57e58a$var$_quickTween._pt && $861618b1eb57e58a$var$_renderPropTweens(1, $861618b1eb57e58a$var$_quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = $861618b1eb57e58a$export$99ee26438460406a.to(target, $861618b1eb57e58a$var$_merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return $861618b1eb57e58a$var$_globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = $861618b1eb57e58a$var$_parseEase(value.ease, $861618b1eb57e58a$var$_defaults.ease));
        return $861618b1eb57e58a$var$_mergeDeep($861618b1eb57e58a$var$_defaults, value || {});
    },
    config: function config(value) {
        return $861618b1eb57e58a$var$_mergeDeep($861618b1eb57e58a$export$4922bee768729a77, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !$861618b1eb57e58a$export$d305d8ec5d7c26b8[pluginName] && !$861618b1eb57e58a$var$_globals[pluginName] && $861618b1eb57e58a$var$_warn(name + " effect requires " + pluginName + " plugin.");
        });
        $861618b1eb57e58a$var$_effects[name] = function(targets, vars, tl) {
            return effect($861618b1eb57e58a$export$45b10814cc054894(targets), $861618b1eb57e58a$export$dc2b19673bb53610(vars || {}, defaults), tl);
        };
        if (extendTimeline) $861618b1eb57e58a$export$e6a97ba2cae5bb94.prototype[name] = function(targets, vars, position) {
            return this.add($861618b1eb57e58a$var$_effects[name](targets, $861618b1eb57e58a$var$_isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        $861618b1eb57e58a$var$_easeMap[name] = $861618b1eb57e58a$var$_parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? $861618b1eb57e58a$var$_parseEase(ease, defaultEase) : $861618b1eb57e58a$var$_easeMap;
    },
    getById: function getById(id) {
        return $861618b1eb57e58a$var$_globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new $861618b1eb57e58a$export$e6a97ba2cae5bb94(vars), child, next;
        tl.smoothChildTiming = $861618b1eb57e58a$var$_isNotFalse(vars.smoothChildTiming);
        $861618b1eb57e58a$var$_globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = $861618b1eb57e58a$var$_globalTimeline._time;
        child = $861618b1eb57e58a$var$_globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof $861618b1eb57e58a$export$208a41d6b4e37b97 && child.vars.onComplete === child._targets[0])) $861618b1eb57e58a$var$_addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        $861618b1eb57e58a$var$_addToTimeline($861618b1eb57e58a$var$_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new $861618b1eb57e58a$var$Context(func, scope) : $861618b1eb57e58a$var$_context;
    },
    matchMedia: function matchMedia(scope) {
        return new $861618b1eb57e58a$var$MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return $861618b1eb57e58a$var$_media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || $861618b1eb57e58a$var$_onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = $861618b1eb57e58a$var$_listeners[type] || ($861618b1eb57e58a$var$_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = $861618b1eb57e58a$var$_listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: $861618b1eb57e58a$export$4997ffc0176396a6,
        wrapYoyo: $861618b1eb57e58a$export$cfc0b067273edc55,
        distribute: $861618b1eb57e58a$export$f02a9ddbe4480f19,
        random: $861618b1eb57e58a$export$4385e60b38654f68,
        snap: $861618b1eb57e58a$export$51a0620f7a28532b,
        normalize: $861618b1eb57e58a$export$a3295358bff77e,
        getUnit: $861618b1eb57e58a$export$65f2564e9a9b9222,
        clamp: $861618b1eb57e58a$export$7d15b64cf5a3a4c4,
        splitColor: $861618b1eb57e58a$export$73d6f35be992df24,
        toArray: $861618b1eb57e58a$export$45b10814cc054894,
        selector: $861618b1eb57e58a$export$aea217a45095ce11,
        mapRange: $861618b1eb57e58a$export$f65a7599bbc6b121,
        pipe: $861618b1eb57e58a$export$a4627e546088548d,
        unitize: $861618b1eb57e58a$export$d7502930aa5492de,
        interpolate: $861618b1eb57e58a$export$89e29e4ab65e70a9,
        shuffle: $861618b1eb57e58a$export$448332262467e042
    },
    install: $861618b1eb57e58a$var$_install,
    effects: $861618b1eb57e58a$var$_effects,
    ticker: $861618b1eb57e58a$export$762ed8fbedb691e3,
    updateRoot: $861618b1eb57e58a$export$e6a97ba2cae5bb94.updateRoot,
    plugins: $861618b1eb57e58a$export$d305d8ec5d7c26b8,
    globalTimeline: $861618b1eb57e58a$var$_globalTimeline,
    core: {
        PropTween: $861618b1eb57e58a$export$3a67f7f44b1e838a,
        globals: $861618b1eb57e58a$var$_addGlobal,
        Tween: $861618b1eb57e58a$export$208a41d6b4e37b97,
        Timeline: $861618b1eb57e58a$export$e6a97ba2cae5bb94,
        Animation: $861618b1eb57e58a$export$c35d437ae5945fcd,
        getCache: $861618b1eb57e58a$export$8b9be379d2de2a39,
        _removeLinkedListItem: $861618b1eb57e58a$export$cd008aa6cd8844e3,
        reverting: function reverting() {
            return $861618b1eb57e58a$var$_reverting;
        },
        context: function context(toAdd) {
            if (toAdd && $861618b1eb57e58a$var$_context) {
                $861618b1eb57e58a$var$_context.data.push(toAdd);
                toAdd._ctx = $861618b1eb57e58a$var$_context;
            }
            return $861618b1eb57e58a$var$_context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return $861618b1eb57e58a$var$_suppressOverwrites = value;
        }
    }
};
$861618b1eb57e58a$export$f9000b814859f126("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return $861618b1eb57e58a$var$_gsap[name] = $861618b1eb57e58a$export$208a41d6b4e37b97[name];
});
$861618b1eb57e58a$export$762ed8fbedb691e3.add($861618b1eb57e58a$export$e6a97ba2cae5bb94.updateRoot);
$861618b1eb57e58a$var$_quickTween = $861618b1eb57e58a$var$_gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var $861618b1eb57e58a$var$_getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, $861618b1eb57e58a$var$_addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = $861618b1eb57e58a$var$_getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, $861618b1eb57e58a$var$_buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if ($861618b1eb57e58a$export$f664476fd67145ca(vars)) {
                    temp = {};
                    $861618b1eb57e58a$export$f9000b814859f126(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                $861618b1eb57e58a$var$_addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var $861618b1eb57e58a$export$99ee26438460406a = $861618b1eb57e58a$var$_gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            $861618b1eb57e58a$var$_reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, $861618b1eb57e58a$var$_buildModifierPlugin("roundProps", $861618b1eb57e58a$export$dd12390e6b265a17), $861618b1eb57e58a$var$_buildModifierPlugin("modifiers"), $861618b1eb57e58a$var$_buildModifierPlugin("snap", $861618b1eb57e58a$export$51a0620f7a28532b)) || $861618b1eb57e58a$var$_gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
$861618b1eb57e58a$export$208a41d6b4e37b97.version = $861618b1eb57e58a$export$e6a97ba2cae5bb94.version = $861618b1eb57e58a$export$99ee26438460406a.version = "3.12.2";
$861618b1eb57e58a$var$_coreReady = 1;
$861618b1eb57e58a$var$_windowExists() && $861618b1eb57e58a$var$_wake();
var $861618b1eb57e58a$export$2fae1e8613537d5f = $861618b1eb57e58a$var$_easeMap.Power0, $861618b1eb57e58a$export$5d84ab4efbecec39 = $861618b1eb57e58a$var$_easeMap.Power1, $861618b1eb57e58a$export$d8c694b7490ad65d = $861618b1eb57e58a$var$_easeMap.Power2, $861618b1eb57e58a$export$acebdf2b184a0b6f = $861618b1eb57e58a$var$_easeMap.Power3, $861618b1eb57e58a$export$42e40a141003d2f0 = $861618b1eb57e58a$var$_easeMap.Power4, $861618b1eb57e58a$export$cff00ccf6e2392de = $861618b1eb57e58a$var$_easeMap.Linear, $861618b1eb57e58a$export$7005c9eb6671414d = $861618b1eb57e58a$var$_easeMap.Quad, $861618b1eb57e58a$export$755261d5a1567778 = $861618b1eb57e58a$var$_easeMap.Cubic, $861618b1eb57e58a$export$daf531446cad3d2a = $861618b1eb57e58a$var$_easeMap.Quart, $861618b1eb57e58a$export$4c407d38ce8ad8cc = $861618b1eb57e58a$var$_easeMap.Quint, $861618b1eb57e58a$export$f301627d437cff88 = $861618b1eb57e58a$var$_easeMap.Strong, $861618b1eb57e58a$export$56ebabebb04a9ca9 = $861618b1eb57e58a$var$_easeMap.Elastic, $861618b1eb57e58a$export$25e48ac541203d4a = $861618b1eb57e58a$var$_easeMap.Back, $861618b1eb57e58a$export$f7a11c7543d81853 = $861618b1eb57e58a$var$_easeMap.SteppedEase, $861618b1eb57e58a$export$d20e79fdc3899e95 = $861618b1eb57e58a$var$_easeMap.Bounce, $861618b1eb57e58a$export$bed2d20ad96b784c = $861618b1eb57e58a$var$_easeMap.Sine, $861618b1eb57e58a$export$41e9d1ff1a2fb15a = $861618b1eb57e58a$var$_easeMap.Expo, $861618b1eb57e58a$export$ce49a57dd865b86c = $861618b1eb57e58a$var$_easeMap.Circ;


/*!
 * CSSPlugin 3.12.2
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $7d9b5a7dd4dbaff5$var$_win, $7d9b5a7dd4dbaff5$var$_doc, $7d9b5a7dd4dbaff5$var$_docElement, $7d9b5a7dd4dbaff5$var$_pluginInitted, $7d9b5a7dd4dbaff5$var$_tempDiv, $7d9b5a7dd4dbaff5$var$_tempDivStyler, $7d9b5a7dd4dbaff5$var$_recentSetterPlugin, $7d9b5a7dd4dbaff5$var$_reverting, $7d9b5a7dd4dbaff5$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $7d9b5a7dd4dbaff5$var$_transformProps = {}, $7d9b5a7dd4dbaff5$var$_RAD2DEG = 180 / Math.PI, $7d9b5a7dd4dbaff5$var$_DEG2RAD = Math.PI / 180, $7d9b5a7dd4dbaff5$var$_atan2 = Math.atan2, $7d9b5a7dd4dbaff5$var$_bigNum = 1e8, $7d9b5a7dd4dbaff5$var$_capsExp = /([A-Z])/g, $7d9b5a7dd4dbaff5$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $7d9b5a7dd4dbaff5$var$_complexExp = /[\s,\(]\S/, $7d9b5a7dd4dbaff5$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $7d9b5a7dd4dbaff5$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $7d9b5a7dd4dbaff5$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $7d9b5a7dd4dbaff5$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $7d9b5a7dd4dbaff5$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_transformProp = "transform", $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin", $7d9b5a7dd4dbaff5$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style;
    if (property in $7d9b5a7dd4dbaff5$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $7d9b5a7dd4dbaff5$var$_get(target, a);
            }) : this.tfm[property] = target._gsap.x ? target._gsap[property] : $7d9b5a7dd4dbaff5$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
        } else return $7d9b5a7dd4dbaff5$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($7d9b5a7dd4dbaff5$var$_transformProp) >= 0) return;
        if (target._gsap.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, isNotCSS, "");
        }
        property = $7d9b5a7dd4dbaff5$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $7d9b5a7dd4dbaff5$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $7d9b5a7dd4dbaff5$var$_reverting();
        if ((!i || !i.isStart) && !style[$7d9b5a7dd4dbaff5$var$_transformProp]) {
            $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $7d9b5a7dd4dbaff5$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $7d9b5a7dd4dbaff5$var$_revertStyle,
        save: $7d9b5a7dd4dbaff5$var$_saveStyle
    };
    target._gsap || (0, $861618b1eb57e58a$export$99ee26438460406a).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $7d9b5a7dd4dbaff5$var$_supports3D, $7d9b5a7dd4dbaff5$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $7d9b5a7dd4dbaff5$var$_doc.createElementNS ? $7d9b5a7dd4dbaff5$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $7d9b5a7dd4dbaff5$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $7d9b5a7dd4dbaff5$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $7d9b5a7dd4dbaff5$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($7d9b5a7dd4dbaff5$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $7d9b5a7dd4dbaff5$var$_prefixes[i] : "") + property;
}, $7d9b5a7dd4dbaff5$var$_initCore = function _initCore() {
    if ($7d9b5a7dd4dbaff5$var$_windowExists() && window.document) {
        $7d9b5a7dd4dbaff5$var$_win = window;
        $7d9b5a7dd4dbaff5$var$_doc = $7d9b5a7dd4dbaff5$var$_win.document;
        $7d9b5a7dd4dbaff5$var$_docElement = $7d9b5a7dd4dbaff5$var$_doc.documentElement;
        $7d9b5a7dd4dbaff5$var$_tempDiv = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $7d9b5a7dd4dbaff5$var$_tempDivStyler = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div");
        $7d9b5a7dd4dbaff5$var$_transformProp = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b($7d9b5a7dd4dbaff5$var$_transformProp);
        $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin";
        $7d9b5a7dd4dbaff5$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $7d9b5a7dd4dbaff5$var$_supports3D = !!$7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b("perspective");
        $7d9b5a7dd4dbaff5$var$_reverting = (0, $861618b1eb57e58a$export$99ee26438460406a).core.reverting;
        $7d9b5a7dd4dbaff5$var$_pluginInitted = 1;
    }
}, $7d9b5a7dd4dbaff5$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $7d9b5a7dd4dbaff5$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $7d9b5a7dd4dbaff5$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $7d9b5a7dd4dbaff5$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $7d9b5a7dd4dbaff5$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $7d9b5a7dd4dbaff5$var$_getBBoxHack || (bounds = $7d9b5a7dd4dbaff5$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $7d9b5a7dd4dbaff5$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$7d9b5a7dd4dbaff5$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp) property = $7d9b5a7dd4dbaff5$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $7d9b5a7dd4dbaff5$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $861618b1eb57e58a$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $7d9b5a7dd4dbaff5$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$7d9b5a7dd4dbaff5$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $7d9b5a7dd4dbaff5$var$_tempDiv.style, horizontal = $7d9b5a7dd4dbaff5$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[unit] || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($7d9b5a7dd4dbaff5$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $7d9b5a7dd4dbaff5$var$_doc || !parent.appendChild) parent = $7d9b5a7dd4dbaff5$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $861618b1eb57e58a$export$762ed8fbedb691e3).time && !cache.uncache) return (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && !$7d9b5a7dd4dbaff5$var$_nonStandardLayouts[$7d9b5a7dd4dbaff5$var$_getComputedProperty(parent, "display")] && (style.position = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($7d9b5a7dd4dbaff5$var$_tempDiv);
        px = $7d9b5a7dd4dbaff5$var$_tempDiv[measureProperty];
        parent.removeChild($7d9b5a7dd4dbaff5$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $861618b1eb57e58a$export$8b9be379d2de2a39)(parent);
            cache.time = (0, $861618b1eb57e58a$export$762ed8fbedb691e3).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $7d9b5a7dd4dbaff5$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore();
    if (property in $7d9b5a7dd4dbaff5$var$_propertyAliases && property !== "transform") {
        property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($7d9b5a7dd4dbaff5$var$_transformProps[property] && property !== "transform") {
        value = $7d9b5a7dd4dbaff5$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $7d9b5a7dd4dbaff5$var$_firstTwoOnly($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $7d9b5a7dd4dbaff5$var$_specialProps[property] && $7d9b5a7dd4dbaff5$var$_specialProps[property](target, property, unit) || $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, property) || (0, $861618b1eb57e58a$export$51d6bbe898aef1f9)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $861618b1eb57e58a$export$3a67f7f44b1e838a)(this._pt, target.style, prop, 0, 1, (0, $861618b1eb57e58a$export$c5bc8e04394ecb2)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $861618b1eb57e58a$export$7eb2e5eb5eeb96a4)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $861618b1eb57e58a$export$65c88bbd597e7b0a)) || [];
    endValues = end.match((0, $861618b1eb57e58a$export$65c88bbd597e7b0a)) || [];
    if (endValues.length) {
        while(result = (0, $861618b1eb57e58a$export$65c88bbd597e7b0a).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $861618b1eb57e58a$export$dac762bc6301b560)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $861618b1eb57e58a$export$65c88bbd597e7b0a).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $861618b1eb57e58a$export$4922bee768729a77).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue;
    (0, $861618b1eb57e58a$export$5a680e28b0b61bc).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $7d9b5a7dd4dbaff5$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[x] || x;
    split[1] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $7d9b5a7dd4dbaff5$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($7d9b5a7dd4dbaff5$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $7d9b5a7dd4dbaff5$var$_transformOriginProp : $7d9b5a7dd4dbaff5$var$_transformProp;
                }
                $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$7d9b5a7dd4dbaff5$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $861618b1eb57e58a$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 0, $7d9b5a7dd4dbaff5$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $7d9b5a7dd4dbaff5$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $7d9b5a7dd4dbaff5$var$_rotationalProperties = {}, $7d9b5a7dd4dbaff5$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
    return $7d9b5a7dd4dbaff5$var$_isNullTransform(matrixString) ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrixString.substr(7).match((0, $861618b1eb57e58a$export$b9d44bb6523120d6)).map((0, $861618b1eb57e58a$export$9c8d725d65e13f94));
}, $7d9b5a7dd4dbaff5$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $861618b1eb57e58a$export$8b9be379d2de2a39)(target), style = target.style, matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrix;
    } else if (matrix === $7d9b5a7dd4dbaff5$var$_identity2DMatrix && !target.offsetParent && target !== $7d9b5a7dd4dbaff5$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $7d9b5a7dd4dbaff5$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $7d9b5a7dd4dbaff5$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $7d9b5a7dd4dbaff5$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $7d9b5a7dd4dbaff5$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $7d9b5a7dd4dbaff5$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $861618b1eb57e58a$export$cf10981d5419cad5)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$7d9b5a7dd4dbaff5$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$7d9b5a7dd4dbaff5$var$_transformProp] !== "none" ? cs[$7d9b5a7dd4dbaff5$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $7d9b5a7dd4dbaff5$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $7d9b5a7dd4dbaff5$var$_atan2(b, a) * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $7d9b5a7dd4dbaff5$var$_atan2(c, d) * $7d9b5a7dd4dbaff5$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $7d9b5a7dd4dbaff5$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a32, a33);
            rotationX = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $7d9b5a7dd4dbaff5$var$_atan2(-c, a33);
            rotationY = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $7d9b5a7dd4dbaff5$var$_atan2(b, a);
            rotation = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$7d9b5a7dd4dbaff5$var$_isNullTransform($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(scaleX);
    cache.scaleY = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(scaleY);
    cache.rotation = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(rotation) + deg;
    cache.rotationX = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(rotationX) + deg;
    cache.rotationY = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = $7d9b5a7dd4dbaff5$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $861618b1eb57e58a$export$4922bee768729a77).force3D;
    cache.renderTransform = cache.svg ? $7d9b5a7dd4dbaff5$var$_renderSVGTransforms : $7d9b5a7dd4dbaff5$var$_supports3D ? $7d9b5a7dd4dbaff5$var$_renderCSSTransforms : $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $7d9b5a7dd4dbaff5$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$7d9b5a7dd4dbaff5$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $861618b1eb57e58a$export$65f2564e9a9b9222)(start);
    return (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(parseFloat(start) + parseFloat($7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $7d9b5a7dd4dbaff5$var$_renderCSSTransforms(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_zeroDeg = "0deg", $7d9b5a7dd4dbaff5$var$_zeroPx = "0px", $7d9b5a7dd4dbaff5$var$_endParenthesis = ") ", $7d9b5a7dd4dbaff5$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $7d9b5a7dd4dbaff5$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += "perspective(" + transformPerspective + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $7d9b5a7dd4dbaff5$var$_zeroPx || y !== $7d9b5a7dd4dbaff5$var$_zeroPx || z !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += z !== $7d9b5a7dd4dbaff5$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotation !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotate(" + rotation + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateY(" + rotationY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateX(" + rotationX + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (skewX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || skewY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms || "translate(0, 0)";
}, $7d9b5a7dd4dbaff5$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        skewX *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(a11);
        a21 = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(a21);
        a12 = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(a12);
        a22 = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", x, "px");
        ty = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(tx + xPercent / 100 * temp.width);
        ty = (0, $861618b1eb57e58a$export$9c8d725d65e13f94)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $7d9b5a7dd4dbaff5$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $861618b1eb57e58a$export$f664476fd67145ca)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $7d9b5a7dd4dbaff5$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $861618b1eb57e58a$export$3a67f7f44b1e838a)(plugin._pt, target, property, startNum, change, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $7d9b5a7dd4dbaff5$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $7d9b5a7dd4dbaff5$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$7d9b5a7dd4dbaff5$var$_transformProp];
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = startValue;
    }
    for(p in $7d9b5a7dd4dbaff5$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $861618b1eb57e58a$export$65f2564e9a9b9222)(startValue);
            endUnit = (0, $861618b1eb57e58a$export$65f2564e9a9b9222)(endValue);
            startNum = startUnit !== endUnit ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $861618b1eb57e58a$export$3a67f7f44b1e838a)(plugin._pt, endCache, p, startNum, endNum - startNum, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $7d9b5a7dd4dbaff5$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $861618b1eb57e58a$export$f9000b814859f126)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $7d9b5a7dd4dbaff5$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $7d9b5a7dd4dbaff5$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $7d9b5a7dd4dbaff5$export$855822f522f18eef = {
    name: "css",
    register: $7d9b5a7dd4dbaff5$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $7d9b5a7dd4dbaff5$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $861618b1eb57e58a$export$d305d8ec5d7c26b8)[p] && (0, $861618b1eb57e58a$export$5c457b74208010cf)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $7d9b5a7dd4dbaff5$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $861618b1eb57e58a$export$d5962a97e3cde94d)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $861618b1eb57e58a$export$dd733e62515be2bd).lastIndex = 0;
                if (!(0, $861618b1eb57e58a$export$dd733e62515be2bd).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $861618b1eb57e58a$export$65f2564e9a9b9222)(startValue);
                    endUnit = (0, $861618b1eb57e58a$export$65f2564e9a9b9222)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $861618b1eb57e58a$export$f664476fd67145ca)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $861618b1eb57e58a$export$d5962a97e3cde94d)(startValue));
                    (0, $861618b1eb57e58a$export$65f2564e9a9b9222)(startValue + "") || (startValue += (0, $861618b1eb57e58a$export$4922bee768729a77).units[p] || (0, $861618b1eb57e58a$export$65f2564e9a9b9222)($7d9b5a7dd4dbaff5$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $7d9b5a7dd4dbaff5$var$_get(target, p)); // can't work with relative values
                } else startValue = $7d9b5a7dd4dbaff5$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $7d9b5a7dd4dbaff5$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $7d9b5a7dd4dbaff5$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $7d9b5a7dd4dbaff5$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $7d9b5a7dd4dbaff5$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $7d9b5a7dd4dbaff5$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $861618b1eb57e58a$export$3a67f7f44b1e838a)(this._pt, style, $7d9b5a7dd4dbaff5$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $861618b1eb57e58a$export$3a67f7f44b1e838a)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $861618b1eb57e58a$export$dac762bc6301b560)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, 0, style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]);
                        endValue = $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, p, $7d9b5a7dd4dbaff5$var$_firstTwoOnly(startValue), $7d9b5a7dd4dbaff5$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $7d9b5a7dd4dbaff5$var$_rotationalProperties) {
                        $7d9b5a7dd4dbaff5$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $861618b1eb57e58a$export$dac762bc6301b560)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $7d9b5a7dd4dbaff5$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$7d9b5a7dd4dbaff5$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $861618b1eb57e58a$export$65f2564e9a9b9222)(endValue) || (p in (0, $861618b1eb57e58a$export$4922bee768729a77).units ? (0, $861618b1eb57e58a$export$4922bee768729a77).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $861618b1eb57e58a$export$3a67f7f44b1e838a)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $861618b1eb57e58a$export$dac762bc6301b560)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp : $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $861618b1eb57e58a$export$7fb54635790b59a5)(p, endValue);
                        continue;
                    }
                } else $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $861618b1eb57e58a$export$eed5824f53346d57)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$7d9b5a7dd4dbaff5$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $7d9b5a7dd4dbaff5$var$_get,
    aliases: $7d9b5a7dd4dbaff5$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp && (target._gsap.x || $7d9b5a7dd4dbaff5$var$_get(target, "x")) ? plugin && $7d9b5a7dd4dbaff5$var$_recentSetterPlugin === plugin ? property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScale : $7d9b5a7dd4dbaff5$var$_setterTransform : ($7d9b5a7dd4dbaff5$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScaleWithRender : $7d9b5a7dd4dbaff5$var$_setterTransformWithRender) : target.style && !(0, $861618b1eb57e58a$export$a8178c063a9fd3a1)(target.style[property]) ? $7d9b5a7dd4dbaff5$var$_setterCSSStyle : ~property.indexOf("-") ? $7d9b5a7dd4dbaff5$var$_setterCSSProp : (0, $861618b1eb57e58a$export$d60fbc1e0278aaf0)(target, property);
    },
    core: {
        _removeProperty: $7d9b5a7dd4dbaff5$var$_removeProperty,
        _getMatrix: $7d9b5a7dd4dbaff5$var$_getMatrix
    }
};
(0, $861618b1eb57e58a$export$99ee26438460406a).utils.checkPrefix = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b;
(0, $861618b1eb57e58a$export$99ee26438460406a).core.getStyleSaver = $7d9b5a7dd4dbaff5$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $861618b1eb57e58a$export$f9000b814859f126)(positionAndScale + "," + rotation + "," + others, function(name) {
        $7d9b5a7dd4dbaff5$var$_transformProps[name] = 1;
    });
    (0, $861618b1eb57e58a$export$f9000b814859f126)(rotation, function(name) {
        (0, $861618b1eb57e58a$export$4922bee768729a77).units[name] = "deg";
        $7d9b5a7dd4dbaff5$var$_rotationalProperties[name] = 1;
    });
    $7d9b5a7dd4dbaff5$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $861618b1eb57e58a$export$f9000b814859f126)(aliases, function(name) {
        var split = name.split(":");
        $7d9b5a7dd4dbaff5$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $861618b1eb57e58a$export$f9000b814859f126)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $861618b1eb57e58a$export$4922bee768729a77).units[name] = "px";
});
(0, $861618b1eb57e58a$export$99ee26438460406a).registerPlugin($7d9b5a7dd4dbaff5$export$855822f522f18eef);


var $1974f63041948ee8$export$99ee26438460406a = (0, $861618b1eb57e58a$export$99ee26438460406a).registerPlugin((0, $7d9b5a7dd4dbaff5$export$855822f522f18eef)) || (0, $861618b1eb57e58a$export$99ee26438460406a), // to protect from tree shaking
$1974f63041948ee8$export$7b23975ad686bf91 = $1974f63041948ee8$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $7e9d8e753943228a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7e9d8e753943228a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7e9d8e753943228a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7e9d8e753943228a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $7e9d8e753943228a$var$gsap, $7e9d8e753943228a$var$_coreInitted, $7e9d8e753943228a$var$_clamp, $7e9d8e753943228a$var$_win, $7e9d8e753943228a$var$_doc, $7e9d8e753943228a$var$_docEl, $7e9d8e753943228a$var$_body, $7e9d8e753943228a$var$_isTouch, $7e9d8e753943228a$var$_pointerType, $7e9d8e753943228a$var$ScrollTrigger, $7e9d8e753943228a$var$_root, $7e9d8e753943228a$var$_normalizer, $7e9d8e753943228a$var$_eventTypes, $7e9d8e753943228a$var$_context, $7e9d8e753943228a$var$_getGSAP = function _getGSAP() {
    return $7e9d8e753943228a$var$gsap || typeof window !== "undefined" && ($7e9d8e753943228a$var$gsap = window.gsap) && $7e9d8e753943228a$var$gsap.registerPlugin && $7e9d8e753943228a$var$gsap;
}, $7e9d8e753943228a$var$_startup = 1, $7e9d8e753943228a$var$_observers = [], $7e9d8e753943228a$export$3cd1cee43d19b683 = [], $7e9d8e753943228a$export$d8e56d510a804d0a = [], $7e9d8e753943228a$var$_getTime = Date.now, $7e9d8e753943228a$var$_bridge = function _bridge(name, value) {
    return value;
}, $7e9d8e753943228a$var$_integrate = function _integrate() {
    var core = $7e9d8e753943228a$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $7e9d8e753943228a$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $7e9d8e753943228a$export$d8e56d510a804d0a);
    $7e9d8e753943228a$export$3cd1cee43d19b683 = scrollers;
    $7e9d8e753943228a$export$d8e56d510a804d0a = proxies;
    $7e9d8e753943228a$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $7e9d8e753943228a$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$7e9d8e753943228a$export$d8e56d510a804d0a.indexOf(element) && $7e9d8e753943228a$export$d8e56d510a804d0a[$7e9d8e753943228a$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $7e9d8e753943228a$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$7e9d8e753943228a$var$_root.indexOf(el);
}, $7e9d8e753943228a$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $7e9d8e753943228a$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $7e9d8e753943228a$var$_scrollLeft = "scrollLeft", $7e9d8e753943228a$var$_scrollTop = "scrollTop", $7e9d8e753943228a$var$_onScroll = function _onScroll() {
    return $7e9d8e753943228a$var$_normalizer && $7e9d8e753943228a$var$_normalizer.isPressed || $7e9d8e753943228a$export$3cd1cee43d19b683.cache++;
}, $7e9d8e753943228a$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $7e9d8e753943228a$var$_startup && ($7e9d8e753943228a$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $7e9d8e753943228a$var$_normalizer && $7e9d8e753943228a$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($7e9d8e753943228a$var$_normalizer && $7e9d8e753943228a$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $7e9d8e753943228a$export$3cd1cee43d19b683.cache;
            isNormalizing && $7e9d8e753943228a$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $7e9d8e753943228a$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $7e9d8e753943228a$var$_bridge("ref")) {
            cachingFunc.cacheID = $7e9d8e753943228a$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $7e9d8e753943228a$export$b2cabb342cb0ebe1 = {
    s: $7e9d8e753943228a$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $7e9d8e753943228a$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $7e9d8e753943228a$var$_win.scrollTo(value, $7e9d8e753943228a$export$8e40fc98ff518e9d.sc()) : $7e9d8e753943228a$var$_win.pageXOffset || $7e9d8e753943228a$var$_doc[$7e9d8e753943228a$var$_scrollLeft] || $7e9d8e753943228a$var$_docEl[$7e9d8e753943228a$var$_scrollLeft] || $7e9d8e753943228a$var$_body[$7e9d8e753943228a$var$_scrollLeft] || 0;
    })
}, $7e9d8e753943228a$export$8e40fc98ff518e9d = {
    s: $7e9d8e753943228a$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $7e9d8e753943228a$export$b2cabb342cb0ebe1,
    sc: $7e9d8e753943228a$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $7e9d8e753943228a$var$_win.scrollTo($7e9d8e753943228a$export$b2cabb342cb0ebe1.sc(), value) : $7e9d8e753943228a$var$_win.pageYOffset || $7e9d8e753943228a$var$_doc[$7e9d8e753943228a$var$_scrollTop] || $7e9d8e753943228a$var$_docEl[$7e9d8e753943228a$var$_scrollTop] || $7e9d8e753943228a$var$_body[$7e9d8e753943228a$var$_scrollTop] || 0;
    })
}, $7e9d8e753943228a$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $7e9d8e753943228a$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $7e9d8e753943228a$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $7e9d8e753943228a$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $7e9d8e753943228a$export$4330f3a92e5d2e94(element) && (element = $7e9d8e753943228a$var$_doc.scrollingElement || $7e9d8e753943228a$var$_docEl);
    var i = $7e9d8e753943228a$export$3cd1cee43d19b683.indexOf(element), offset = sc === $7e9d8e753943228a$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $7e9d8e753943228a$export$3cd1cee43d19b683.push(element) - 1);
    $7e9d8e753943228a$export$3cd1cee43d19b683[i + offset] || $7e9d8e753943228a$var$_addListener(element, "scroll", $7e9d8e753943228a$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $7e9d8e753943228a$export$3cd1cee43d19b683[i + offset], func = prev || ($7e9d8e753943228a$export$3cd1cee43d19b683[i + offset] = $7e9d8e753943228a$var$_scrollCacheFunc($7e9d8e753943228a$export$6078f1ef08b38af9(element, s), true) || ($7e9d8e753943228a$export$4330f3a92e5d2e94(element) ? sc : $7e9d8e753943228a$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $7e9d8e753943228a$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $7e9d8e753943228a$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $7e9d8e753943228a$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $7e9d8e753943228a$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $7e9d8e753943228a$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $7e9d8e753943228a$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $7e9d8e753943228a$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $7e9d8e753943228a$var$_setScrollTrigger = function _setScrollTrigger() {
    $7e9d8e753943228a$var$ScrollTrigger = $7e9d8e753943228a$var$gsap.core.globals().ScrollTrigger;
    $7e9d8e753943228a$var$ScrollTrigger && $7e9d8e753943228a$var$ScrollTrigger.core && $7e9d8e753943228a$var$_integrate();
}, $7e9d8e753943228a$var$_initCore = function _initCore(core) {
    $7e9d8e753943228a$var$gsap = core || $7e9d8e753943228a$var$_getGSAP();
    if ($7e9d8e753943228a$var$gsap && typeof document !== "undefined" && document.body) {
        $7e9d8e753943228a$var$_win = window;
        $7e9d8e753943228a$var$_doc = document;
        $7e9d8e753943228a$var$_docEl = $7e9d8e753943228a$var$_doc.documentElement;
        $7e9d8e753943228a$var$_body = $7e9d8e753943228a$var$_doc.body;
        $7e9d8e753943228a$var$_root = [
            $7e9d8e753943228a$var$_win,
            $7e9d8e753943228a$var$_doc,
            $7e9d8e753943228a$var$_docEl,
            $7e9d8e753943228a$var$_body
        ];
        $7e9d8e753943228a$var$_clamp = $7e9d8e753943228a$var$gsap.utils.clamp;
        $7e9d8e753943228a$var$_context = $7e9d8e753943228a$var$gsap.core.context || function() {};
        $7e9d8e753943228a$var$_pointerType = "onpointerenter" in $7e9d8e753943228a$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $7e9d8e753943228a$var$_isTouch = $7e9d8e753943228a$export$c1cbdee04e18ea8b.isTouch = $7e9d8e753943228a$var$_win.matchMedia && $7e9d8e753943228a$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $7e9d8e753943228a$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $7e9d8e753943228a$var$_eventTypes = $7e9d8e753943228a$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $7e9d8e753943228a$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $7e9d8e753943228a$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $7e9d8e753943228a$var$_startup = 0;
        }, 500);
        $7e9d8e753943228a$var$_setScrollTrigger();
        $7e9d8e753943228a$var$_coreInitted = 1;
    }
    return $7e9d8e753943228a$var$_coreInitted;
};
$7e9d8e753943228a$export$b2cabb342cb0ebe1.op = $7e9d8e753943228a$export$8e40fc98ff518e9d;
$7e9d8e753943228a$export$3cd1cee43d19b683.cache = 0;
var $7e9d8e753943228a$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $7e9d8e753943228a$var$_coreInitted || $7e9d8e753943228a$var$_initCore($7e9d8e753943228a$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $7e9d8e753943228a$var$ScrollTrigger || $7e9d8e753943228a$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $7e9d8e753943228a$export$937374fea3f88711(target) || $7e9d8e753943228a$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $7e9d8e753943228a$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($7e9d8e753943228a$var$_win.getComputedStyle($7e9d8e753943228a$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, scrollFuncX = $7e9d8e753943228a$export$8665aac53dad5647(target, $7e9d8e753943228a$export$b2cabb342cb0ebe1), scrollFuncY = $7e9d8e753943228a$export$8665aac53dad5647(target, $7e9d8e753943228a$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $7e9d8e753943228a$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $7e9d8e753943228a$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $7e9d8e753943228a$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $7e9d8e753943228a$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $7e9d8e753943228a$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $7e9d8e753943228a$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $7e9d8e753943228a$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $7e9d8e753943228a$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $7e9d8e753943228a$var$_addListener(isNormalizer ? target : ownerDoc, $7e9d8e753943228a$var$_eventTypes[1], _onDrag, preventDefault, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $7e9d8e753943228a$var$_removeListener(isNormalizer ? target : ownerDoc, $7e9d8e753943228a$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $7e9d8e753943228a$var$_getEvent(e);
            if (!wasDragging && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset();
                if (preventDefault && allowClicks) $7e9d8e753943228a$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($7e9d8e753943228a$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $7e9d8e753943228a$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, wasDragging);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $7e9d8e753943228a$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $7e9d8e753943228a$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $7e9d8e753943228a$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $7e9d8e753943228a$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $7e9d8e753943228a$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $7e9d8e753943228a$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $7e9d8e753943228a$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $7e9d8e753943228a$var$_addListener(isViewport ? ownerDoc : target, "scroll", $7e9d8e753943228a$var$_onScroll);
                type.indexOf("scroll") >= 0 && $7e9d8e753943228a$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, preventDefault, capture);
                type.indexOf("wheel") >= 0 && $7e9d8e753943228a$var$_addListener(target, "wheel", _onWheel, preventDefault, capture);
                if (type.indexOf("touch") >= 0 && $7e9d8e753943228a$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $7e9d8e753943228a$var$_addListener(target, $7e9d8e753943228a$var$_eventTypes[0], _onPress, preventDefault, capture);
                    $7e9d8e753943228a$var$_addListener(ownerDoc, $7e9d8e753943228a$var$_eventTypes[2], _onRelease);
                    $7e9d8e753943228a$var$_addListener(ownerDoc, $7e9d8e753943228a$var$_eventTypes[3], _onRelease);
                    allowClicks && $7e9d8e753943228a$var$_addListener(target, "click", clickCapture, false, true);
                    onClick && $7e9d8e753943228a$var$_addListener(target, "click", _onClick);
                    onGestureStart && $7e9d8e753943228a$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $7e9d8e753943228a$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $7e9d8e753943228a$var$_addListener(target, $7e9d8e753943228a$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $7e9d8e753943228a$var$_addListener(target, $7e9d8e753943228a$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $7e9d8e753943228a$var$_addListener(target, $7e9d8e753943228a$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $7e9d8e753943228a$var$_observers.filter(function(o) {
                    return o !== self && $7e9d8e753943228a$export$4330f3a92e5d2e94(o.target);
                }).length || $7e9d8e753943228a$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $7e9d8e753943228a$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $7e9d8e753943228a$var$_removeListener(isNormalizer ? target : ownerDoc, $7e9d8e753943228a$var$_eventTypes[1], _onDrag, true);
                }
                $7e9d8e753943228a$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $7e9d8e753943228a$var$_removeListener(target, "wheel", _onWheel, capture);
                $7e9d8e753943228a$var$_removeListener(target, $7e9d8e753943228a$var$_eventTypes[0], _onPress, capture);
                $7e9d8e753943228a$var$_removeListener(ownerDoc, $7e9d8e753943228a$var$_eventTypes[2], _onRelease);
                $7e9d8e753943228a$var$_removeListener(ownerDoc, $7e9d8e753943228a$var$_eventTypes[3], _onRelease);
                $7e9d8e753943228a$var$_removeListener(target, "click", clickCapture, true);
                $7e9d8e753943228a$var$_removeListener(target, "click", _onClick);
                $7e9d8e753943228a$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $7e9d8e753943228a$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $7e9d8e753943228a$var$_removeListener(target, $7e9d8e753943228a$var$_pointerType + "enter", _onHover);
                $7e9d8e753943228a$var$_removeListener(target, $7e9d8e753943228a$var$_pointerType + "leave", _onHoverEnd);
                $7e9d8e753943228a$var$_removeListener(target, $7e9d8e753943228a$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $7e9d8e753943228a$var$_observers.indexOf(self);
            i >= 0 && $7e9d8e753943228a$var$_observers.splice(i, 1);
            $7e9d8e753943228a$var$_normalizer === self && ($7e9d8e753943228a$var$_normalizer = 0);
        };
        $7e9d8e753943228a$var$_observers.push(self);
        isNormalizer && $7e9d8e753943228a$export$4330f3a92e5d2e94(target) && ($7e9d8e753943228a$var$_normalizer = self);
        self.enable(event);
    };
    $7e9d8e753943228a$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$7e9d8e753943228a$export$c1cbdee04e18ea8b.version = "3.12.2";
$7e9d8e753943228a$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $7e9d8e753943228a$export$c1cbdee04e18ea8b(vars);
};
$7e9d8e753943228a$export$c1cbdee04e18ea8b.register = $7e9d8e753943228a$var$_initCore;
$7e9d8e753943228a$export$c1cbdee04e18ea8b.getAll = function() {
    return $7e9d8e753943228a$var$_observers.slice();
};
$7e9d8e753943228a$export$c1cbdee04e18ea8b.getById = function(id) {
    return $7e9d8e753943228a$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$7e9d8e753943228a$var$_getGSAP() && $7e9d8e753943228a$var$gsap.registerPlugin($7e9d8e753943228a$export$c1cbdee04e18ea8b);


var $cff96cc64f639998$var$gsap, $cff96cc64f639998$var$_coreInitted, $cff96cc64f639998$var$_win, $cff96cc64f639998$var$_doc, $cff96cc64f639998$var$_docEl, $cff96cc64f639998$var$_body, $cff96cc64f639998$var$_root, $cff96cc64f639998$var$_resizeDelay, $cff96cc64f639998$var$_toArray, $cff96cc64f639998$var$_clamp, $cff96cc64f639998$var$_time2, $cff96cc64f639998$var$_syncInterval, $cff96cc64f639998$var$_refreshing, $cff96cc64f639998$var$_pointerIsDown, $cff96cc64f639998$var$_transformProp, $cff96cc64f639998$var$_i, $cff96cc64f639998$var$_prevWidth, $cff96cc64f639998$var$_prevHeight, $cff96cc64f639998$var$_autoRefresh, $cff96cc64f639998$var$_sort, $cff96cc64f639998$var$_suppressOverwrites, $cff96cc64f639998$var$_ignoreResize, $cff96cc64f639998$var$_normalizer, $cff96cc64f639998$var$_ignoreMobileResize, $cff96cc64f639998$var$_baseScreenHeight, $cff96cc64f639998$var$_baseScreenWidth, $cff96cc64f639998$var$_fixIOSBug, $cff96cc64f639998$var$_context, $cff96cc64f639998$var$_scrollRestoration, $cff96cc64f639998$var$_div100vh, $cff96cc64f639998$var$_100vh, $cff96cc64f639998$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$cff96cc64f639998$var$_startup = 1, $cff96cc64f639998$var$_getTime = Date.now, $cff96cc64f639998$var$_time1 = $cff96cc64f639998$var$_getTime(), $cff96cc64f639998$var$_lastScrollTime = 0, $cff96cc64f639998$var$_enabled = 0, $cff96cc64f639998$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $cff96cc64f639998$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $cff96cc64f639998$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$cff96cc64f639998$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $cff96cc64f639998$var$_rafBugFix = function _rafBugFix() {
    return $cff96cc64f639998$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$cff96cc64f639998$var$_pointerDownHandler = function _pointerDownHandler() {
    return $cff96cc64f639998$var$_pointerIsDown = 1;
}, $cff96cc64f639998$var$_pointerUpHandler = function _pointerUpHandler() {
    return $cff96cc64f639998$var$_pointerIsDown = 0;
}, $cff96cc64f639998$var$_passThrough = function _passThrough(v) {
    return v;
}, $cff96cc64f639998$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $cff96cc64f639998$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $cff96cc64f639998$var$_getGSAP = function _getGSAP() {
    return $cff96cc64f639998$var$gsap || $cff96cc64f639998$var$_windowExists() && ($cff96cc64f639998$var$gsap = window.gsap) && $cff96cc64f639998$var$gsap.registerPlugin && $cff96cc64f639998$var$gsap;
}, $cff96cc64f639998$var$_isViewport = function _isViewport(e) {
    return !!~$cff96cc64f639998$var$_root.indexOf(e);
}, $cff96cc64f639998$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $cff96cc64f639998$var$_100vh : $cff96cc64f639998$var$_win["inner" + dimensionProperty]) || $cff96cc64f639998$var$_docEl["client" + dimensionProperty] || $cff96cc64f639998$var$_body["client" + dimensionProperty];
}, $cff96cc64f639998$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($cff96cc64f639998$var$_isViewport(element) ? function() {
        $cff96cc64f639998$var$_winOffsets.width = $cff96cc64f639998$var$_win.innerWidth;
        $cff96cc64f639998$var$_winOffsets.height = $cff96cc64f639998$var$_100vh;
        return $cff96cc64f639998$var$_winOffsets;
    } : function() {
        return $cff96cc64f639998$var$_getBounds(element);
    });
}, $cff96cc64f639998$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $cff96cc64f639998$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $cff96cc64f639998$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $7e9d8e753943228a$export$d8e56d510a804d0a).indexOf(element) ? $cff96cc64f639998$var$_getBoundsFunc(element) : function() {
        return $cff96cc64f639998$var$_winOffsets;
    };
}, $cff96cc64f639998$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(element, s)) ? a() - $cff96cc64f639998$var$_getBoundsFunc(element)()[d] : $cff96cc64f639998$var$_isViewport(element) ? ($cff96cc64f639998$var$_docEl[s] || $cff96cc64f639998$var$_body[s]) - $cff96cc64f639998$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $cff96cc64f639998$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $cff96cc64f639998$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($cff96cc64f639998$var$_autoRefresh[i + 1])) && func($cff96cc64f639998$var$_autoRefresh[i], $cff96cc64f639998$var$_autoRefresh[i + 1], $cff96cc64f639998$var$_autoRefresh[i + 2]);
}, $cff96cc64f639998$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $cff96cc64f639998$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $cff96cc64f639998$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $cff96cc64f639998$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $cff96cc64f639998$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $cff96cc64f639998$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $cff96cc64f639998$var$_abs = Math.abs, $cff96cc64f639998$var$_left = "left", $cff96cc64f639998$var$_top = "top", $cff96cc64f639998$var$_right = "right", $cff96cc64f639998$var$_bottom = "bottom", $cff96cc64f639998$var$_width = "width", $cff96cc64f639998$var$_height = "height", $cff96cc64f639998$var$_Right = "Right", $cff96cc64f639998$var$_Left = "Left", $cff96cc64f639998$var$_Top = "Top", $cff96cc64f639998$var$_Bottom = "Bottom", $cff96cc64f639998$var$_padding = "padding", $cff96cc64f639998$var$_margin = "margin", $cff96cc64f639998$var$_Width = "Width", $cff96cc64f639998$var$_Height = "Height", $cff96cc64f639998$var$_px = "px", $cff96cc64f639998$var$_getComputedStyle = function _getComputedStyle(element) {
    return $cff96cc64f639998$var$_win.getComputedStyle(element);
}, $cff96cc64f639998$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $cff96cc64f639998$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $cff96cc64f639998$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $cff96cc64f639998$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $cff96cc64f639998$var$_getComputedStyle(element)[$cff96cc64f639998$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $cff96cc64f639998$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $cff96cc64f639998$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $cff96cc64f639998$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $cff96cc64f639998$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $cff96cc64f639998$var$gsap.utils.snap($cff96cc64f639998$var$_getLabelRatioArray(animation), value);
    };
}, $cff96cc64f639998$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $cff96cc64f639998$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $cff96cc64f639998$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $cff96cc64f639998$var$_snapDirectional($cff96cc64f639998$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $cff96cc64f639998$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $cff96cc64f639998$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $cff96cc64f639998$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $cff96cc64f639998$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $cff96cc64f639998$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $cff96cc64f639998$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $cff96cc64f639998$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $cff96cc64f639998$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($cff96cc64f639998$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $cff96cc64f639998$var$_keywords ? $cff96cc64f639998$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $cff96cc64f639998$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $cff96cc64f639998$var$_doc.createElement("div"), useFixedPosition = $cff96cc64f639998$var$_isViewport(container) || (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $cff96cc64f639998$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $7e9d8e753943228a$export$8e40fc98ff518e9d) ? $cff96cc64f639998$var$_right : $cff96cc64f639998$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $cff96cc64f639998$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $cff96cc64f639998$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $cff96cc64f639998$var$_Width] = 1;
    vars["border" + oppositeSide + $cff96cc64f639998$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $cff96cc64f639998$var$gsap.set(marker, vars);
}, $cff96cc64f639998$var$_triggers = [], $cff96cc64f639998$var$_ids = {}, $cff96cc64f639998$var$_rafID, $cff96cc64f639998$var$_sync = function _sync() {
    return $cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_lastScrollTime > 34 && ($cff96cc64f639998$var$_rafID || ($cff96cc64f639998$var$_rafID = requestAnimationFrame($cff96cc64f639998$var$_updateAll)));
}, $cff96cc64f639998$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$cff96cc64f639998$var$_normalizer || !$cff96cc64f639998$var$_normalizer.isPressed || $cff96cc64f639998$var$_normalizer.startX > $cff96cc64f639998$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++;
        if ($cff96cc64f639998$var$_normalizer) $cff96cc64f639998$var$_rafID || ($cff96cc64f639998$var$_rafID = requestAnimationFrame($cff96cc64f639998$var$_updateAll));
        else $cff96cc64f639998$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $cff96cc64f639998$var$_lastScrollTime || $cff96cc64f639998$var$_dispatch("scrollStart");
        $cff96cc64f639998$var$_lastScrollTime = $cff96cc64f639998$var$_getTime();
    }
}, $cff96cc64f639998$var$_setBaseDimensions = function _setBaseDimensions() {
    $cff96cc64f639998$var$_baseScreenWidth = $cff96cc64f639998$var$_win.innerWidth;
    $cff96cc64f639998$var$_baseScreenHeight = $cff96cc64f639998$var$_win.innerHeight;
}, $cff96cc64f639998$var$_onResize = function _onResize() {
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++;
    !$cff96cc64f639998$var$_refreshing && !$cff96cc64f639998$var$_ignoreResize && !$cff96cc64f639998$var$_doc.fullscreenElement && !$cff96cc64f639998$var$_doc.webkitFullscreenElement && (!$cff96cc64f639998$var$_ignoreMobileResize || $cff96cc64f639998$var$_baseScreenWidth !== $cff96cc64f639998$var$_win.innerWidth || Math.abs($cff96cc64f639998$var$_win.innerHeight - $cff96cc64f639998$var$_baseScreenHeight) > $cff96cc64f639998$var$_win.innerHeight * 0.25) && $cff96cc64f639998$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$cff96cc64f639998$var$_listeners = {}, $cff96cc64f639998$var$_emptyArray = [], $cff96cc64f639998$var$_softRefresh = function _softRefresh() {
    return $cff96cc64f639998$var$_removeListener($cff96cc64f639998$export$875bcbe48555930, "scrollEnd", _softRefresh) || $cff96cc64f639998$var$_refreshAll(true);
}, $cff96cc64f639998$var$_dispatch = function _dispatch(type) {
    return $cff96cc64f639998$var$_listeners[type] && $cff96cc64f639998$var$_listeners[type].map(function(f) {
        return f();
    }) || $cff96cc64f639998$var$_emptyArray;
}, $cff96cc64f639998$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$cff96cc64f639998$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $cff96cc64f639998$var$_savedStyles.length; i += 5)if (!media || $cff96cc64f639998$var$_savedStyles[i + 4] && $cff96cc64f639998$var$_savedStyles[i + 4].query === media) {
        $cff96cc64f639998$var$_savedStyles[i].style.cssText = $cff96cc64f639998$var$_savedStyles[i + 1];
        $cff96cc64f639998$var$_savedStyles[i].getBBox && $cff96cc64f639998$var$_savedStyles[i].setAttribute("transform", $cff96cc64f639998$var$_savedStyles[i + 2] || "");
        $cff96cc64f639998$var$_savedStyles[i + 3].uncache = 1;
    }
}, $cff96cc64f639998$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($cff96cc64f639998$var$_i = 0; $cff96cc64f639998$var$_i < $cff96cc64f639998$var$_triggers.length; $cff96cc64f639998$var$_i++){
        trigger = $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    media && $cff96cc64f639998$var$_revertRecorded(media);
    media || $cff96cc64f639998$var$_dispatch("revert");
}, $cff96cc64f639998$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++;
    (force || !$cff96cc64f639998$var$_refreshingAll) && (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(obj) {
        return $cff96cc64f639998$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $cff96cc64f639998$var$_isString(scrollRestoration) && ($cff96cc64f639998$var$_win.history.scrollRestoration = $cff96cc64f639998$var$_scrollRestoration = scrollRestoration);
}, $cff96cc64f639998$var$_refreshingAll, $cff96cc64f639998$var$_refreshID = 0, $cff96cc64f639998$var$_queueRefreshID, $cff96cc64f639998$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($cff96cc64f639998$var$_queueRefreshID !== $cff96cc64f639998$var$_refreshID) {
        var id = $cff96cc64f639998$var$_queueRefreshID = $cff96cc64f639998$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $cff96cc64f639998$var$_refreshID && $cff96cc64f639998$var$_refreshAll(true);
        });
    }
}, $cff96cc64f639998$var$_refresh100vh = function _refresh100vh() {
    $cff96cc64f639998$var$_body.appendChild($cff96cc64f639998$var$_div100vh);
    $cff96cc64f639998$var$_100vh = $cff96cc64f639998$var$_div100vh.offsetHeight || $cff96cc64f639998$var$_win.innerHeight;
    $cff96cc64f639998$var$_body.removeChild($cff96cc64f639998$var$_div100vh);
}, $cff96cc64f639998$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($cff96cc64f639998$var$_lastScrollTime && !force) {
        $cff96cc64f639998$var$_addListener($cff96cc64f639998$export$875bcbe48555930, "scrollEnd", $cff96cc64f639998$var$_softRefresh);
        return;
    }
    $cff96cc64f639998$var$_refresh100vh();
    $cff96cc64f639998$var$_refreshingAll = $cff96cc64f639998$export$875bcbe48555930.isRefreshing = true;
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(obj) {
        return $cff96cc64f639998$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $cff96cc64f639998$var$_dispatch("refreshInit");
    $cff96cc64f639998$var$_sort && $cff96cc64f639998$export$875bcbe48555930.sort();
    skipRevert || $cff96cc64f639998$var$_revertAll();
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($cff96cc64f639998$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $cff96cc64f639998$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $cff96cc64f639998$var$_triggers.forEach(function(t, i) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $cff96cc64f639998$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $cff96cc64f639998$var$_maxScroll(t.scroller, t._dir);
        (t.vars.end === "max" || t._endClamp && t.end > max) && t.setPositions(t.start, Math.max(t.start + 1, max), true);
    });
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($cff96cc64f639998$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $cff96cc64f639998$var$_clearScrollMemory($cff96cc64f639998$var$_scrollRestoration, 1);
    $cff96cc64f639998$var$_resizeDelay.pause();
    $cff96cc64f639998$var$_refreshID++;
    $cff96cc64f639998$var$_refreshingAll = 2;
    $cff96cc64f639998$var$_updateAll(2);
    $cff96cc64f639998$var$_triggers.forEach(function(t) {
        return $cff96cc64f639998$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $cff96cc64f639998$var$_refreshingAll = $cff96cc64f639998$export$875bcbe48555930.isRefreshing = false;
    $cff96cc64f639998$var$_dispatch("refresh");
}, $cff96cc64f639998$var$_lastScroll = 0, $cff96cc64f639998$var$_direction = 1, $cff96cc64f639998$var$_primary, $cff96cc64f639998$var$_updateAll = function _updateAll(force) {
    if (!$cff96cc64f639998$var$_refreshingAll || force === 2) {
        $cff96cc64f639998$export$875bcbe48555930.isUpdating = true;
        $cff96cc64f639998$var$_primary && $cff96cc64f639998$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $cff96cc64f639998$var$_triggers.length, time = $cff96cc64f639998$var$_getTime(), recordVelocity = time - $cff96cc64f639998$var$_time1 >= 50, scroll = l && $cff96cc64f639998$var$_triggers[0].scroll();
        $cff96cc64f639998$var$_direction = $cff96cc64f639998$var$_lastScroll > scroll ? -1 : 1;
        $cff96cc64f639998$var$_refreshingAll || ($cff96cc64f639998$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($cff96cc64f639998$var$_lastScrollTime && !$cff96cc64f639998$var$_pointerIsDown && time - $cff96cc64f639998$var$_lastScrollTime > 200) {
                $cff96cc64f639998$var$_lastScrollTime = 0;
                $cff96cc64f639998$var$_dispatch("scrollEnd");
            }
            $cff96cc64f639998$var$_time2 = $cff96cc64f639998$var$_time1;
            $cff96cc64f639998$var$_time1 = time;
        }
        if ($cff96cc64f639998$var$_direction < 0) {
            $cff96cc64f639998$var$_i = l;
            while($cff96cc64f639998$var$_i-- > 0)$cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i] && $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i].update(0, recordVelocity);
            $cff96cc64f639998$var$_direction = 1;
        } else for($cff96cc64f639998$var$_i = 0; $cff96cc64f639998$var$_i < l; $cff96cc64f639998$var$_i++)$cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i] && $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_i].update(0, recordVelocity);
        $cff96cc64f639998$export$875bcbe48555930.isUpdating = false;
    }
    $cff96cc64f639998$var$_rafID = 0;
}, $cff96cc64f639998$var$_propNamesToCopy = [
    $cff96cc64f639998$var$_left,
    $cff96cc64f639998$var$_top,
    $cff96cc64f639998$var$_bottom,
    $cff96cc64f639998$var$_right,
    $cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Bottom,
    $cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Right,
    $cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Top,
    $cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $cff96cc64f639998$var$_stateProps = $cff96cc64f639998$var$_propNamesToCopy.concat([
    $cff96cc64f639998$var$_width,
    $cff96cc64f639998$var$_height,
    "boxSizing",
    "max" + $cff96cc64f639998$var$_Width,
    "max" + $cff96cc64f639998$var$_Height,
    "position",
    $cff96cc64f639998$var$_margin,
    $cff96cc64f639998$var$_padding,
    $cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Top,
    $cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Right,
    $cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Bottom,
    $cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Left
]), $cff96cc64f639998$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $cff96cc64f639998$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $cff96cc64f639998$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $cff96cc64f639998$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $cff96cc64f639998$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $cff96cc64f639998$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$cff96cc64f639998$var$_bottom] = pinStyle[$cff96cc64f639998$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$cff96cc64f639998$var$_width] = $cff96cc64f639998$var$_getSize(pin, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1)) + $cff96cc64f639998$var$_px;
        spacerStyle[$cff96cc64f639998$var$_height] = $cff96cc64f639998$var$_getSize(pin, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d)) + $cff96cc64f639998$var$_px;
        spacerStyle[$cff96cc64f639998$var$_padding] = pinStyle[$cff96cc64f639998$var$_margin] = pinStyle[$cff96cc64f639998$var$_top] = pinStyle[$cff96cc64f639998$var$_left] = "0";
        $cff96cc64f639998$var$_setState(spacerState);
        pinStyle[$cff96cc64f639998$var$_width] = pinStyle["max" + $cff96cc64f639998$var$_Width] = cs[$cff96cc64f639998$var$_width];
        pinStyle[$cff96cc64f639998$var$_height] = pinStyle["max" + $cff96cc64f639998$var$_Height] = cs[$cff96cc64f639998$var$_height];
        pinStyle[$cff96cc64f639998$var$_padding] = cs[$cff96cc64f639998$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $cff96cc64f639998$var$_capsExp = /([A-Z])/g, $cff96cc64f639998$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $cff96cc64f639998$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($cff96cc64f639998$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $cff96cc64f639998$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $cff96cc64f639998$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($cff96cc64f639998$var$_stateProps[i], style[$cff96cc64f639998$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $cff96cc64f639998$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $cff96cc64f639998$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$cff96cc64f639998$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $cff96cc64f639998$var$_isFunction(value) && (value = value(self));
    if ($cff96cc64f639998$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $cff96cc64f639998$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$cff96cc64f639998$var$_isNumber(value)) {
        $cff96cc64f639998$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $7e9d8e753943228a$export$937374fea3f88711)(trigger, self) || $cff96cc64f639998$var$_body;
        bounds = $cff96cc64f639998$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $cff96cc64f639998$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $cff96cc64f639998$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $cff96cc64f639998$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $cff96cc64f639998$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $cff96cc64f639998$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $cff96cc64f639998$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $cff96cc64f639998$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $cff96cc64f639998$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($cff96cc64f639998$var$_body[p1], $cff96cc64f639998$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $cff96cc64f639998$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $cff96cc64f639998$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $cff96cc64f639998$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $cff96cc64f639998$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $cff96cc64f639998$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $cff96cc64f639998$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $cff96cc64f639998$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $cff96cc64f639998$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$cff96cc64f639998$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $cff96cc64f639998$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $cff96cc64f639998$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $cff96cc64f639998$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $cff96cc64f639998$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$cff96cc64f639998$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $7e9d8e753943228a$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $cff96cc64f639998$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++;
            $cff96cc64f639998$var$_updateAll();
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $cff96cc64f639998$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $cff96cc64f639998$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $cff96cc64f639998$export$875bcbe48555930.isTouch && $cff96cc64f639998$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $cff96cc64f639998$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $cff96cc64f639998$var$_coreInitted || ScrollTrigger.register($cff96cc64f639998$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $cff96cc64f639998$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$cff96cc64f639998$var$_enabled) {
            this.update = this.refresh = this.kill = $cff96cc64f639998$var$_passThrough;
            return;
        }
        vars = $cff96cc64f639998$var$_setDefaults($cff96cc64f639998$var$_isString(vars) || $cff96cc64f639998$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $cff96cc64f639998$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1) : (0, $7e9d8e753943228a$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $7e9d8e753943228a$export$937374fea3f88711)(vars.scroller || $cff96cc64f639998$var$_win), scrollerCache = $cff96cc64f639998$var$gsap.core.getCache(scroller), isViewport = $cff96cc64f639998$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $cff96cc64f639998$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($cff96cc64f639998$var$_getComputedStyle(scroller)["border" + direction.p2 + $cff96cc64f639998$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $cff96cc64f639998$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $cff96cc64f639998$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $7e9d8e753943228a$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $cff96cc64f639998$var$_sort = 1;
            vars.refreshPriority === -9999 && ($cff96cc64f639998$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $cff96cc64f639998$var$_getTweenCreator(scroller, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d)),
            left: $cff96cc64f639998$var$_getTweenCreator(scroller, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $cff96cc64f639998$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $cff96cc64f639998$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://greensock.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$cff96cc64f639998$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $cff96cc64f639998$var$_body.style && $cff96cc64f639998$var$gsap.set(isViewport ? [
                $cff96cc64f639998$var$_body,
                $cff96cc64f639998$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $7e9d8e753943228a$export$3cd1cee43d19b683).forEach(function(o) {
                return $cff96cc64f639998$var$_isFunction(o) && o.target === (isViewport ? $cff96cc64f639998$var$_doc.scrollingElement || $cff96cc64f639998$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $cff96cc64f639998$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $cff96cc64f639998$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $cff96cc64f639998$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $cff96cc64f639998$var$_snapDirectional(snap.snapTo)(value, $cff96cc64f639998$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $cff96cc64f639998$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $cff96cc64f639998$var$_isObject(snapDurClamp) ? $cff96cc64f639998$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $cff96cc64f639998$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $cff96cc64f639998$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $cff96cc64f639998$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$cff96cc64f639998$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_time2) * 1000 || 0, change1 = $cff96cc64f639998$var$gsap.utils.clamp(-progress, 1 - progress, $cff96cc64f639998$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue = $cff96cc64f639998$var$_clamp(0, 1, snapFunc(naturalEnd, self)), endScroll = Math.round(start + endValue * change), _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $cff96cc64f639998$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($cff96cc64f639998$var$_abs(Math.max($cff96cc64f639998$var$_abs(naturalEnd - totalProgress), $cff96cc64f639998$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $cff96cc64f639998$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($cff96cc64f639998$var$_ids[id] = self);
        trigger = self.trigger = (0, $7e9d8e753943228a$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $7e9d8e753943228a$export$937374fea3f88711)(pin);
        $cff96cc64f639998$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $cff96cc64f639998$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $cff96cc64f639998$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $cff96cc64f639998$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $cff96cc64f639998$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $7e9d8e753943228a$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $cff96cc64f639998$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $cff96cc64f639998$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $cff96cc64f639998$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $cff96cc64f639998$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $cff96cc64f639998$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $cff96cc64f639998$var$gsap.getProperty(pin);
            pinSetter = $cff96cc64f639998$var$gsap.quickSetter(pin, direction.a, $cff96cc64f639998$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $cff96cc64f639998$var$_swapPinIn(pin, spacer, cs);
            pinState = $cff96cc64f639998$var$_getState(pin);
        }
        if (markers) {
            markerVars = $cff96cc64f639998$var$_isObject(markers) ? $cff96cc64f639998$var$_setDefaults(markers, $cff96cc64f639998$var$_markerDefaults) : $cff96cc64f639998$var$_markerDefaults;
            markerStartTrigger = $cff96cc64f639998$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $cff96cc64f639998$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $7e9d8e753943228a$export$937374fea3f88711)((0, $7e9d8e753943228a$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $cff96cc64f639998$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $cff96cc64f639998$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $cff96cc64f639998$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $cff96cc64f639998$var$_px));
            if (!useFixedPosition && !((0, $7e9d8e753943228a$export$d8e56d510a804d0a).length && (0, $7e9d8e753943228a$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $cff96cc64f639998$var$_makePositionable(isViewport ? $cff96cc64f639998$var$_body : scroller);
                $cff96cc64f639998$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $cff96cc64f639998$var$gsap.quickSetter(markerStartTrigger, direction.a, $cff96cc64f639998$var$_px);
                markerEndSetter = $cff96cc64f639998$var$gsap.quickSetter(markerEndTrigger, direction.a, $cff96cc64f639998$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $cff96cc64f639998$var$_triggers[$cff96cc64f639998$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $cff96cc64f639998$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $cff96cc64f639998$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $cff96cc64f639998$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $cff96cc64f639998$var$_swapPinIn(pin, spacer, $cff96cc64f639998$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $cff96cc64f639998$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($cff96cc64f639998$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $cff96cc64f639998$var$_lastScrollTime) {
                $cff96cc64f639998$var$_addListener(ScrollTrigger, "scrollEnd", $cff96cc64f639998$var$_softRefresh);
                return;
            }
            !$cff96cc64f639998$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $cff96cc64f639998$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $cff96cc64f639998$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $cff96cc64f639998$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $cff96cc64f639998$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $7e9d8e753943228a$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $cff96cc64f639998$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $cff96cc64f639998$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $cff96cc64f639998$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $cff96cc64f639998$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $cff96cc64f639998$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($cff96cc64f639998$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $cff96cc64f639998$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $cff96cc64f639998$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $cff96cc64f639998$var$_parseClamp(parsedStart, "start", self);
            start = $cff96cc64f639998$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $cff96cc64f639998$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($cff96cc64f639998$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($cff96cc64f639998$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $cff96cc64f639998$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $cff96cc64f639998$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $cff96cc64f639998$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $cff96cc64f639998$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $cff96cc64f639998$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $cff96cc64f639998$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$cff96cc64f639998$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $cff96cc64f639998$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $cff96cc64f639998$var$gsap.utils.clamp(0, 1, $cff96cc64f639998$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $cff96cc64f639998$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin) {
                cs = $cff96cc64f639998$var$_getComputedStyle(pin);
                isVertical = direction === (0, $7e9d8e753943228a$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://greensock.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $cff96cc64f639998$var$_doc.scrollingElement || $cff96cc64f639998$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $cff96cc64f639998$var$_getComputedStyle($cff96cc64f639998$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $cff96cc64f639998$var$_swapPinIn(pin, spacer, cs);
                pinState = $cff96cc64f639998$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $cff96cc64f639998$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $7e9d8e753943228a$export$8665aac53dad5647)(scroller, isVertical ? (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1) : (0, $7e9d8e753943228a$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $cff96cc64f639998$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $cff96cc64f639998$var$_padding ? $cff96cc64f639998$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    i && spacerState.push(direction.d, i + $cff96cc64f639998$var$_px); // for box-sizing: border-box (must include padding).
                    $cff96cc64f639998$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $cff96cc64f639998$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $cff96cc64f639998$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $cff96cc64f639998$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$cff96cc64f639998$var$_width] = override["max" + $cff96cc64f639998$var$_Width] = Math.ceil(bounds.width) + $cff96cc64f639998$var$_px;
                    override[$cff96cc64f639998$var$_height] = override["max" + $cff96cc64f639998$var$_Height] = Math.ceil(bounds.height) + $cff96cc64f639998$var$_px;
                    override[$cff96cc64f639998$var$_margin] = override[$cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Top] = override[$cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Right] = override[$cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Bottom] = override[$cff96cc64f639998$var$_margin + $cff96cc64f639998$var$_Left] = "0";
                    override[$cff96cc64f639998$var$_padding] = cs[$cff96cc64f639998$var$_padding];
                    override[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Top] = cs[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Top];
                    override[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Right] = cs[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Right];
                    override[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Bottom] = cs[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Bottom];
                    override[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Left] = cs[$cff96cc64f639998$var$_padding + $cff96cc64f639998$var$_Left];
                    pinActiveState = $cff96cc64f639998$var$_copyState(pinOriginalState, override, pinReparent);
                    $cff96cc64f639998$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $cff96cc64f639998$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $cff96cc64f639998$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $cff96cc64f639998$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $cff96cc64f639998$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$cff96cc64f639998$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $cff96cc64f639998$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $cff96cc64f639998$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $cff96cc64f639998$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $cff96cc64f639998$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $cff96cc64f639998$var$gsap.getProperty(markerEndTrigger, direction.p);
                $cff96cc64f639998$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $cff96cc64f639998$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $cff96cc64f639998$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $cff96cc64f639998$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$cff96cc64f639998$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$cff96cc64f639998$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $cff96cc64f639998$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $cff96cc64f639998$var$_endAnimation(animation, animation.reversed()) : isToggle || $cff96cc64f639998$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $cff96cc64f639998$var$_triggers.indexOf(self), a = self.direction > 0 ? $cff96cc64f639998$var$_triggers.slice(0, i).reverse() : $cff96cc64f639998$var$_triggers.slice(i + 1);
            return ($cff96cc64f639998$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $cff96cc64f639998$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            anticipatePin && !clipped && pin && !$cff96cc64f639998$var$_refreshing && !$cff96cc64f639998$var$_startup && $cff96cc64f639998$var$_lastScrollTime && start < scroll + (scroll - scroll2) / ($cff96cc64f639998$var$_getTime() - $cff96cc64f639998$var$_time2) * anticipatePin && (clipped = 0.0001);
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$cff96cc64f639998$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($cff96cc64f639998$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$cff96cc64f639998$var$_refreshing && !$cff96cc64f639998$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($cff96cc64f639998$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($cff96cc64f639998$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $cff96cc64f639998$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $cff96cc64f639998$var$_getBounds(pin, true), _offset = scroll - start;
                                $cff96cc64f639998$var$_reparent(pin, $cff96cc64f639998$var$_body, bounds.top + (direction === (0, $7e9d8e753943228a$export$8e40fc98ff518e9d) ? _offset : 0) + $cff96cc64f639998$var$_px, bounds.left + (direction === (0, $7e9d8e753943228a$export$8e40fc98ff518e9d) ? 0 : _offset) + $cff96cc64f639998$var$_px);
                            } else $cff96cc64f639998$var$_reparent(pin, spacer);
                        }
                        $cff96cc64f639998$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$cff96cc64f639998$var$_refreshing && !$cff96cc64f639998$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$cff96cc64f639998$var$_limitCallbacks)) && $cff96cc64f639998$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$cff96cc64f639998$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$cff96cc64f639998$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $cff96cc64f639998$var$_callback(self, onToggle);
                        callbacks[toggleState] && $cff96cc64f639998$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $cff96cc64f639998$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($cff96cc64f639998$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $cff96cc64f639998$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $cff96cc64f639998$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$cff96cc64f639998$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $cff96cc64f639998$var$_addListener(scroller, "resize", $cff96cc64f639998$var$_onResize);
                isViewport || $cff96cc64f639998$var$_addListener(scroller, "scroll", $cff96cc64f639998$var$_onScroll);
                onRefreshInit && $cff96cc64f639998$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $cff96cc64f639998$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $cff96cc64f639998$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $cff96cc64f639998$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $cff96cc64f639998$var$_px;
                $cff96cc64f639998$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $cff96cc64f639998$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $cff96cc64f639998$var$_triggers.length;
                    while(i--){
                        if ($cff96cc64f639998$var$_triggers[i].scroller === scroller && $cff96cc64f639998$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $cff96cc64f639998$var$_removeListener(scroller, "resize", $cff96cc64f639998$var$_onResize);
                    isViewport || $cff96cc64f639998$var$_removeListener(scroller, "scroll", $cff96cc64f639998$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $cff96cc64f639998$var$_ids[id];
            var i = $cff96cc64f639998$var$_triggers.indexOf(self);
            i >= 0 && $cff96cc64f639998$var$_triggers.splice(i, 1);
            i === $cff96cc64f639998$var$_i && $cff96cc64f639998$var$_direction > 0 && $cff96cc64f639998$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $cff96cc64f639998$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $cff96cc64f639998$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $cff96cc64f639998$var$_primary === self && ($cff96cc64f639998$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $cff96cc64f639998$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $cff96cc64f639998$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $cff96cc64f639998$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $cff96cc64f639998$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$cff96cc64f639998$var$_coreInitted) {
            $cff96cc64f639998$var$gsap = core || $cff96cc64f639998$var$_getGSAP();
            $cff96cc64f639998$var$_windowExists() && window.document && ScrollTrigger.enable();
            $cff96cc64f639998$var$_coreInitted = $cff96cc64f639998$var$_enabled;
        }
        return $cff96cc64f639998$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$cff96cc64f639998$var$_defaults[p] = config[p];
        return $cff96cc64f639998$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $cff96cc64f639998$var$_enabled = 0;
        $cff96cc64f639998$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_win, "wheel", $cff96cc64f639998$var$_onScroll);
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_doc, "scroll", $cff96cc64f639998$var$_onScroll);
        clearInterval($cff96cc64f639998$var$_syncInterval);
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_doc, "touchcancel", $cff96cc64f639998$var$_passThrough);
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_body, "touchstart", $cff96cc64f639998$var$_passThrough);
        $cff96cc64f639998$var$_multiListener($cff96cc64f639998$var$_removeListener, $cff96cc64f639998$var$_doc, "pointerdown,touchstart,mousedown", $cff96cc64f639998$var$_pointerDownHandler);
        $cff96cc64f639998$var$_multiListener($cff96cc64f639998$var$_removeListener, $cff96cc64f639998$var$_doc, "pointerup,touchend,mouseup", $cff96cc64f639998$var$_pointerUpHandler);
        $cff96cc64f639998$var$_resizeDelay.kill();
        $cff96cc64f639998$var$_iterateAutoRefresh($cff96cc64f639998$var$_removeListener);
        for(var i = 0; i < (0, $7e9d8e753943228a$export$3cd1cee43d19b683).length; i += 3){
            $cff96cc64f639998$var$_wheelListener($cff96cc64f639998$var$_removeListener, (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i], (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i + 1]);
            $cff96cc64f639998$var$_wheelListener($cff96cc64f639998$var$_removeListener, (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i], (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $cff96cc64f639998$var$_win = window;
        $cff96cc64f639998$var$_doc = document;
        $cff96cc64f639998$var$_docEl = $cff96cc64f639998$var$_doc.documentElement;
        $cff96cc64f639998$var$_body = $cff96cc64f639998$var$_doc.body;
        if ($cff96cc64f639998$var$gsap) {
            $cff96cc64f639998$var$_toArray = $cff96cc64f639998$var$gsap.utils.toArray;
            $cff96cc64f639998$var$_clamp = $cff96cc64f639998$var$gsap.utils.clamp;
            $cff96cc64f639998$var$_context = $cff96cc64f639998$var$gsap.core.context || $cff96cc64f639998$var$_passThrough;
            $cff96cc64f639998$var$_suppressOverwrites = $cff96cc64f639998$var$gsap.core.suppressOverwrites || $cff96cc64f639998$var$_passThrough;
            $cff96cc64f639998$var$_scrollRestoration = $cff96cc64f639998$var$_win.history.scrollRestoration || "auto";
            $cff96cc64f639998$var$_lastScroll = $cff96cc64f639998$var$_win.pageYOffset;
            $cff96cc64f639998$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($cff96cc64f639998$var$_body) {
                $cff96cc64f639998$var$_enabled = 1;
                $cff96cc64f639998$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $cff96cc64f639998$var$_div100vh.style.height = "100vh";
                $cff96cc64f639998$var$_div100vh.style.position = "absolute";
                $cff96cc64f639998$var$_refresh100vh();
                $cff96cc64f639998$var$_rafBugFix();
                (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).register($cff96cc64f639998$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch;
                $cff96cc64f639998$var$_fixIOSBug = (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_win, "wheel", $cff96cc64f639998$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $cff96cc64f639998$var$_root = [
                    $cff96cc64f639998$var$_win,
                    $cff96cc64f639998$var$_doc,
                    $cff96cc64f639998$var$_docEl,
                    $cff96cc64f639998$var$_body
                ];
                if ($cff96cc64f639998$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $cff96cc64f639998$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $cff96cc64f639998$var$gsap.addEventListener("matchMediaInit", function() {
                        return $cff96cc64f639998$var$_revertAll();
                    });
                    $cff96cc64f639998$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $cff96cc64f639998$var$_revertRecorded();
                    });
                    $cff96cc64f639998$var$gsap.addEventListener("matchMedia", function() {
                        $cff96cc64f639998$var$_refreshAll(0, 1);
                        $cff96cc64f639998$var$_dispatch("matchMedia");
                    });
                    $cff96cc64f639998$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $cff96cc64f639998$var$_setBaseDimensions();
                        return $cff96cc64f639998$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $cff96cc64f639998$var$_setBaseDimensions();
                $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_doc, "scroll", $cff96cc64f639998$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $cff96cc64f639998$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $cff96cc64f639998$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $cff96cc64f639998$var$_getBounds($cff96cc64f639998$var$_body);
                (0, $7e9d8e753943228a$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $7e9d8e753943228a$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $cff96cc64f639998$var$_syncInterval = setInterval($cff96cc64f639998$var$_sync, 250);
                $cff96cc64f639998$var$gsap.delayedCall(0.5, function() {
                    return $cff96cc64f639998$var$_startup = 0;
                });
                $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_doc, "touchcancel", $cff96cc64f639998$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_body, "touchstart", $cff96cc64f639998$var$_passThrough); //works around Safari bug: https://greensock.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $cff96cc64f639998$var$_multiListener($cff96cc64f639998$var$_addListener, $cff96cc64f639998$var$_doc, "pointerdown,touchstart,mousedown", $cff96cc64f639998$var$_pointerDownHandler);
                $cff96cc64f639998$var$_multiListener($cff96cc64f639998$var$_addListener, $cff96cc64f639998$var$_doc, "pointerup,touchend,mouseup", $cff96cc64f639998$var$_pointerUpHandler);
                $cff96cc64f639998$var$_transformProp = $cff96cc64f639998$var$gsap.utils.checkPrefix("transform");
                $cff96cc64f639998$var$_stateProps.push($cff96cc64f639998$var$_transformProp);
                $cff96cc64f639998$var$_coreInitted = $cff96cc64f639998$var$_getTime();
                $cff96cc64f639998$var$_resizeDelay = $cff96cc64f639998$var$gsap.delayedCall(0.2, $cff96cc64f639998$var$_refreshAll).pause();
                $cff96cc64f639998$var$_autoRefresh = [
                    $cff96cc64f639998$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $cff96cc64f639998$var$_win.innerWidth, h = $cff96cc64f639998$var$_win.innerHeight;
                        if ($cff96cc64f639998$var$_doc.hidden) {
                            $cff96cc64f639998$var$_prevWidth = w;
                            $cff96cc64f639998$var$_prevHeight = h;
                        } else if ($cff96cc64f639998$var$_prevWidth !== w || $cff96cc64f639998$var$_prevHeight !== h) $cff96cc64f639998$var$_onResize();
                    },
                    $cff96cc64f639998$var$_doc,
                    "DOMContentLoaded",
                    $cff96cc64f639998$var$_refreshAll,
                    $cff96cc64f639998$var$_win,
                    "load",
                    $cff96cc64f639998$var$_refreshAll,
                    $cff96cc64f639998$var$_win,
                    "resize",
                    $cff96cc64f639998$var$_onResize
                ];
                $cff96cc64f639998$var$_iterateAutoRefresh($cff96cc64f639998$var$_addListener);
                $cff96cc64f639998$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $7e9d8e753943228a$export$3cd1cee43d19b683).length; i += 3){
                    $cff96cc64f639998$var$_wheelListener($cff96cc64f639998$var$_removeListener, (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i], (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i + 1]);
                    $cff96cc64f639998$var$_wheelListener($cff96cc64f639998$var$_removeListener, (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i], (0, $7e9d8e753943228a$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($cff96cc64f639998$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($cff96cc64f639998$var$_syncInterval) || ($cff96cc64f639998$var$_syncInterval = ms) && setInterval($cff96cc64f639998$var$_sync, ms);
        "ignoreMobileResize" in vars && ($cff96cc64f639998$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $cff96cc64f639998$var$_iterateAutoRefresh($cff96cc64f639998$var$_removeListener) || $cff96cc64f639998$var$_iterateAutoRefresh($cff96cc64f639998$var$_addListener, vars.autoRefreshEvents || "none");
            $cff96cc64f639998$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $7e9d8e753943228a$export$937374fea3f88711)(target), i = (0, $7e9d8e753943228a$export$3cd1cee43d19b683).indexOf(t), isViewport = $cff96cc64f639998$var$_isViewport(t);
        if (~i) (0, $7e9d8e753943228a$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $7e9d8e753943228a$export$d8e56d510a804d0a).unshift($cff96cc64f639998$var$_win, vars, $cff96cc64f639998$var$_body, vars, $cff96cc64f639998$var$_docEl, vars) : (0, $7e9d8e753943228a$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $cff96cc64f639998$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($cff96cc64f639998$var$_isString(element) ? (0, $7e9d8e753943228a$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $cff96cc64f639998$var$_width : $cff96cc64f639998$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $cff96cc64f639998$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $cff96cc64f639998$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $cff96cc64f639998$var$_isString(element) && (element = (0, $7e9d8e753943228a$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $cff96cc64f639998$var$_width : $cff96cc64f639998$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $cff96cc64f639998$var$_keywords ? $cff96cc64f639998$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $cff96cc64f639998$var$_win.innerWidth : (bounds.top + offset) / $cff96cc64f639998$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $cff96cc64f639998$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $cff96cc64f639998$var$_listeners.killAll || [];
            $cff96cc64f639998$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$cff96cc64f639998$export$875bcbe48555930.version = "3.12.2";
$cff96cc64f639998$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $cff96cc64f639998$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $cff96cc64f639998$var$_savedStyles.indexOf(target);
            i >= 0 && $cff96cc64f639998$var$_savedStyles.splice(i, 5);
            $cff96cc64f639998$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $cff96cc64f639998$var$gsap.core.getCache(target), $cff96cc64f639998$var$_context());
        }
    }) : $cff96cc64f639998$var$_savedStyles;
};
$cff96cc64f639998$export$875bcbe48555930.revert = function(soft, media) {
    return $cff96cc64f639998$var$_revertAll(!soft, media);
};
$cff96cc64f639998$export$875bcbe48555930.create = function(vars, animation) {
    return new $cff96cc64f639998$export$875bcbe48555930(vars, animation);
};
$cff96cc64f639998$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $cff96cc64f639998$var$_onResize() : ($cff96cc64f639998$var$_coreInitted || $cff96cc64f639998$export$875bcbe48555930.register()) && $cff96cc64f639998$var$_refreshAll(true);
};
$cff96cc64f639998$export$875bcbe48555930.update = function(force) {
    return ++(0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache && $cff96cc64f639998$var$_updateAll(force === true ? 2 : 0);
};
$cff96cc64f639998$export$875bcbe48555930.clearScrollMemory = $cff96cc64f639998$var$_clearScrollMemory;
$cff96cc64f639998$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $cff96cc64f639998$var$_maxScroll(element, horizontal ? (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1) : (0, $7e9d8e753943228a$export$8e40fc98ff518e9d));
};
$cff96cc64f639998$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $7e9d8e753943228a$export$8665aac53dad5647)((0, $7e9d8e753943228a$export$937374fea3f88711)(element), horizontal ? (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1) : (0, $7e9d8e753943228a$export$8e40fc98ff518e9d));
};
$cff96cc64f639998$export$875bcbe48555930.getById = function(id) {
    return $cff96cc64f639998$var$_ids[id];
};
$cff96cc64f639998$export$875bcbe48555930.getAll = function() {
    return $cff96cc64f639998$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$cff96cc64f639998$export$875bcbe48555930.isScrolling = function() {
    return !!$cff96cc64f639998$var$_lastScrollTime;
};
$cff96cc64f639998$export$875bcbe48555930.snapDirectional = $cff96cc64f639998$var$_snapDirectional;
$cff96cc64f639998$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $cff96cc64f639998$var$_listeners[type] || ($cff96cc64f639998$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$cff96cc64f639998$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $cff96cc64f639998$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$cff96cc64f639998$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $cff96cc64f639998$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $cff96cc64f639998$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($cff96cc64f639998$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $cff96cc64f639998$var$_addListener($cff96cc64f639998$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $cff96cc64f639998$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($cff96cc64f639998$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $cff96cc64f639998$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $cff96cc64f639998$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $cff96cc64f639998$var$_docEl && _allowNativePanning($cff96cc64f639998$var$_body, direction);
}, $cff96cc64f639998$var$_overflow = {
    auto: 1,
    scroll: 1
}, $cff96cc64f639998$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $cff96cc64f639998$var$gsap.core.getCache(node), time = $cff96cc64f639998$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $cff96cc64f639998$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($cff96cc64f639998$var$_overflow[(cs = $cff96cc64f639998$var$_getComputedStyle(node)).overflowY] || $cff96cc64f639998$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$cff96cc64f639998$var$_isViewport(node) && ($cff96cc64f639998$var$_overflow[(cs = $cff96cc64f639998$var$_getComputedStyle(node)).overflowY] || $cff96cc64f639998$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$cff96cc64f639998$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $cff96cc64f639998$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_doc, (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).eventTypes[0], $cff96cc64f639998$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_doc, (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).eventTypes[0], $cff96cc64f639998$var$_captureInputs, true);
        }
    });
}, $cff96cc64f639998$var$_inputExp = /(input|label|select|textarea)/i, $cff96cc64f639998$var$_inputIsFocused, $cff96cc64f639998$var$_captureInputs = function _captureInputs(e) {
    var isInput = $cff96cc64f639998$var$_inputExp.test(e.target.tagName);
    if (isInput || $cff96cc64f639998$var$_inputIsFocused) {
        e._gsapAllow = true;
        $cff96cc64f639998$var$_inputIsFocused = isInput;
    }
}, $cff96cc64f639998$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $cff96cc64f639998$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $7e9d8e753943228a$export$937374fea3f88711)(vars.target) || $cff96cc64f639998$var$_docEl, smoother = $cff96cc64f639998$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $cff96cc64f639998$var$_fixIOSBug && (vars.content && (0, $7e9d8e753943228a$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $7e9d8e753943228a$export$8665aac53dad5647)(target, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d)), scrollFuncX = (0, $7e9d8e753943228a$export$8665aac53dad5647)(target, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $7e9d8e753943228a$export$c1cbdee04e18ea8b).isTouch && $cff96cc64f639998$var$_win.visualViewport ? $cff96cc64f639998$var$_win.visualViewport.scale * $cff96cc64f639998$var$_win.visualViewport.width : $cff96cc64f639998$var$_win.outerWidth) / $cff96cc64f639998$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $cff96cc64f639998$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $cff96cc64f639998$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $cff96cc64f639998$var$_passThrough, scrollClampY = $cff96cc64f639998$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $cff96cc64f639998$var$_maxScroll(target, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d));
        scrollClampY = $cff96cc64f639998$var$_clamp($cff96cc64f639998$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $cff96cc64f639998$var$_clamp(0, $cff96cc64f639998$var$_maxScroll(target, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1))));
        lastRefreshID = $cff96cc64f639998$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $cff96cc64f639998$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $cff96cc64f639998$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $cff96cc64f639998$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache;
                $cff96cc64f639998$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $cff96cc64f639998$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $cff96cc64f639998$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $cff96cc64f639998$var$_round(($cff96cc64f639998$var$_win.visualViewport && $cff96cc64f639998$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $cff96cc64f639998$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $cff96cc64f639998$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $7e9d8e753943228a$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $cff96cc64f639998$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $cff96cc64f639998$var$_maxScroll(target, (0, $7e9d8e753943228a$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $cff96cc64f639998$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $cff96cc64f639998$var$_maxScroll(target, (0, $7e9d8e753943228a$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($cff96cc64f639998$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $cff96cc64f639998$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($cff96cc64f639998$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $cff96cc64f639998$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $cff96cc64f639998$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $cff96cc64f639998$var$_updateAll();
    };
    vars.onEnable = function() {
        $cff96cc64f639998$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $cff96cc64f639998$export$875bcbe48555930.addEventListener("refresh", onResize);
        $cff96cc64f639998$var$_addListener($cff96cc64f639998$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $cff96cc64f639998$var$_allowNativePanning(target, true);
        $cff96cc64f639998$var$_removeListener($cff96cc64f639998$var$_win, "resize", onResize);
        $cff96cc64f639998$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $cff96cc64f639998$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $cff96cc64f639998$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $cff96cc64f639998$var$_fixIOSBug && $cff96cc64f639998$var$gsap.ticker.add($cff96cc64f639998$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $cff96cc64f639998$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $cff96cc64f639998$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $cff96cc64f639998$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$cff96cc64f639998$export$875bcbe48555930.sort = function(func) {
    return $cff96cc64f639998$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$cff96cc64f639998$export$875bcbe48555930.observe = function(vars) {
    return new (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b)(vars);
};
$cff96cc64f639998$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $cff96cc64f639998$var$_normalizer;
    if (vars === true && $cff96cc64f639998$var$_normalizer) return $cff96cc64f639998$var$_normalizer.enable();
    if (vars === false) return $cff96cc64f639998$var$_normalizer && $cff96cc64f639998$var$_normalizer.kill();
    var normalizer = vars instanceof (0, $7e9d8e753943228a$export$c1cbdee04e18ea8b) ? vars : $cff96cc64f639998$var$_getScrollNormalizer(vars);
    $cff96cc64f639998$var$_normalizer && $cff96cc64f639998$var$_normalizer.target === normalizer.target && $cff96cc64f639998$var$_normalizer.kill();
    $cff96cc64f639998$var$_isViewport(normalizer.target) && ($cff96cc64f639998$var$_normalizer = normalizer);
    return normalizer;
};
$cff96cc64f639998$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $7e9d8e753943228a$export$5de019f4480f0f8d),
    _inputObserver: $cff96cc64f639998$var$_inputObserver,
    _scrollers: (0, $7e9d8e753943228a$export$3cd1cee43d19b683),
    _proxies: (0, $7e9d8e753943228a$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $cff96cc64f639998$var$_lastScrollTime || $cff96cc64f639998$var$_dispatch("scrollStart");
            $cff96cc64f639998$var$_lastScrollTime = $cff96cc64f639998$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $cff96cc64f639998$var$_refreshing;
        }
    }
};
$cff96cc64f639998$var$_getGSAP() && $cff96cc64f639998$var$gsap.registerPlugin($cff96cc64f639998$export$875bcbe48555930);


(0, $1974f63041948ee8$export$99ee26438460406a).registerPlugin((0, $cff96cc64f639998$export$875bcbe48555930));
function $8a7c66e0d6b59d89$export$2e2bcd8739ae039(debug = false) {
    document.querySelectorAll("[data-animation]").forEach((el)=>$8a7c66e0d6b59d89$var$startAnimation(el, debug));
}
function $8a7c66e0d6b59d89$var$startAnimation(element, debug = false) {
    const { animation: animation, animationDebug: animationDebug } = element.dataset ?? {};
    debug = Boolean(animationDebug) ?? debug;
    if (!animation) return;
    switch(animation){
        case "slide-left":
            $8a7c66e0d6b59d89$var$slideLeft(element, debug);
            break;
        case "path":
            $8a7c66e0d6b59d89$var$path(element, debug);
            break;
        default:
            console.warn(`Animation ${animation} not found`);
    }
}
function $8a7c66e0d6b59d89$var$slideLeft(element, debug = false) {
    (0, $1974f63041948ee8$export$99ee26438460406a).from(element, {
        scrollTrigger: {
            trigger: element,
            start: "top 80%",
            end: "bottom 80%",
            scrub: true,
            markers: debug
        },
        x: 100,
        opacity: 0
    });
}
function $8a7c66e0d6b59d89$var$path(element, debug = false) {
    const tl = (0, $1974f63041948ee8$export$99ee26438460406a).timeline({
        scrollTrigger: {
            trigger: element,
            start: "top center",
            scrub: true,
            markers: debug
        }
    });
    tl.fromTo(element, {
        clipPath: "inset(0px 0px 100% 0px)"
    }, {
        clipPath: "inset(0px 0px 0% 0px)",
        duration: 2
    });
}


var $ad98aa175baa05d0$exports = {};
!function(e, t) {
    var n, o;
    $ad98aa175baa05d0$exports = t();
}(window, function() {
    return function(e) {
        var t = {};
        function n(o) {
            if (t[o]) return t[o].exports;
            var i = t[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, o) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)n.d(o, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return o;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, i = "fslightbox-", r = "".concat(i, "styles"), s = "".concat(i, "cursor-grabbing"), a = "".concat(i, "full-dimension"), c = "".concat(i, "flex-centered"), l = "".concat(i, "open"), u = "".concat(i, "transform-transition"), d = "".concat(i, "absoluted"), f = "".concat(i, "slide-btn"), p = "".concat(f, "-container"), h = "".concat(i, "fade-in"), m = "".concat(i, "fade-out"), g = h + "-strong", v = m + "-strong", b = "".concat(i, "opacity-"), x = "".concat(b, "1"), y = "".concat(i, "source");
            function w(e) {
                return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function S(e) {
                var t = e.stageIndexes, n = e.core.stageManager, o = e.props.sources.length - 1;
                n.getPreviousSlideIndex = function() {
                    return 0 === t.current ? o : t.current - 1;
                }, n.getNextSlideIndex = function() {
                    return t.current === o ? 0 : t.current + 1;
                }, n.updateStageIndexes = 0 === o ? function() {} : 1 === o ? function() {
                    0 === t.current ? (t.next = 1, delete t.previous) : (t.previous = 0, delete t.next);
                } : function() {
                    t.previous = n.getPreviousSlideIndex(), t.next = n.getNextSlideIndex();
                }, n.i = o <= 2 ? function() {
                    return !0;
                } : function(e) {
                    var n = t.current;
                    if (0 === n && e === o || n === o && 0 === e) return !0;
                    var i = n - e;
                    return -1 === i || 0 === i || 1 === i;
                };
            }
            "object" === ("undefined" == typeof document ? "undefined" : w(document)) && ((o = document.createElement("style")).className = r, o.appendChild(document.createTextNode(".fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);touch-action:pinch-zoom;z-index:1000000000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#ddd}.fslightbox-nav{height:45px;width:100%;position:absolute;top:0;left:0}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slide-number-container .fslightbox-flex-centered{height:100%}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%)}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-container-previous{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px}}.fslightbox-slide-btn-container-next{right:0;padding-left:12px;padding-right:3px}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-container-next{padding-left:30px}}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-right:6px}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-invalid-file-wrapper{font-size:22px;color:#eaebeb;margin:auto}.fslightbox-video{object-fit:cover}.fslightbox-youtube-iframe{border:0}.fslightboxl{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightboxl div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightboxl 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightboxl div:nth-child(1){animation-delay:-.45s}.fslightboxl div:nth-child(2){animation-delay:-.3s}.fslightboxl div:nth-child(3){animation-delay:-.15s}@keyframes fslightboxl{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-source{position:relative;z-index:2;opacity:0}")), document.head.appendChild(o));
            function L(e) {
                var t, n = e.props, o = 0, i = {};
                this.getSourceTypeFromLocalStorageByUrl = function(e) {
                    return t[e] ? t[e] : r(e);
                }, this.handleReceivedSourceTypeForUrl = function(e, n) {
                    if (!1 === i[n] && (o--, "invalid" !== e ? i[n] = e : delete i[n], 0 === o)) {
                        !function(e, t) {
                            for(var n in t)e[n] = t[n];
                        }(t, i);
                        try {
                            localStorage.setItem("fslightbox-types", JSON.stringify(t));
                        } catch (e) {}
                    }
                };
                var r = function(e) {
                    o++, i[e] = !1;
                };
                if (n.disableLocalStorage) this.getSourceTypeFromLocalStorageByUrl = function() {}, this.handleReceivedSourceTypeForUrl = function() {};
                else {
                    try {
                        t = JSON.parse(localStorage.getItem("fslightbox-types"));
                    } catch (e) {}
                    t || (t = {}, this.getSourceTypeFromLocalStorageByUrl = r);
                }
            }
            function A(e, t, n, o) {
                var i = e.data, r = e.elements.sources, s = n / o, a = 0;
                this.adjustSize = function() {
                    if ((a = i.maxSourceWidth / s) < i.maxSourceHeight) return n < i.maxSourceWidth && (a = o), c();
                    a = o > i.maxSourceHeight ? i.maxSourceHeight : o, c();
                };
                var c = function() {
                    r[t].style.width = a * s + "px", r[t].style.height = a + "px";
                };
            }
            function C(e, t) {
                var n = this, o = e.collections.sourceSizers, i = e.elements, r = i.sourceAnimationWrappers, s = i.sources, a = e.isl, c = e.resolve;
                function l(e, n) {
                    o[t] = c(A, [
                        t,
                        e,
                        n
                    ]), o[t].adjustSize();
                }
                this.runActions = function(e, o) {
                    a[t] = !0, s[t].classList.add(x), r[t].classList.add(g), r[t].removeChild(r[t].firstChild), l(e, o), n.runActions = l;
                };
            }
            function E(e, t) {
                var n, o = this, i = e.elements.sources, r = e.props, s = (0, e.resolve)(C, [
                    t
                ]);
                this.handleImageLoad = function(e) {
                    var t = e.target, n = t.naturalWidth, o = t.naturalHeight;
                    s.runActions(n, o);
                }, this.handleVideoLoad = function(e) {
                    var t = e.target, o = t.videoWidth, i = t.videoHeight;
                    n = !0, s.runActions(o, i);
                }, this.handleNotMetaDatedVideoLoad = function() {
                    n || o.handleYoutubeLoad();
                }, this.handleYoutubeLoad = function() {
                    var e = 1920, t = 1080;
                    r.maxYoutubeDimensions && (e = r.maxYoutubeDimensions.width, t = r.maxYoutubeDimensions.height), s.runActions(e, t);
                }, this.handleCustomLoad = function() {
                    var e = i[t], n = e.offsetWidth, r = e.offsetHeight;
                    n && r ? s.runActions(n, r) : setTimeout(o.handleCustomLoad);
                };
            }
            function F(e, t, n) {
                var o = e.elements.sources, i = e.props.customClasses, r = i[t] ? i[t] : "";
                o[t].className = n + " " + r;
            }
            function I(e, t) {
                var n = e.elements.sources, o = e.props.customAttributes;
                for(var i in o[t])n[t].setAttribute(i, o[t][i]);
            }
            function T(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props.sources;
                i[t] = document.createElement("img"), F(e, t, y), i[t].src = s[t], i[t].onload = n[t].handleImageLoad, I(e, t), r[t].appendChild(i[t]);
            }
            function N(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props, a = s.sources, c = s.videosPosters;
                i[t] = document.createElement("video"), F(e, t, y), i[t].src = a[t], i[t].onloadedmetadata = function(e) {
                    n[t].handleVideoLoad(e);
                }, i[t].controls = !0, I(e, t), c[t] && (i[t].poster = c[t]);
                var l = document.createElement("source");
                l.src = a[t], i[t].appendChild(l), setTimeout(n[t].handleNotMetaDatedVideoLoad, 3e3), r[t].appendChild(i[t]);
            }
            function z(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, r = o.sources, s = o.sourceAnimationWrappers, a = e.props.sources;
                r[t] = document.createElement("iframe"), F(e, t, "".concat(y, " ").concat(i, "youtube-iframe"));
                var c = a[t], l = c.split("?")[1];
                r[t].src = "https://www.youtube.com/embed/".concat(c.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2], "?").concat(l || ""), r[t].allowFullscreen = !0, I(e, t), s[t].appendChild(r[t]), n[t].handleYoutubeLoad();
            }
            function P(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props.sources;
                i[t] = s[t], F(e, t, "".concat(i[t].className, " ").concat(y)), r[t].appendChild(i[t]), n[t].handleCustomLoad();
            }
            function k(e, t) {
                var n = e.elements, o = n.sources, r = n.sourceAnimationWrappers;
                e.props.sources;
                o[t] = document.createElement("div"), o[t].className = "".concat(i, "invalid-file-wrapper ").concat(c), o[t].innerHTML = "Invalid source", r[t].classList.add(g), r[t].removeChild(r[t].firstChild), r[t].appendChild(o[t]);
            }
            function H(e) {
                var t = e.collections, n = t.sourceLoadHandlers, o = t.sourcesRenderFunctions, i = e.core.sourceDisplayFacade, r = e.resolve;
                this.runActionsForSourceTypeAndIndex = function(t, s) {
                    var a;
                    switch("invalid" !== t && (n[s] = r(E, [
                        s
                    ])), t){
                        case "image":
                            a = T;
                            break;
                        case "video":
                            a = N;
                            break;
                        case "youtube":
                            a = z;
                            break;
                        case "custom":
                            a = P;
                            break;
                        default:
                            a = k;
                    }
                    o[s] = function() {
                        return a(e, s);
                    }, i.displaySourcesWhichShouldBeDisplayed();
                };
            }
            function W() {
                var e, t, n, o = {
                    isUrlYoutubeOne: function(e) {
                        var t = document.createElement("a");
                        return t.href = e, "www.youtube.com" === t.hostname || "youtu.be" === t.hostname;
                    },
                    getTypeFromResponseContentType: function(e) {
                        return e.slice(0, e.indexOf("/"));
                    }
                };
                function i() {
                    if (4 !== n.readyState) {
                        if (2 === n.readyState) {
                            var e;
                            switch(o.getTypeFromResponseContentType(n.getResponseHeader("content-type"))){
                                case "image":
                                    e = "image";
                                    break;
                                case "video":
                                    e = "video";
                                    break;
                                default:
                                    e = "invalid";
                            }
                            n.onreadystatechange = null, n.abort(), t(e);
                        }
                    } else t("invalid");
                }
                this.setUrlToCheck = function(t) {
                    e = t;
                }, this.getSourceType = function(r) {
                    if (o.isUrlYoutubeOne(e)) return r("youtube");
                    t = r, (n = new XMLHttpRequest).onreadystatechange = i, n.open("GET", e, !0), n.send();
                };
            }
            function R(e, t, n) {
                var o = e.props, i = o.types, r = o.type, s = o.sources, a = e.resolve;
                this.getTypeSetByClientForIndex = function(e) {
                    var t;
                    return i && i[e] ? t = i[e] : r && (t = r), t;
                }, this.retrieveTypeWithXhrForIndex = function(e) {
                    var o = a(W);
                    o.setUrlToCheck(s[e]), o.getSourceType(function(o) {
                        t.handleReceivedSourceTypeForUrl(o, s[e]), n.runActionsForSourceTypeAndIndex(o, e);
                    });
                };
            }
            function D(e, t) {
                var n = e.core.stageManager, o = e.elements, i = o.smw, r = o.sourceWrappersContainer, s = e.props, l = 0, f = document.createElement("div");
                function p(e) {
                    f.style.transform = "translateX(".concat(e + l, "px)"), l = 0;
                }
                function h() {
                    return (1 + s.slideDistance) * innerWidth;
                }
                f.className = "".concat(d, " ").concat(a, " ").concat(c), f.s = function() {
                    f.style.display = "flex";
                }, f.h = function() {
                    f.style.display = "none";
                }, f.a = function() {
                    f.classList.add(u);
                }, f.d = function() {
                    f.classList.remove(u);
                }, f.n = function() {
                    f.style.removeProperty("transform");
                }, f.v = function(e) {
                    return l = e, f;
                }, f.ne = function() {
                    p(-h());
                }, f.z = function() {
                    p(0);
                }, f.p = function() {
                    p(h());
                }, n.i(t) || f.h(), i[t] = f, r.appendChild(f), function(e, t) {
                    var n = e.elements, o = n.smw, i = n.sourceAnimationWrappers, r = document.createElement("div"), s = document.createElement("div");
                    s.className = "fslightboxl";
                    for(var a = 0; a < 3; a++){
                        var c = document.createElement("div");
                        s.appendChild(c);
                    }
                    r.appendChild(s), o[t].appendChild(r), i[t] = r;
                }(e, t);
            }
            function O(e, t, n, o) {
                var r = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                r.setAttributeNS(null, "width", t), r.setAttributeNS(null, "height", t), r.setAttributeNS(null, "viewBox", n);
                var s = document.createElementNS("http://www.w3.org/2000/svg", "path");
                return s.setAttributeNS(null, "class", "".concat(i, "svg-path")), s.setAttributeNS(null, "d", o), r.appendChild(s), e.appendChild(r), r;
            }
            function M(e, t) {
                var n = document.createElement("div");
                return n.className = "".concat(i, "toolbar-button ").concat(c), n.title = t, e.appendChild(n), n;
            }
            function j(e, t) {
                var n = document.createElement("div");
                n.className = "".concat(i, "toolbar"), t.appendChild(n), function(e, t) {
                    var n = e.componentsServices, o = e.data, i = e.fs, r = "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z", s = M(t);
                    s.title = "Enter fullscreen";
                    var a = O(s, "20px", "0 0 18 18", r);
                    n.ofs = function() {
                        o.ifs = !0, s.title = "Exit fullscreen", a.setAttributeNS(null, "width", "24px"), a.setAttributeNS(null, "height", "24px"), a.setAttributeNS(null, "viewBox", "0 0 950 1024"), a.firstChild.setAttributeNS(null, "d", "M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z");
                    }, n.xfs = function() {
                        o.ifs = !1, s.title = "Enter fullscreen", a.setAttributeNS(null, "width", "20px"), a.setAttributeNS(null, "height", "20px"), a.setAttributeNS(null, "viewBox", "0 0 18 18"), a.firstChild.setAttributeNS(null, "d", r);
                    }, s.onclick = i.t;
                }(e, n), function(e, t) {
                    var n = M(t, "Close");
                    n.onclick = e.core.lightboxCloser.closeLightbox, O(n, "20px", "0 0 24 24", "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z");
                }(e, n);
            }
            function X(e) {
                var t = e.props.sources, n = e.elements.container, o = document.createElement("div");
                o.className = "".concat(i, "nav"), n.appendChild(o), j(e, o), t.length > 1 && function(e, t) {
                    var n = e.componentsServices, o = e.props.sources, r = (e.stageIndexes, document.createElement("div"));
                    r.className = "".concat(i, "slide-number-container");
                    var s = document.createElement("div");
                    s.className = c;
                    var a = document.createElement("span");
                    n.setSlideNumber = function(e) {
                        return a.innerHTML = e;
                    };
                    var l = document.createElement("span");
                    l.className = "".concat(i, "slash");
                    var u = document.createElement("div");
                    u.innerHTML = o.length, r.appendChild(s), s.appendChild(a), s.appendChild(l), s.appendChild(u), t.appendChild(r), setTimeout(function() {
                        s.offsetWidth > 55 && (r.style.justifyContent = "flex-start");
                    });
                }(e, o);
            }
            function B(e, t, n, o) {
                var i = e.elements.container, r = n.charAt(0).toUpperCase() + n.slice(1), s = document.createElement("div");
                s.className = "".concat(p, " ").concat(p, "-").concat(n), s.title = "".concat(r, " slide"), s.onclick = t, function(e, t) {
                    var n = document.createElement("div");
                    n.className = "".concat(f, " ").concat(c), O(n, "20px", "0 0 20 20", t), e.appendChild(n);
                }(s, o), i.appendChild(s);
            }
            function U(e) {
                var t = e.core, n = t.lightboxCloser, o = t.slideChangeFacade, i = e.fs;
                this.listener = function(e) {
                    switch(e.key){
                        case "Escape":
                            n.closeLightbox();
                            break;
                        case "ArrowLeft":
                            o.changeToPrevious();
                            break;
                        case "ArrowRight":
                            o.changeToNext();
                            break;
                        case "F11":
                            e.preventDefault(), i.t();
                    }
                };
            }
            function q(e) {
                var t = e.elements, n = e.sourcePointerProps, o = e.stageIndexes;
                function i(e, o) {
                    t.smw[e].v(n.swipedX)[o]();
                }
                this.runActionsForEvent = function(e) {
                    var r, a, c;
                    t.container.contains(t.slideSwipingHoverer) || t.container.appendChild(t.slideSwipingHoverer), r = t.container, a = s, (c = r.classList).contains(a) || c.add(a), n.swipedX = e.screenX - n.downScreenX;
                    var l = o.previous, u = o.next;
                    i(o.current, "z"), void 0 !== l && n.swipedX > 0 ? i(l, "ne") : void 0 !== u && n.swipedX < 0 && i(u, "p");
                };
            }
            function V(e) {
                var t = e.props.sources, n = e.resolve, o = e.sourcePointerProps, i = n(q);
                1 === t.length ? this.listener = function() {
                    o.swipedX = 1;
                } : this.listener = function(e) {
                    o.isPointering && i.runActionsForEvent(e);
                };
            }
            function _(e) {
                var t = e.core.slideIndexChanger, n = e.elements.smw, o = e.stageIndexes, i = e.sws;
                function r(e) {
                    var t = n[o.current];
                    t.a(), t[e]();
                }
                function s(e, t) {
                    void 0 !== e && (n[e].s(), n[e][t]());
                }
                this.runPositiveSwipedXActions = function() {
                    var e = o.previous;
                    if (void 0 === e) r("z");
                    else {
                        r("p");
                        var n = o.next;
                        t.changeTo(e);
                        var a = o.previous;
                        i.d(a), i.b(n), r("z"), s(a, "ne");
                    }
                }, this.runNegativeSwipedXActions = function() {
                    var e = o.next;
                    if (void 0 === e) r("z");
                    else {
                        r("ne");
                        var n = o.previous;
                        t.changeTo(e);
                        var a = o.next;
                        i.d(a), i.b(n), r("z"), s(a, "p");
                    }
                };
            }
            function Y(e, t) {
                e.contains(t) && e.removeChild(t);
            }
            function J(e) {
                var t = e.core.lightboxCloser, n = e.elements, o = e.resolve, i = e.sourcePointerProps, r = o(_);
                this.runNoSwipeActions = function() {
                    Y(n.container, n.slideSwipingHoverer), i.isSourceDownEventTarget || t.closeLightbox(), i.isPointering = !1;
                }, this.runActions = function() {
                    i.swipedX > 0 ? r.runPositiveSwipedXActions() : r.runNegativeSwipedXActions(), Y(n.container, n.slideSwipingHoverer), n.container.classList.remove(s), i.isPointering = !1;
                };
            }
            function G(e) {
                var t = e.resolve, n = e.sourcePointerProps, o = t(J);
                this.listener = function() {
                    n.isPointering && (n.swipedX ? o.runActions() : o.runNoSwipeActions());
                };
            }
            function $(e) {
                var t = this, n = e.core, o = n.eventsDispatcher, i = n.globalEventsController, r = n.scrollbarRecompensor, s = e.data, a = e.elements, c = e.fs, u = e.props, d = e.sourcePointerProps;
                this.isLightboxFadingOut = !1, this.runActions = function() {
                    t.isLightboxFadingOut = !0, a.container.classList.add(v), i.removeListeners(), u.exitFullscreenOnClose && s.ifs && c.x(), setTimeout(function() {
                        t.isLightboxFadingOut = !1, d.isPointering = !1, a.container.classList.remove(v), document.documentElement.classList.remove(l), r.removeRecompense(), document.body.removeChild(a.container), o.dispatch("onClose");
                    }, 270);
                };
            }
            function K(e, t) {
                var n = e.classList;
                n.contains(t) && n.remove(t);
            }
            function Q(e) {
                var t, n, o;
                n = (t = e).core.eventsDispatcher, o = t.props, n.dispatch = function(e) {
                    o[e] && o[e]();
                }, function(e) {
                    var t = e.componentsServices, n = e.data, o = e.fs, i = [
                        "fullscreenchange",
                        "webkitfullscreenchange",
                        "mozfullscreenchange",
                        "MSFullscreenChange"
                    ];
                    function r(e) {
                        for(var t = 0; t < i.length; t++)document[e](i[t], s);
                    }
                    function s() {
                        document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement ? t.ofs() : t.xfs();
                    }
                    o.o = function() {
                        t.ofs();
                        var e = document.documentElement;
                        e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen && e.msRequestFullscreen();
                    }, o.x = function() {
                        t.xfs(), document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                    }, o.t = function() {
                        n.ifs ? o.x() : o.o();
                    }, o.l = function() {
                        r("addEventListener");
                    }, o.q = function() {
                        r("removeEventListener");
                    };
                }(e), function(e) {
                    var t = e.core, n = t.globalEventsController, o = t.windowResizeActioner, i = e.fs, r = e.resolve, s = r(U), a = r(V), c = r(G);
                    n.attachListeners = function() {
                        document.addEventListener("pointermove", a.listener), document.addEventListener("pointerup", c.listener), addEventListener("resize", o.runActions), document.addEventListener("keydown", s.listener), i.l();
                    }, n.removeListeners = function() {
                        document.removeEventListener("pointermove", a.listener), document.removeEventListener("pointerup", c.listener), removeEventListener("resize", o.runActions), document.removeEventListener("keydown", s.listener), i.q();
                    };
                }(e), function(e) {
                    var t = e.core.lightboxCloser, n = (0, e.resolve)($);
                    t.closeLightbox = function() {
                        n.isLightboxFadingOut || n.runActions();
                    };
                }(e), function(e) {
                    var t = e.data, n = e.core.scrollbarRecompensor;
                    function o() {
                        document.body.offsetHeight > innerHeight && (document.body.style.marginRight = t.scrollbarWidth + "px");
                    }
                    n.addRecompense = function() {
                        "complete" === document.readyState ? o() : addEventListener("load", function() {
                            o(), n.addRecompense = o;
                        });
                    }, n.removeRecompense = function() {
                        document.body.style.removeProperty("margin-right");
                    };
                }(e), function(e) {
                    var t = e.core, n = t.slideChangeFacade, o = t.slideIndexChanger, i = t.stageManager;
                    e.props.sources.length > 1 ? (n.changeToPrevious = function() {
                        o.jumpTo(i.getPreviousSlideIndex());
                    }, n.changeToNext = function() {
                        o.jumpTo(i.getNextSlideIndex());
                    }) : (n.changeToPrevious = function() {}, n.changeToNext = function() {});
                }(e), function(e) {
                    var t = e.componentsServices, n = e.core, o = n.slideIndexChanger, i = n.sourceDisplayFacade, r = n.stageManager, s = e.elements, a = s.smw, c = s.sourceAnimationWrappers, l = e.isl, u = e.stageIndexes, d = e.sws;
                    o.changeTo = function(e) {
                        u.current = e, r.updateStageIndexes(), t.setSlideNumber(e + 1), i.displaySourcesWhichShouldBeDisplayed();
                    }, o.jumpTo = function(e) {
                        var t = u.previous, n = u.current, i = u.next, s = l[n], f = l[e];
                        o.changeTo(e);
                        for(var p = 0; p < a.length; p++)a[p].d();
                        d.d(n), d.c(), requestAnimationFrame(function() {
                            requestAnimationFrame(function() {
                                var e = u.previous, o = u.next;
                                function p() {
                                    r.i(n) ? n === u.previous ? a[n].ne() : n === u.next && a[n].p() : (a[n].h(), a[n].n());
                                }
                                s && c[n].classList.add(m), f && c[u.current].classList.add(h), d.a(), void 0 !== e && e !== n && a[e].ne(), a[u.current].n(), void 0 !== o && o !== n && a[o].p(), d.b(t), d.b(i), l[n] ? setTimeout(p, 260) : p();
                            });
                        });
                    };
                }(e), function(e) {
                    var t = e.core.sourcesPointerDown, n = e.elements, o = n.smw, i = n.sources, r = e.sourcePointerProps, s = e.stageIndexes;
                    t.listener = function(e) {
                        "VIDEO" !== e.target.tagName && e.preventDefault(), r.isPointering = !0, r.downScreenX = e.screenX, r.swipedX = 0;
                        var t = i[s.current];
                        t && t.contains(e.target) ? r.isSourceDownEventTarget = !0 : r.isSourceDownEventTarget = !1;
                        for(var n = 0; n < o.length; n++)o[n].d();
                    };
                }(e), function(e) {
                    var t = e.collections.sourcesRenderFunctions, n = e.core.sourceDisplayFacade, o = e.props, i = e.stageIndexes;
                    function r(e) {
                        t[e] && (t[e](), delete t[e]);
                    }
                    n.displaySourcesWhichShouldBeDisplayed = function() {
                        if (o.loadOnlyCurrentSource) r(i.current);
                        else for(var e in i)r(i[e]);
                    };
                }(e), function(e) {
                    var t = e.core.stageManager, n = e.elements, o = n.smw, i = n.sourceAnimationWrappers, r = e.isl, s = e.stageIndexes, a = e.sws;
                    a.a = function() {
                        for(var e in s)o[s[e]].s();
                    }, a.b = function(e) {
                        void 0 === e || t.i(e) || (o[e].h(), o[e].n());
                    }, a.c = function() {
                        for(var e in s)a.d(s[e]);
                    }, a.d = function(e) {
                        if (r[e]) {
                            var t = i[e];
                            K(t, g), K(t, h), K(t, m);
                        }
                    };
                }(e), function(e) {
                    var t = e.collections.sourceSizers, n = e.core.windowResizeActioner, o = e.data, i = e.elements.smw, r = e.stageIndexes;
                    n.runActions = function() {
                        innerWidth < 992 ? o.maxSourceWidth = innerWidth : o.maxSourceWidth = .9 * innerWidth, o.maxSourceHeight = .9 * innerHeight;
                        for(var e = 0; e < i.length; e++)i[e].d(), t[e] && t[e].adjustSize();
                        var n = r.previous, s = r.next;
                        void 0 !== n && i[n].ne(), void 0 !== s && i[s].p();
                    };
                }(e);
            }
            function Z(e) {
                var t = e.componentsServices, n = e.core, o = n.eventsDispatcher, r = n.globalEventsController, s = n.scrollbarRecompensor, c = n.sourceDisplayFacade, u = n.stageManager, f = n.windowResizeActioner, p = e.data, h = e.elements, m = (e.props, e.stageIndexes), v = e.sws;
                function b() {
                    var t, n;
                    p.i = !0, p.scrollbarWidth = function() {
                        var e = document.createElement("div"), t = e.style, n = document.createElement("div");
                        t.visibility = "hidden", t.width = "100px", t.msOverflowStyle = "scrollbar", t.overflow = "scroll", n.style.width = "100%", document.body.appendChild(e);
                        var o = e.offsetWidth;
                        e.appendChild(n);
                        var i = n.offsetWidth;
                        return document.body.removeChild(e), o - i;
                    }(), Q(e), h.container = document.createElement("div"), h.container.className = "".concat(i, "container ").concat(a, " ").concat(g), function(e) {
                        var t = e.elements;
                        t.slideSwipingHoverer = document.createElement("div"), t.slideSwipingHoverer.className = "".concat(i, "slide-swiping-hoverer ").concat(a, " ").concat(d);
                    }(e), X(e), function(e) {
                        var t = e.core.sourcesPointerDown, n = e.elements, o = e.props.sources, i = document.createElement("div");
                        i.className = "".concat(d, " ").concat(a), n.container.appendChild(i), i.addEventListener("pointerdown", t.listener), n.sourceWrappersContainer = i;
                        for(var r = 0; r < o.length; r++)D(e, r);
                    }(e), e.props.sources.length > 1 && (n = (t = e).core.slideChangeFacade, B(t, n.changeToPrevious, "previous", "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z"), B(t, n.changeToNext, "next", "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z")), function(e) {
                        for(var t = e.props.sources, n = e.resolve, o = n(L), i = n(H), r = n(R, [
                            o,
                            i
                        ]), s = 0; s < t.length; s++)if ("string" == typeof t[s]) {
                            var a = r.getTypeSetByClientForIndex(s);
                            if (a) i.runActionsForSourceTypeAndIndex(a, s);
                            else {
                                var c = o.getSourceTypeFromLocalStorageByUrl(t[s]);
                                c ? i.runActionsForSourceTypeAndIndex(c, s) : r.retrieveTypeWithXhrForIndex(s);
                            }
                        } else i.runActionsForSourceTypeAndIndex("custom", s);
                    }(e), o.dispatch("onInit");
                }
                e.open = function() {
                    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = m.previous, a = m.current, d = m.next;
                    m.current = n, p.i || S(e), u.updateStageIndexes(), p.i ? (v.c(), v.a(), v.b(i), v.b(a), v.b(d), o.dispatch("onShow")) : b(), c.displaySourcesWhichShouldBeDisplayed(), t.setSlideNumber(n + 1), document.body.appendChild(h.container), document.documentElement.classList.add(l), s.addRecompense(), r.attachListeners(), f.runActions(), h.smw[m.current].n(), o.dispatch("onOpen");
                };
            }
            function ee(e, t, n) {
                return (ee = te() ? Reflect.construct.bind() : function(e, t, n) {
                    var o = [
                        null
                    ];
                    o.push.apply(o, t);
                    var i = new (Function.bind.apply(e, o));
                    return n && ne(i, n.prototype), i;
                }).apply(null, arguments);
            }
            function te() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }
            function ne(e, t) {
                return (ne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            function oe(e) {
                return function(e) {
                    if (Array.isArray(e)) return ie(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || function(e, t) {
                    if (!e) return;
                    if ("string" == typeof e) return ie(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === n && e.constructor && (n = e.constructor.name);
                    if ("Map" === n || "Set" === n) return Array.from(e);
                    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ie(e, t);
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function ie(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, o = new Array(t); n < t; n++)o[n] = e[n];
                return o;
            }
            function re() {
                for(var e = document.getElementsByTagName("a"), t = function(t) {
                    if (!e[t].hasAttribute("data-fslightbox")) return "continue";
                    var n = e[t].hasAttribute("data-href") ? e[t].getAttribute("data-href") : e[t].getAttribute("href");
                    if (!n) return console.warn('The "data-fslightbox" attribute was set without the "href" attribute.'), "continue";
                    var o = e[t].getAttribute("data-fslightbox");
                    fsLightboxInstances[o] || (fsLightboxInstances[o] = new FsLightbox);
                    var i = null;
                    "#" === n.charAt(0) ? (i = document.getElementById(n.substring(1)).cloneNode(!0)).removeAttribute("id") : i = n, fsLightboxInstances[o].props.sources.push(i), fsLightboxInstances[o].elements.a.push(e[t]);
                    var r = fsLightboxInstances[o].props.sources.length - 1;
                    e[t].onclick = function(e) {
                        e.preventDefault(), fsLightboxInstances[o].open(r);
                    }, d("types", "data-type"), d("videosPosters", "data-video-poster"), d("customClasses", "data-class"), d("customClasses", "data-custom-class");
                    for(var s = [
                        "href",
                        "data-fslightbox",
                        "data-href",
                        "data-type",
                        "data-video-poster",
                        "data-class",
                        "data-custom-class"
                    ], a = e[t].attributes, c = fsLightboxInstances[o].props.customAttributes, l = 0; l < a.length; l++)if (-1 === s.indexOf(a[l].name) && "data-" === a[l].name.substr(0, 5)) {
                        c[r] || (c[r] = {});
                        var u = a[l].name.substr(5);
                        c[r][u] = a[l].value;
                    }
                    function d(n, i) {
                        e[t].hasAttribute(i) && (fsLightboxInstances[o].props[n][r] = e[t].getAttribute(i));
                    }
                }, n = 0; n < e.length; n++)t(n);
                var o = Object.keys(fsLightboxInstances);
                window.fsLightbox = fsLightboxInstances[o[o.length - 1]];
            }
            window.FsLightbox = function() {
                var e = this;
                this.props = {
                    sources: [],
                    customAttributes: [],
                    customClasses: [],
                    types: [],
                    videosPosters: [],
                    slideDistance: .3
                }, this.data = {
                    isFullscreenOpen: !1,
                    maxSourceWidth: 0,
                    maxSourceHeight: 0,
                    scrollbarWidth: 0
                }, this.isl = [], this.sourcePointerProps = {
                    downScreenX: null,
                    isPointering: !1,
                    isSourceDownEventTarget: !1,
                    swipedX: 0
                }, this.stageIndexes = {}, this.elements = {
                    a: [],
                    container: null,
                    slideSwipingHoverer: null,
                    smw: [],
                    sourceWrappersContainer: null,
                    sources: [],
                    sourceAnimationWrappers: []
                }, this.componentsServices = {
                    setSlideNumber: function() {}
                }, this.resolve = function(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    return n.unshift(e), ee(t, oe(n));
                }, this.collections = {
                    sourceLoadHandlers: [],
                    sourcesRenderFunctions: [],
                    sourceSizers: []
                }, this.core = {
                    eventsDispatcher: {},
                    globalEventsController: {},
                    lightboxCloser: {},
                    lightboxUpdater: {},
                    scrollbarRecompensor: {},
                    slideChangeFacade: {},
                    slideIndexChanger: {},
                    sourcesPointerDown: {},
                    sourceDisplayFacade: {},
                    stageManager: {},
                    windowResizeActioner: {}
                }, this.fs = {}, this.sws = {}, Z(this), this.close = function() {
                    return e.core.lightboxCloser.closeLightbox();
                };
            }, window.fsLightboxInstances = {}, re(), window.refreshFsLightbox = function() {
                for(var e in fsLightboxInstances){
                    var t = fsLightboxInstances[e].props;
                    fsLightboxInstances[e] = new FsLightbox, fsLightboxInstances[e].props = t, fsLightboxInstances[e].props.sources = [], fsLightboxInstances[e].elements.a = [];
                }
                re();
            };
        }
    ]);
});


(0, $bc9f108a1f5a5010$export$2e2bcd8739ae039)();
(0, $465ea4fae4599252$export$2e2bcd8739ae039)();
(0, $71f7029a2b886464$export$2e2bcd8739ae039)();
(0, $71f7029a2b886464$export$fa6cf3b4dcaf1b1c)();
(0, $8a7c66e0d6b59d89$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=main.js.map
